const hamburgNetwork = {
    "linesOfNetwork": [
        {
            "id": "d38ec6a4-5593-4d1f-af91-780150f468d3",
            "name": "1220-Hamburg-Kiel_all",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "railwayEdgeIds": "65d0a8d5-925c-4264-9d14-04db1be3cc07;c7faa86c-f2f0-4fab-a4cb-0593302b1a7f;30cf2a81-334f-4924-80a8-0611a8644dcb;a0ae3313-2df7-4ef5-b9ad-06ad8dc01cb6;ea92adb9-ff0d-4bb9-a337-0c28e12fbc85;357bb902-2fc7-410a-a500-106521f4d98e;c246260c-280b-4f42-9103-13099fdc9ac3;bb481aaf-e568-4944-b141-1574895b3f5a;574867c6-e2ba-420b-b45f-15fe8fddf6c3;d983fa0c-0b6e-4d1e-8b7a-17f4a4348bea;b26ad56a-8575-43a1-bba3-1d138ee6ff2c;5e98aa54-2b2e-45fb-8302-1f28e2bd8c65;54a440ba-6cd4-4c41-b10b-278ac044c46e;d4b0416a-0368-4440-9b1d-2d5af6bb9028;569703f2-82e3-4cf1-8066-2e1844773a28;07d522ee-a53f-4c02-bfde-309efe21e5b5;8a177ecf-1ef4-47c2-bdd3-362290f9ba3b;f4bdd39c-58e2-45da-a12e-37893fc260cf;54ba477c-045a-4da6-8aa2-37e7812365e6;87fdb318-b4cb-49ab-b1d6-4544cdb87c75;7dd80fbb-e897-402f-9f15-4d9aff084ccb;9b0e6197-022f-4ae4-84a7-4eecf23d693f;921ab941-ec16-4bcc-b3af-51bad7e80e1c;70a2bb61-cf4e-476b-8db2-51f6a428e0ba;476a3700-a98f-44fa-b557-5e3fe68dcc78;deba2f3e-0ad6-4738-b61a-6a79dee9e199;4b37b5ef-9503-4ad7-b8ed-6e2c1bcb2579;52411956-223c-4c11-a645-6e829ffeab50;94ab70d6-8c95-452a-ba9b-70dac21b7969;13e0275f-6d6f-45b7-b6a2-7247959aaa3e;57741d2b-9e8c-480c-98bc-7bae4ca2700a;e83a8d8e-2329-42ce-95fe-7da691099249;102e706f-81d5-4a49-8b81-7f4d6f98c122;6aefdd2c-a48a-445c-958d-80328920e713;56c4edb2-e3c0-4324-8109-82a1b27a5cbd;e6008ce4-e16a-49b3-8c40-85d0c8e7bc2c;386b3615-6a2d-4db8-8a52-8634356921a0;40936f37-6ae2-4f53-8a56-86f5323d084d;8b1bb2d7-413a-4ddc-a982-8aa38d0012f2;81d309ee-ca5e-41a6-a5d8-9144102c7563;b3596c69-f6f8-4f83-8f51-93278c3968d0;c874d1cd-3a87-4f46-92ec-964153f00504;b110e6bf-9f95-4d4f-bef0-98339e1dab23;fe8dbbff-b5f9-4527-b44e-98f96d0af29b;da632810-acde-44d4-bbec-999b8106ee11;4cec9a4d-3083-4759-924f-99b7ca38048e;7df8a71a-8b62-414f-a15a-9abbb2f0ce19;4c218b0e-1e8c-435f-9a90-9bcfed66d911;fa340628-200a-4ddb-8781-9e9548a63bfb;4a5dcef1-068e-404e-8993-a1725c9661d6;003c2b96-62a8-4a95-9c41-a5716547293f;c2c4b531-f75f-4941-8e00-ab8226c57707;3dacd4b6-b660-45bc-90a2-b0cd6b440efc;67aca7fc-7b36-4a67-a88f-b7ef07e0d4b8;12b5c4e3-4ae9-4e8d-bb9b-b946a8242a9a;7df76260-086b-4702-9dbd-bb7ebaf792ef;c09aa8d1-750c-4846-8b65-bd15765ca1c9;38f5ff9e-2907-4174-a163-bf3d1f35dad9;6482cdb0-afad-47ba-b028-c0292d6c1bef;496b6270-3554-4e14-b878-c4f4f80abd8a;1c4b3255-869d-4b9a-974b-c56c754d98c8;79ebc9e3-5392-4be1-8519-c64528908743;da27c160-8d39-41be-91d7-cbc5b61c3108;afc28dbb-d7b8-4086-be1f-cc696f7128cd;96bcb5e0-50d4-4562-97e2-cee9acbaa229;9bd6a648-632e-4c62-b448-d0043eb13eb9;b13b3e40-813a-4073-8568-d1f1504d7436;8d709c30-7b1d-4d3b-870a-d489c7b9c896;e0df3ceb-3ff4-4fa7-8198-de6fdb058d66;e4505616-ff15-4a7d-a8f8-de7bd40e271f;905efa5f-22b1-4272-9d28-dfcc62e790d1;b7b12798-2f58-45d7-8805-e217a3fc76b4;6da0a1d7-8b78-41a7-9a23-e2325bc25fc7;781b6fe5-3bb2-499b-8757-e54116d8a6a2;a8be4a7b-4d68-4fec-82f2-e930eb148b4a;94209ba0-31f9-4183-824a-ecb9aa7d978d;9cc46267-dc70-4397-810d-eccf3ea8ea77;a0e8c1d7-7cf8-4fd7-a6df-f4c9b27973b5;96f01ef1-3f8d-4dfc-a340-f7c49e1d46cc;842a8fb0-d4d8-4ce4-b6eb-fbd9a88bf9b1;30cb4516-2722-4894-bd6a-fdcf6ea43604"
        }
    ],
    "edgesOfNetwork": [
        {
            "railwayEdgeId": "65d0a8d5-925c-4264-9d14-04db1be3cc07",
            "railwayEdgeName": "E27",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 25739.852003500237,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0963115,
                        54.2800263
                    ],
                    [
                        10.0959584,
                        54.2797346
                    ],
                    [
                        10.0958077,
                        54.2796038
                    ],
                    [
                        10.0956507,
                        54.2794618
                    ],
                    [
                        10.0954306,
                        54.2792572
                    ],
                    [
                        10.0952251,
                        54.2790519
                    ],
                    [
                        10.0950269,
                        54.2788373
                    ],
                    [
                        10.0948187,
                        54.2785959
                    ],
                    [
                        10.0945493,
                        54.2782467
                    ],
                    [
                        10.0943124,
                        54.2779132
                    ],
                    [
                        10.0941682,
                        54.2776935
                    ],
                    [
                        10.0940441,
                        54.2774905
                    ],
                    [
                        10.0939749,
                        54.2773737
                    ],
                    [
                        10.093816,
                        54.2770873
                    ],
                    [
                        10.0936742,
                        54.276801
                    ],
                    [
                        10.0934524,
                        54.2762762
                    ],
                    [
                        10.0932592,
                        54.275742
                    ],
                    [
                        10.0927938,
                        54.2742379
                    ],
                    [
                        10.0926772,
                        54.2738704
                    ],
                    [
                        10.0925798,
                        54.2735716
                    ],
                    [
                        10.0924533,
                        54.2732254
                    ],
                    [
                        10.092371,
                        54.273015
                    ],
                    [
                        10.0922827,
                        54.2728081
                    ],
                    [
                        10.0921838,
                        54.2725914
                    ],
                    [
                        10.0920803,
                        54.2723842
                    ],
                    [
                        10.0919645,
                        54.2721677
                    ],
                    [
                        10.0918398,
                        54.2719518
                    ],
                    [
                        10.0917368,
                        54.271782
                    ],
                    [
                        10.0916241,
                        54.2716055
                    ],
                    [
                        10.0913024,
                        54.2711252
                    ],
                    [
                        10.0902437,
                        54.2696255
                    ],
                    [
                        10.0891174,
                        54.2680359
                    ],
                    [
                        10.0888921,
                        54.2677249
                    ],
                    [
                        10.0886587,
                        54.2674185
                    ],
                    [
                        10.0885022,
                        54.2672216
                    ],
                    [
                        10.088336,
                        54.2670227
                    ],
                    [
                        10.0882172,
                        54.266886
                    ],
                    [
                        10.0880413,
                        54.2666921
                    ],
                    [
                        10.0877701,
                        54.2664148
                    ],
                    [
                        10.0875813,
                        54.2662351
                    ],
                    [
                        10.0874519,
                        54.2661193
                    ],
                    [
                        10.0871834,
                        54.2658895
                    ],
                    [
                        10.0869051,
                        54.2656668
                    ],
                    [
                        10.0866957,
                        54.2655085
                    ],
                    [
                        10.0864757,
                        54.2653515
                    ],
                    [
                        10.0862596,
                        54.2652036
                    ],
                    [
                        10.0860448,
                        54.2650637
                    ],
                    [
                        10.0856391,
                        54.2648168
                    ],
                    [
                        10.0854219,
                        54.264692
                    ],
                    [
                        10.0851315,
                        54.2645347
                    ],
                    [
                        10.0847841,
                        54.2643558
                    ],
                    [
                        10.0843387,
                        54.2641443
                    ],
                    [
                        10.0840652,
                        54.2640227
                    ],
                    [
                        10.0836373,
                        54.2638448
                    ],
                    [
                        10.0833432,
                        54.2637281
                    ],
                    [
                        10.0828841,
                        54.2635547
                    ],
                    [
                        10.0824315,
                        54.2633902
                    ],
                    [
                        10.0812178,
                        54.2629615
                    ],
                    [
                        10.0807665,
                        54.2627981
                    ],
                    [
                        10.0803636,
                        54.2626501
                    ],
                    [
                        10.0799304,
                        54.2624821
                    ],
                    [
                        10.0795046,
                        54.2623089
                    ],
                    [
                        10.079133,
                        54.2621488
                    ],
                    [
                        10.0787778,
                        54.2619871
                    ],
                    [
                        10.0784509,
                        54.2618295
                    ],
                    [
                        10.0781453,
                        54.2616752
                    ],
                    [
                        10.0776566,
                        54.2614112
                    ],
                    [
                        10.0772052,
                        54.2611482
                    ],
                    [
                        10.0767646,
                        54.2608743
                    ],
                    [
                        10.0764005,
                        54.2606261
                    ],
                    [
                        10.0761353,
                        54.2604391
                    ],
                    [
                        10.0759066,
                        54.2602673
                    ],
                    [
                        10.0756847,
                        54.2600926
                    ],
                    [
                        10.075275,
                        54.2597493
                    ],
                    [
                        10.0750178,
                        54.2595163
                    ],
                    [
                        10.0746702,
                        54.2591779
                    ],
                    [
                        10.0744895,
                        54.2589905
                    ],
                    [
                        10.0743211,
                        54.2588047
                    ],
                    [
                        10.0740193,
                        54.2584456
                    ],
                    [
                        10.073731,
                        54.2580729
                    ],
                    [
                        10.0735348,
                        54.257801
                    ],
                    [
                        10.0733806,
                        54.2575836
                    ],
                    [
                        10.0731819,
                        54.2572904
                    ],
                    [
                        10.0728192,
                        54.2567505
                    ],
                    [
                        10.0699277,
                        54.252445
                    ],
                    [
                        10.0682233,
                        54.2499035
                    ],
                    [
                        10.0669578,
                        54.2480195
                    ],
                    [
                        10.0666198,
                        54.2475385
                    ],
                    [
                        10.0664238,
                        54.2472706
                    ],
                    [
                        10.0662813,
                        54.2470818
                    ],
                    [
                        10.065907,
                        54.2466205
                    ],
                    [
                        10.0656581,
                        54.2463352
                    ],
                    [
                        10.0653444,
                        54.2459895
                    ],
                    [
                        10.0646262,
                        54.2452268
                    ],
                    [
                        10.0632287,
                        54.2437451
                    ],
                    [
                        10.0631185,
                        54.2436267
                    ],
                    [
                        10.0627265,
                        54.2432046
                    ],
                    [
                        10.0607031,
                        54.2410699
                    ],
                    [
                        10.0605433,
                        54.2409016
                    ],
                    [
                        10.060439,
                        54.2407894
                    ],
                    [
                        10.0586338,
                        54.2388786
                    ],
                    [
                        10.0580429,
                        54.2382757
                    ],
                    [
                        10.057752,
                        54.2380008
                    ],
                    [
                        10.0571268,
                        54.2374615
                    ],
                    [
                        10.0565046,
                        54.2369831
                    ],
                    [
                        10.055796,
                        54.23649
                    ],
                    [
                        10.0554278,
                        54.23626
                    ],
                    [
                        10.055031,
                        54.2360196
                    ],
                    [
                        10.0543807,
                        54.2356502
                    ],
                    [
                        10.0537171,
                        54.2353068
                    ],
                    [
                        10.0530403,
                        54.2349648
                    ],
                    [
                        10.0515131,
                        54.2342098
                    ],
                    [
                        10.0500244,
                        54.2334725
                    ],
                    [
                        10.0493247,
                        54.2331385
                    ],
                    [
                        10.0485833,
                        54.2327566
                    ],
                    [
                        10.0477984,
                        54.2323681
                    ],
                    [
                        10.0466843,
                        54.2318149
                    ],
                    [
                        10.045571,
                        54.2312554
                    ],
                    [
                        10.0448913,
                        54.2308863
                    ],
                    [
                        10.0445407,
                        54.230682
                    ],
                    [
                        10.0442259,
                        54.23049
                    ],
                    [
                        10.0438573,
                        54.230249
                    ],
                    [
                        10.0435962,
                        54.2300573
                    ],
                    [
                        10.0432774,
                        54.229829
                    ],
                    [
                        10.0429961,
                        54.2296038
                    ],
                    [
                        10.0424625,
                        54.2291674
                    ],
                    [
                        10.0419689,
                        54.2286862
                    ],
                    [
                        10.0415132,
                        54.2281957
                    ],
                    [
                        10.0412992,
                        54.2279452
                    ],
                    [
                        10.0411107,
                        54.2277046
                    ],
                    [
                        10.0407564,
                        54.2272032
                    ],
                    [
                        10.0405015,
                        54.2267958
                    ],
                    [
                        10.040249,
                        54.2263143
                    ],
                    [
                        10.0401208,
                        54.2260214
                    ],
                    [
                        10.0399072,
                        54.2254855
                    ],
                    [
                        10.0397363,
                        54.2248337
                    ],
                    [
                        10.0396197,
                        54.2241683
                    ],
                    [
                        10.0395964,
                        54.2233734
                    ],
                    [
                        10.0396729,
                        54.2226238
                    ],
                    [
                        10.0403466,
                        54.2193306
                    ],
                    [
                        10.0409172,
                        54.2167824
                    ],
                    [
                        10.0412475,
                        54.2151555
                    ],
                    [
                        10.0413957,
                        54.214309
                    ],
                    [
                        10.0414691,
                        54.2136118
                    ],
                    [
                        10.0414716,
                        54.2134857
                    ],
                    [
                        10.0413718,
                        54.2117386
                    ],
                    [
                        10.0411787,
                        54.2092289
                    ],
                    [
                        10.0411353,
                        54.2088124
                    ],
                    [
                        10.0411663,
                        54.2082543
                    ],
                    [
                        10.0412428,
                        54.2077262
                    ],
                    [
                        10.0413813,
                        54.2071198
                    ],
                    [
                        10.0415055,
                        54.2067258
                    ],
                    [
                        10.041711,
                        54.2062648
                    ],
                    [
                        10.0421458,
                        54.2054795
                    ],
                    [
                        10.0426283,
                        54.2047698
                    ],
                    [
                        10.0432503,
                        54.2040488
                    ],
                    [
                        10.0438828,
                        54.2034526
                    ],
                    [
                        10.0441342,
                        54.203217
                    ],
                    [
                        10.0485971,
                        54.1991909
                    ],
                    [
                        10.0494574,
                        54.1984048
                    ],
                    [
                        10.0502211,
                        54.1976586
                    ],
                    [
                        10.0506741,
                        54.1971671
                    ],
                    [
                        10.0509966,
                        54.1967831
                    ],
                    [
                        10.0516548,
                        54.195933
                    ],
                    [
                        10.0522277,
                        54.1950508
                    ],
                    [
                        10.0524756,
                        54.1946271
                    ],
                    [
                        10.0526952,
                        54.1942048
                    ],
                    [
                        10.0529007,
                        54.1937599
                    ],
                    [
                        10.0529974,
                        54.193545
                    ],
                    [
                        10.0530893,
                        54.1933159
                    ],
                    [
                        10.053237,
                        54.1929184
                    ],
                    [
                        10.0533346,
                        54.1926296
                    ],
                    [
                        10.0537351,
                        54.1913741
                    ],
                    [
                        10.0539627,
                        54.1906598
                    ],
                    [
                        10.0540943,
                        54.1902256
                    ],
                    [
                        10.0542208,
                        54.1897611
                    ],
                    [
                        10.054289,
                        54.1894531
                    ],
                    [
                        10.054353,
                        54.1891294
                    ],
                    [
                        10.0544157,
                        54.1887303
                    ],
                    [
                        10.0544592,
                        54.1883321
                    ],
                    [
                        10.0544861,
                        54.1879856
                    ],
                    [
                        10.0544967,
                        54.187644
                    ],
                    [
                        10.0544967,
                        54.1872566
                    ],
                    [
                        10.0544829,
                        54.1868696
                    ],
                    [
                        10.0544147,
                        54.1862271
                    ],
                    [
                        10.0543714,
                        54.1859091
                    ],
                    [
                        10.0543133,
                        54.1855949
                    ],
                    [
                        10.0542047,
                        54.1851254
                    ],
                    [
                        10.0540743,
                        54.184665
                    ],
                    [
                        10.053933,
                        54.1842315
                    ],
                    [
                        10.0537533,
                        54.1837609
                    ],
                    [
                        10.0536237,
                        54.1834562
                    ],
                    [
                        10.0534839,
                        54.1831517
                    ],
                    [
                        10.0534028,
                        54.1829847
                    ],
                    [
                        10.0532636,
                        54.18271
                    ],
                    [
                        10.0531131,
                        54.1824347
                    ],
                    [
                        10.052904,
                        54.18208
                    ],
                    [
                        10.0524737,
                        54.1814171
                    ],
                    [
                        10.0522268,
                        54.1810684
                    ],
                    [
                        10.0519641,
                        54.1807234
                    ],
                    [
                        10.0516764,
                        54.1803643
                    ],
                    [
                        10.0513688,
                        54.1800072
                    ],
                    [
                        10.0509087,
                        54.1795107
                    ],
                    [
                        10.0505881,
                        54.1791834
                    ],
                    [
                        10.0501071,
                        54.178723
                    ],
                    [
                        10.0496006,
                        54.1782726
                    ],
                    [
                        10.0490895,
                        54.1778423
                    ],
                    [
                        10.0485505,
                        54.1774239
                    ],
                    [
                        10.0481811,
                        54.1771523
                    ],
                    [
                        10.0478067,
                        54.1768847
                    ],
                    [
                        10.0470937,
                        54.1764091
                    ],
                    [
                        10.046199,
                        54.1758567
                    ],
                    [
                        10.0450188,
                        54.1751564
                    ],
                    [
                        10.0436794,
                        54.1743542
                    ],
                    [
                        10.0433292,
                        54.1741366
                    ],
                    [
                        10.0425767,
                        54.1736871
                    ],
                    [
                        10.0416748,
                        54.1731498
                    ],
                    [
                        10.0415457,
                        54.1730738
                    ],
                    [
                        10.0411837,
                        54.1728576
                    ],
                    [
                        10.0411539,
                        54.1728399
                    ],
                    [
                        10.0368059,
                        54.1702491
                    ],
                    [
                        10.0366844,
                        54.1701756
                    ],
                    [
                        10.0357146,
                        54.1695976
                    ],
                    [
                        10.0348469,
                        54.1690811
                    ],
                    [
                        10.0342004,
                        54.1686511
                    ],
                    [
                        10.0338193,
                        54.1683933
                    ],
                    [
                        10.033562,
                        54.1682117
                    ],
                    [
                        10.0330424,
                        54.1678366
                    ],
                    [
                        10.0326708,
                        54.1675568
                    ],
                    [
                        10.0322357,
                        54.167181
                    ],
                    [
                        10.0320937,
                        54.1670573
                    ],
                    [
                        10.0316467,
                        54.1666607
                    ],
                    [
                        10.031117,
                        54.1661527
                    ],
                    [
                        10.030639,
                        54.1656745
                    ],
                    [
                        10.0303546,
                        54.1653557
                    ],
                    [
                        10.0300981,
                        54.1650537
                    ],
                    [
                        10.0299093,
                        54.1648294
                    ],
                    [
                        10.0296154,
                        54.1644561
                    ],
                    [
                        10.0290673,
                        54.1637628
                    ],
                    [
                        10.0280191,
                        54.1622417
                    ],
                    [
                        10.0242217,
                        54.1568249
                    ],
                    [
                        10.0235604,
                        54.1558879
                    ],
                    [
                        10.0204267,
                        54.1514047
                    ],
                    [
                        10.0167154,
                        54.1460954
                    ],
                    [
                        10.016648,
                        54.1459996
                    ],
                    [
                        10.0145378,
                        54.1429905
                    ],
                    [
                        10.0141645,
                        54.1424619
                    ],
                    [
                        10.0136864,
                        54.1417926
                    ],
                    [
                        10.0130642,
                        54.1409571
                    ],
                    [
                        10.0124422,
                        54.1402198
                    ],
                    [
                        10.0120783,
                        54.1398251
                    ],
                    [
                        10.0118011,
                        54.1395427
                    ],
                    [
                        10.0117328,
                        54.1394758
                    ],
                    [
                        10.0112332,
                        54.1389978
                    ],
                    [
                        10.0107089,
                        54.1385378
                    ],
                    [
                        10.0099364,
                        54.1379131
                    ],
                    [
                        10.0091312,
                        54.1373226
                    ],
                    [
                        10.0088166,
                        54.1371047
                    ],
                    [
                        10.0083642,
                        54.1368114
                    ],
                    [
                        10.0068874,
                        54.1358925
                    ],
                    [
                        10.0041581,
                        54.134212
                    ],
                    [
                        10.0030956,
                        54.1335533
                    ],
                    [
                        10.0019263,
                        54.1328298
                    ],
                    [
                        10.0011034,
                        54.1322575
                    ],
                    [
                        10.0003439,
                        54.1316754
                    ],
                    [
                        9.9998477,
                        54.1312642
                    ],
                    [
                        9.9993732,
                        54.1308442
                    ],
                    [
                        9.9988498,
                        54.1303523
                    ],
                    [
                        9.9981571,
                        54.1296421
                    ],
                    [
                        9.9980085,
                        54.129469
                    ],
                    [
                        9.9978851,
                        54.1293343
                    ],
                    [
                        9.9975322,
                        54.128917
                    ],
                    [
                        9.997488,
                        54.1288624
                    ],
                    [
                        9.9971991,
                        54.1284899
                    ],
                    [
                        9.9969102,
                        54.12809
                    ],
                    [
                        9.9965934,
                        54.1276082
                    ],
                    [
                        9.9964655,
                        54.1273977
                    ],
                    [
                        9.9962169,
                        54.126962
                    ],
                    [
                        9.9960137,
                        54.1265607
                    ],
                    [
                        9.9958601,
                        54.126235
                    ],
                    [
                        9.9956735,
                        54.1258015
                    ],
                    [
                        9.9955291,
                        54.1254337
                    ],
                    [
                        9.9950687,
                        54.1240242
                    ],
                    [
                        9.994832,
                        54.1232563
                    ],
                    [
                        9.9941814,
                        54.1211259
                    ],
                    [
                        9.9933352,
                        54.118355
                    ],
                    [
                        9.9921707,
                        54.1145405
                    ],
                    [
                        9.9893505,
                        54.1053017
                    ],
                    [
                        9.9882766,
                        54.1017772
                    ],
                    [
                        9.9871843,
                        54.0981948
                    ],
                    [
                        9.9869233,
                        54.0973412
                    ],
                    [
                        9.9861161,
                        54.0946079
                    ],
                    [
                        9.9859927,
                        54.0941263
                    ],
                    [
                        9.985849,
                        54.0935976
                    ],
                    [
                        9.9858095,
                        54.0934624
                    ],
                    [
                        9.9857711,
                        54.0933225
                    ],
                    [
                        9.9856294,
                        54.0928261
                    ],
                    [
                        9.9853778,
                        54.092017
                    ],
                    [
                        9.9853578,
                        54.0919517
                    ],
                    [
                        9.9853477,
                        54.091918
                    ],
                    [
                        9.9851836,
                        54.0913741
                    ],
                    [
                        9.9850707,
                        54.0909993
                    ],
                    [
                        9.9848484,
                        54.0902995
                    ],
                    [
                        9.9847314,
                        54.0899321
                    ],
                    [
                        9.9846139,
                        54.0895471
                    ],
                    [
                        9.9843773,
                        54.088757
                    ],
                    [
                        9.9829557,
                        54.0840863
                    ],
                    [
                        9.9827621,
                        54.0834573
                    ],
                    [
                        9.9826127,
                        54.0829717
                    ],
                    [
                        9.9822596,
                        54.081815
                    ],
                    [
                        9.9820038,
                        54.0810277
                    ],
                    [
                        9.9819867,
                        54.0809748
                    ],
                    [
                        9.9818047,
                        54.0804596
                    ],
                    [
                        9.9816731,
                        54.0800718
                    ],
                    [
                        9.9815859,
                        54.0798324
                    ],
                    [
                        9.9814262,
                        54.0793654
                    ],
                    [
                        9.9813618,
                        54.0791742
                    ],
                    [
                        9.9812374,
                        54.0788238
                    ],
                    [
                        9.9809434,
                        54.0779755
                    ],
                    [
                        9.9808417,
                        54.0776872
                    ],
                    [
                        9.9808294,
                        54.0776547
                    ],
                    [
                        9.9807972,
                        54.0775795
                    ],
                    [
                        9.9807164,
                        54.077401
                    ],
                    [
                        9.9806577,
                        54.077284
                    ],
                    [
                        9.9806048,
                        54.077188
                    ],
                    [
                        9.9805619,
                        54.0771266
                    ],
                    [
                        9.9803899,
                        54.0768652
                    ],
                    [
                        9.9803807,
                        54.0768525
                    ],
                    [
                        9.9802797,
                        54.0767187
                    ],
                    [
                        9.9800622,
                        54.0763932
                    ],
                    [
                        9.9799724,
                        54.0762501
                    ],
                    [
                        9.9799698,
                        54.0762456
                    ],
                    [
                        9.9799508,
                        54.0762142
                    ],
                    [
                        9.9798508,
                        54.0760234
                    ],
                    [
                        9.9797112,
                        54.0757455
                    ],
                    [
                        9.9796962,
                        54.0757128
                    ],
                    [
                        9.9796508,
                        54.0756144
                    ],
                    [
                        9.9796428,
                        54.0755979
                    ],
                    [
                        9.9795784,
                        54.0754417
                    ],
                    [
                        9.9794715,
                        54.0751652
                    ],
                    [
                        9.9794102,
                        54.0749892
                    ],
                    [
                        9.9793452,
                        54.0747723
                    ],
                    [
                        9.9792136,
                        54.0742228
                    ],
                    [
                        9.9792052,
                        54.0741931
                    ],
                    [
                        9.9791821,
                        54.0741049
                    ],
                    [
                        9.9791149,
                        54.0739075
                    ],
                    [
                        9.9790715,
                        54.0737931
                    ],
                    [
                        9.9790284,
                        54.0737029
                    ],
                    [
                        9.9789486,
                        54.0735528
                    ],
                    [
                        9.9788831,
                        54.0734318
                    ],
                    [
                        9.9787915,
                        54.0732932
                    ],
                    [
                        9.97869,
                        54.0731488
                    ],
                    [
                        9.9786487,
                        54.0730912
                    ],
                    [
                        9.9782894,
                        54.0726655
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "c7faa86c-f2f0-4fab-a4cb-0593302b1a7f",
            "railwayEdgeName": "E42",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 5550.389027438597,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.1317833,
                        54.3149714
                    ],
                    [
                        10.1317415,
                        54.3148975
                    ],
                    [
                        10.1312474,
                        54.3140159
                    ],
                    [
                        10.1308627,
                        54.3133371
                    ],
                    [
                        10.1308337,
                        54.3132869
                    ],
                    [
                        10.1304795,
                        54.3126582
                    ],
                    [
                        10.1304174,
                        54.3125453
                    ],
                    [
                        10.1303883,
                        54.3124684
                    ],
                    [
                        10.1303616,
                        54.3123967
                    ],
                    [
                        10.1301876,
                        54.3117898
                    ],
                    [
                        10.1300688,
                        54.3113703
                    ],
                    [
                        10.1300603,
                        54.3113351
                    ],
                    [
                        10.1300503,
                        54.3112933
                    ],
                    [
                        10.1298582,
                        54.3106314
                    ],
                    [
                        10.1297354,
                        54.3101949
                    ],
                    [
                        10.1297193,
                        54.3101409
                    ],
                    [
                        10.1297132,
                        54.3101161
                    ],
                    [
                        10.129636,
                        54.3098147
                    ],
                    [
                        10.1295854,
                        54.3095531
                    ],
                    [
                        10.1295661,
                        54.3093212
                    ],
                    [
                        10.1295649,
                        54.3092865
                    ],
                    [
                        10.1295613,
                        54.3091596
                    ],
                    [
                        10.1295638,
                        54.3089849
                    ],
                    [
                        10.1295886,
                        54.3087196
                    ],
                    [
                        10.1296018,
                        54.3086228
                    ],
                    [
                        10.1296693,
                        54.308222
                    ],
                    [
                        10.1297464,
                        54.3078241
                    ],
                    [
                        10.1297891,
                        54.307657
                    ],
                    [
                        10.1298408,
                        54.3074852
                    ],
                    [
                        10.1299664,
                        54.3071554
                    ],
                    [
                        10.1300336,
                        54.3070137
                    ],
                    [
                        10.1301382,
                        54.3068113
                    ],
                    [
                        10.1302315,
                        54.3066561
                    ],
                    [
                        10.1303276,
                        54.3065075
                    ],
                    [
                        10.1304356,
                        54.3063565
                    ],
                    [
                        10.1305438,
                        54.3062145
                    ],
                    [
                        10.130597,
                        54.3061488
                    ],
                    [
                        10.1307591,
                        54.3059585
                    ],
                    [
                        10.1313424,
                        54.3053267
                    ],
                    [
                        10.1321548,
                        54.3044578
                    ],
                    [
                        10.132527,
                        54.3040777
                    ],
                    [
                        10.1330397,
                        54.3035589
                    ],
                    [
                        10.1340369,
                        54.3025514
                    ],
                    [
                        10.1343291,
                        54.3022463
                    ],
                    [
                        10.1345379,
                        54.3020143
                    ],
                    [
                        10.1347655,
                        54.301747
                    ],
                    [
                        10.1349641,
                        54.301479
                    ],
                    [
                        10.1351291,
                        54.301253
                    ],
                    [
                        10.1352888,
                        54.3010112
                    ],
                    [
                        10.1354477,
                        54.3007448
                    ],
                    [
                        10.1356028,
                        54.3004519
                    ],
                    [
                        10.1357389,
                        54.3001656
                    ],
                    [
                        10.1358001,
                        54.3000189
                    ],
                    [
                        10.135871,
                        54.2998353
                    ],
                    [
                        10.1359616,
                        54.2995684
                    ],
                    [
                        10.13603,
                        54.2993388
                    ],
                    [
                        10.1360871,
                        54.299106
                    ],
                    [
                        10.1361259,
                        54.2989193
                    ],
                    [
                        10.1361563,
                        54.2987316
                    ],
                    [
                        10.136177,
                        54.298575
                    ],
                    [
                        10.1361989,
                        54.2983586
                    ],
                    [
                        10.1362122,
                        54.2981515
                    ],
                    [
                        10.1362147,
                        54.2979565
                    ],
                    [
                        10.1362106,
                        54.2977188
                    ],
                    [
                        10.1361951,
                        54.2974778
                    ],
                    [
                        10.1361691,
                        54.2972094
                    ],
                    [
                        10.1361317,
                        54.2969359
                    ],
                    [
                        10.1360751,
                        54.2966022
                    ],
                    [
                        10.1360004,
                        54.2962462
                    ],
                    [
                        10.1358552,
                        54.295738
                    ],
                    [
                        10.1357543,
                        54.2954492
                    ],
                    [
                        10.1356435,
                        54.2951587
                    ],
                    [
                        10.1354217,
                        54.2946628
                    ],
                    [
                        10.1352731,
                        54.2943809
                    ],
                    [
                        10.1351088,
                        54.2940999
                    ],
                    [
                        10.1349432,
                        54.2938336
                    ],
                    [
                        10.1347507,
                        54.2935698
                    ],
                    [
                        10.1345497,
                        54.29331
                    ],
                    [
                        10.1343666,
                        54.2930896
                    ],
                    [
                        10.1341214,
                        54.2928127
                    ],
                    [
                        10.133265,
                        54.2918822
                    ],
                    [
                        10.1327972,
                        54.2913854
                    ],
                    [
                        10.1324149,
                        54.2909944
                    ],
                    [
                        10.1321613,
                        54.2907506
                    ],
                    [
                        10.1318889,
                        54.2905011
                    ],
                    [
                        10.131765,
                        54.2903901
                    ],
                    [
                        10.1315835,
                        54.2902339
                    ],
                    [
                        10.1313515,
                        54.2900449
                    ],
                    [
                        10.1310362,
                        54.2898029
                    ],
                    [
                        10.1308019,
                        54.2896312
                    ],
                    [
                        10.1305632,
                        54.289462
                    ],
                    [
                        10.1302606,
                        54.2892621
                    ],
                    [
                        10.1299536,
                        54.2890647
                    ],
                    [
                        10.1297227,
                        54.2889232
                    ],
                    [
                        10.1294853,
                        54.2887843
                    ],
                    [
                        10.1292177,
                        54.2886321
                    ],
                    [
                        10.1289208,
                        54.2884716
                    ],
                    [
                        10.1286174,
                        54.2883162
                    ],
                    [
                        10.1282426,
                        54.2881308
                    ],
                    [
                        10.1278688,
                        54.287956
                    ],
                    [
                        10.1275432,
                        54.2878129
                    ],
                    [
                        10.1272154,
                        54.2876737
                    ],
                    [
                        10.12675,
                        54.2874888
                    ],
                    [
                        10.12622,
                        54.2872922
                    ],
                    [
                        10.1256812,
                        54.287102
                    ],
                    [
                        10.1251183,
                        54.2869176
                    ],
                    [
                        10.1245662,
                        54.2867464
                    ],
                    [
                        10.1241075,
                        54.286612
                    ],
                    [
                        10.1236422,
                        54.2864827
                    ],
                    [
                        10.1233104,
                        54.2863936
                    ],
                    [
                        10.1229786,
                        54.2863095
                    ],
                    [
                        10.1226601,
                        54.286232
                    ],
                    [
                        10.1223395,
                        54.286157
                    ],
                    [
                        10.121896,
                        54.2860577
                    ],
                    [
                        10.1214351,
                        54.2859609
                    ],
                    [
                        10.1209877,
                        54.2858728
                    ],
                    [
                        10.1205359,
                        54.2857886
                    ],
                    [
                        10.1202558,
                        54.2857398
                    ],
                    [
                        10.1199757,
                        54.2856937
                    ],
                    [
                        10.1196085,
                        54.2856338
                    ],
                    [
                        10.1192853,
                        54.2855853
                    ],
                    [
                        10.1189556,
                        54.2855394
                    ],
                    [
                        10.1186104,
                        54.2854928
                    ],
                    [
                        10.1182695,
                        54.2854513
                    ],
                    [
                        10.1179258,
                        54.2854126
                    ],
                    [
                        10.1175777,
                        54.2853764
                    ],
                    [
                        10.1161288,
                        54.2852491
                    ],
                    [
                        10.1123801,
                        54.2849713
                    ],
                    [
                        10.1101588,
                        54.2848052
                    ],
                    [
                        10.1094887,
                        54.2847509
                    ],
                    [
                        10.1089555,
                        54.2847021
                    ],
                    [
                        10.1084298,
                        54.2846498
                    ],
                    [
                        10.1078271,
                        54.2845819
                    ],
                    [
                        10.1074686,
                        54.2845361
                    ],
                    [
                        10.107095,
                        54.2844868
                    ],
                    [
                        10.1067391,
                        54.2844364
                    ],
                    [
                        10.1063787,
                        54.2843825
                    ],
                    [
                        10.1059959,
                        54.2843198
                    ],
                    [
                        10.1055294,
                        54.2842387
                    ],
                    [
                        10.1050418,
                        54.2841456
                    ],
                    [
                        10.1046554,
                        54.2840678
                    ],
                    [
                        10.1043786,
                        54.2840049
                    ],
                    [
                        10.1040999,
                        54.2839396
                    ],
                    [
                        10.10379,
                        54.2838616
                    ],
                    [
                        10.1035495,
                        54.2837965
                    ],
                    [
                        10.1032443,
                        54.2837122
                    ],
                    [
                        10.1029474,
                        54.2836248
                    ],
                    [
                        10.1025396,
                        54.2834955
                    ],
                    [
                        10.1021351,
                        54.2833604
                    ],
                    [
                        10.1016993,
                        54.2832021
                    ],
                    [
                        10.101345,
                        54.2830648
                    ],
                    [
                        10.1009768,
                        54.2829118
                    ],
                    [
                        10.1005947,
                        54.2827443
                    ],
                    [
                        10.1002347,
                        54.2825759
                    ],
                    [
                        10.0998863,
                        54.2824029
                    ],
                    [
                        10.0996518,
                        54.2822796
                    ],
                    [
                        10.0994485,
                        54.2821698
                    ],
                    [
                        10.0992082,
                        54.2820338
                    ],
                    [
                        10.0988671,
                        54.2818295
                    ],
                    [
                        10.0985396,
                        54.2816212
                    ],
                    [
                        10.0979203,
                        54.2812031
                    ],
                    [
                        10.0974086,
                        54.2808384
                    ],
                    [
                        10.0969951,
                        54.2805419
                    ],
                    [
                        10.0966836,
                        54.2803117
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "30cf2a81-334f-4924-80a8-0611a8644dcb",
            "railwayEdgeName": "E34",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 26408.05101651103,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7940466,
                        53.6575762
                    ],
                    [
                        9.7937552,
                        53.6577806
                    ],
                    [
                        9.7934825,
                        53.6579743
                    ],
                    [
                        9.7931975,
                        53.6581742
                    ],
                    [
                        9.7930307,
                        53.6582921
                    ],
                    [
                        9.7927908,
                        53.6584573
                    ],
                    [
                        9.7922591,
                        53.6588281
                    ],
                    [
                        9.791809,
                        53.6591327
                    ],
                    [
                        9.7909496,
                        53.6597167
                    ],
                    [
                        9.7902709,
                        53.6602071
                    ],
                    [
                        9.7895668,
                        53.6606909
                    ],
                    [
                        9.7891181,
                        53.6610009
                    ],
                    [
                        9.7888827,
                        53.6611582
                    ],
                    [
                        9.7880486,
                        53.6617029
                    ],
                    [
                        9.7876235,
                        53.661973
                    ],
                    [
                        9.78752,
                        53.6620459
                    ],
                    [
                        9.7868147,
                        53.6625236
                    ],
                    [
                        9.786108,
                        53.6630117
                    ],
                    [
                        9.7835348,
                        53.6647744
                    ],
                    [
                        9.7823901,
                        53.6653858
                    ],
                    [
                        9.781239,
                        53.6660005
                    ],
                    [
                        9.7783037,
                        53.6673095
                    ],
                    [
                        9.7773784,
                        53.6677221
                    ],
                    [
                        9.7748189,
                        53.6688635
                    ],
                    [
                        9.7683674,
                        53.6717632
                    ],
                    [
                        9.766116,
                        53.6727294
                    ],
                    [
                        9.7643338,
                        53.6735017
                    ],
                    [
                        9.7602728,
                        53.6752841
                    ],
                    [
                        9.7586651,
                        53.6759929
                    ],
                    [
                        9.7571853,
                        53.6766454
                    ],
                    [
                        9.7567527,
                        53.676841
                    ],
                    [
                        9.7541132,
                        53.6780342
                    ],
                    [
                        9.7528273,
                        53.6785944
                    ],
                    [
                        9.7505372,
                        53.6795911
                    ],
                    [
                        9.7447991,
                        53.6820947
                    ],
                    [
                        9.744165,
                        53.6823944
                    ],
                    [
                        9.7422771,
                        53.6832867
                    ],
                    [
                        9.7380329,
                        53.68514
                    ],
                    [
                        9.7362875,
                        53.685905
                    ],
                    [
                        9.7320999,
                        53.6877502
                    ],
                    [
                        9.7312882,
                        53.6881079
                    ],
                    [
                        9.7288317,
                        53.6891593
                    ],
                    [
                        9.7273935,
                        53.6897749
                    ],
                    [
                        9.7264234,
                        53.690206
                    ],
                    [
                        9.7262436,
                        53.6902904
                    ],
                    [
                        9.7253251,
                        53.690722
                    ],
                    [
                        9.7253136,
                        53.6907273
                    ],
                    [
                        9.7252473,
                        53.6907585
                    ],
                    [
                        9.7222935,
                        53.692176
                    ],
                    [
                        9.7220446,
                        53.6923041
                    ],
                    [
                        9.7211485,
                        53.6927653
                    ],
                    [
                        9.7200426,
                        53.6933915
                    ],
                    [
                        9.7190863,
                        53.6940222
                    ],
                    [
                        9.7187906,
                        53.6942447
                    ],
                    [
                        9.7174989,
                        53.6952166
                    ],
                    [
                        9.7165975,
                        53.6959524
                    ],
                    [
                        9.7163844,
                        53.696127
                    ],
                    [
                        9.7160124,
                        53.696432
                    ],
                    [
                        9.7154425,
                        53.6969331
                    ],
                    [
                        9.7153406,
                        53.6970227
                    ],
                    [
                        9.7145217,
                        53.6977095
                    ],
                    [
                        9.7144747,
                        53.6977489
                    ],
                    [
                        9.7142319,
                        53.697944
                    ],
                    [
                        9.7134153,
                        53.6986232
                    ],
                    [
                        9.7120924,
                        53.6997384
                    ],
                    [
                        9.7095802,
                        53.7018367
                    ],
                    [
                        9.7063661,
                        53.7045592
                    ],
                    [
                        9.7058228,
                        53.7050193
                    ],
                    [
                        9.705675,
                        53.7051445
                    ],
                    [
                        9.7033088,
                        53.7071593
                    ],
                    [
                        9.7016857,
                        53.7085414
                    ],
                    [
                        9.6986284,
                        53.7112379
                    ],
                    [
                        9.695849,
                        53.7135173
                    ],
                    [
                        9.6952306,
                        53.7140245
                    ],
                    [
                        9.6940536,
                        53.7151137
                    ],
                    [
                        9.6892437,
                        53.7191743
                    ],
                    [
                        9.6879167,
                        53.7202944
                    ],
                    [
                        9.6805407,
                        53.7264916
                    ],
                    [
                        9.6800054,
                        53.7269413
                    ],
                    [
                        9.6770583,
                        53.7294624
                    ],
                    [
                        9.6762204,
                        53.730181
                    ],
                    [
                        9.6745113,
                        53.7316465
                    ],
                    [
                        9.6723331,
                        53.7335065
                    ],
                    [
                        9.6688067,
                        53.7363504
                    ],
                    [
                        9.6674691,
                        53.737496
                    ],
                    [
                        9.6672387,
                        53.7377024
                    ],
                    [
                        9.6664585,
                        53.7384015
                    ],
                    [
                        9.6655362,
                        53.73927
                    ],
                    [
                        9.6645557,
                        53.7403211
                    ],
                    [
                        9.6639508,
                        53.7410881
                    ],
                    [
                        9.663263,
                        53.7421404
                    ],
                    [
                        9.6631161,
                        53.7424112
                    ],
                    [
                        9.6628429,
                        53.7429388
                    ],
                    [
                        9.6624998,
                        53.743632
                    ],
                    [
                        9.6622682,
                        53.7442222
                    ],
                    [
                        9.6618997,
                        53.74538
                    ],
                    [
                        9.6617291,
                        53.7459617
                    ],
                    [
                        9.6615525,
                        53.7465642
                    ],
                    [
                        9.661098,
                        53.7481159
                    ],
                    [
                        9.6610948,
                        53.7481262
                    ],
                    [
                        9.6610065,
                        53.7484634
                    ],
                    [
                        9.6608651,
                        53.7489552
                    ],
                    [
                        9.6607792,
                        53.7492569
                    ],
                    [
                        9.6605442,
                        53.7500854
                    ],
                    [
                        9.6605263,
                        53.7501454
                    ],
                    [
                        9.6605178,
                        53.7501765
                    ],
                    [
                        9.660088,
                        53.7517208
                    ],
                    [
                        9.6595126,
                        53.7537884
                    ],
                    [
                        9.659499,
                        53.7538407
                    ],
                    [
                        9.659392,
                        53.7542229
                    ],
                    [
                        9.6593325,
                        53.7544378
                    ],
                    [
                        9.6592575,
                        53.7547162
                    ],
                    [
                        9.6591662,
                        53.7550324
                    ],
                    [
                        9.6591503,
                        53.7550871
                    ],
                    [
                        9.659148,
                        53.755095
                    ],
                    [
                        9.6590421,
                        53.7554566
                    ],
                    [
                        9.6590093,
                        53.755579
                    ],
                    [
                        9.6588099,
                        53.7562624
                    ],
                    [
                        9.6586433,
                        53.7568347
                    ],
                    [
                        9.6585779,
                        53.7570664
                    ],
                    [
                        9.6579842,
                        53.7591464
                    ],
                    [
                        9.6579603,
                        53.7592333
                    ],
                    [
                        9.6578966,
                        53.7594548
                    ],
                    [
                        9.6576288,
                        53.7604643
                    ],
                    [
                        9.6572947,
                        53.7618226
                    ],
                    [
                        9.6571221,
                        53.7624371
                    ],
                    [
                        9.6566524,
                        53.7640837
                    ],
                    [
                        9.6557501,
                        53.7671475
                    ],
                    [
                        9.6555167,
                        53.7679583
                    ],
                    [
                        9.6550126,
                        53.7696847
                    ],
                    [
                        9.6548286,
                        53.7703375
                    ],
                    [
                        9.6544562,
                        53.7717528
                    ],
                    [
                        9.6540069,
                        53.7732539
                    ],
                    [
                        9.6538573,
                        53.7737803
                    ],
                    [
                        9.6537073,
                        53.7742957
                    ],
                    [
                        9.6526885,
                        53.7779415
                    ],
                    [
                        9.6519862,
                        53.7804222
                    ],
                    [
                        9.6514679,
                        53.7822469
                    ],
                    [
                        9.6513569,
                        53.7826349
                    ],
                    [
                        9.6508384,
                        53.78449
                    ],
                    [
                        9.6481484,
                        53.794037
                    ],
                    [
                        9.6478773,
                        53.7950145
                    ],
                    [
                        9.6469636,
                        53.7982553
                    ],
                    [
                        9.6451626,
                        53.8046426
                    ],
                    [
                        9.6449207,
                        53.8054997
                    ],
                    [
                        9.6445911,
                        53.8066732
                    ],
                    [
                        9.6430678,
                        53.8120789
                    ],
                    [
                        9.6429262,
                        53.8126272
                    ],
                    [
                        9.6428045,
                        53.8131715
                    ],
                    [
                        9.6427186,
                        53.8137334
                    ],
                    [
                        9.6426751,
                        53.8142757
                    ],
                    [
                        9.6426629,
                        53.8149727
                    ],
                    [
                        9.6426969,
                        53.8156549
                    ],
                    [
                        9.6427061,
                        53.8157665
                    ],
                    [
                        9.6427963,
                        53.8164596
                    ],
                    [
                        9.6429328,
                        53.8171803
                    ],
                    [
                        9.6430011,
                        53.8174634
                    ],
                    [
                        9.6430786,
                        53.8177574
                    ],
                    [
                        9.6431831,
                        53.8180949
                    ],
                    [
                        9.6432999,
                        53.8184337
                    ],
                    [
                        9.6435727,
                        53.8191181
                    ],
                    [
                        9.6438218,
                        53.8196467
                    ],
                    [
                        9.6439743,
                        53.8199426
                    ],
                    [
                        9.6442513,
                        53.8204359
                    ],
                    [
                        9.6443884,
                        53.8206634
                    ],
                    [
                        9.645078,
                        53.8216707
                    ],
                    [
                        9.6453902,
                        53.8220709
                    ],
                    [
                        9.645825,
                        53.822581
                    ],
                    [
                        9.6463093,
                        53.8230988
                    ],
                    [
                        9.646585,
                        53.8233756
                    ],
                    [
                        9.6468687,
                        53.8236502
                    ],
                    [
                        9.6474493,
                        53.8241945
                    ],
                    [
                        9.6480593,
                        53.8247446
                    ],
                    [
                        9.6497054,
                        53.8261791
                    ],
                    [
                        9.6552619,
                        53.8308372
                    ],
                    [
                        9.659536,
                        53.8344169
                    ],
                    [
                        9.66353,
                        53.8377583
                    ],
                    [
                        9.6646666,
                        53.8387092
                    ],
                    [
                        9.6648047,
                        53.8388273
                    ],
                    [
                        9.6649616,
                        53.8389569
                    ],
                    [
                        9.6660332,
                        53.8398546
                    ],
                    [
                        9.6681757,
                        53.8416436
                    ],
                    [
                        9.6717705,
                        53.8446542
                    ],
                    [
                        9.6747936,
                        53.8471856
                    ],
                    [
                        9.6762604,
                        53.848413
                    ],
                    [
                        9.6769795,
                        53.8490103
                    ],
                    [
                        9.677749,
                        53.8496557
                    ],
                    [
                        9.6778101,
                        53.8497048
                    ],
                    [
                        9.6789108,
                        53.8506338
                    ],
                    [
                        9.6793886,
                        53.8510696
                    ],
                    [
                        9.6795757,
                        53.8512498
                    ],
                    [
                        9.679758,
                        53.8514335
                    ],
                    [
                        9.6801146,
                        53.8518023
                    ],
                    [
                        9.6803376,
                        53.8520446
                    ],
                    [
                        9.6805489,
                        53.8522883
                    ],
                    [
                        9.6806449,
                        53.8523937
                    ],
                    [
                        9.6806683,
                        53.8524201
                    ],
                    [
                        9.6807036,
                        53.8524612
                    ],
                    [
                        9.6807336,
                        53.8524971
                    ],
                    [
                        9.6807979,
                        53.8525752
                    ],
                    [
                        9.6811012,
                        53.8529462
                    ],
                    [
                        9.6813866,
                        53.8532788
                    ],
                    [
                        9.681764,
                        53.8537253
                    ],
                    [
                        9.6829949,
                        53.8551984
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "a0ae3313-2df7-4ef5-b9ad-06ad8dc01cb6",
            "railwayEdgeName": "E1",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 1974.9849334119874,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.978655,
                        54.062102
                    ],
                    [
                        9.9781616,
                        54.0623503
                    ],
                    [
                        9.9774698,
                        54.0627144
                    ],
                    [
                        9.9774375,
                        54.0627314
                    ],
                    [
                        9.9773045,
                        54.0627983
                    ],
                    [
                        9.9771874,
                        54.0628673
                    ],
                    [
                        9.9768783,
                        54.0630454
                    ],
                    [
                        9.9765558,
                        54.0632486
                    ],
                    [
                        9.9762572,
                        54.0634597
                    ],
                    [
                        9.9760621,
                        54.0636046
                    ],
                    [
                        9.9759777,
                        54.0636797
                    ],
                    [
                        9.9759403,
                        54.0637106
                    ],
                    [
                        9.9758874,
                        54.0637578
                    ],
                    [
                        9.9757122,
                        54.0639091
                    ],
                    [
                        9.9752839,
                        54.0643575
                    ],
                    [
                        9.9750874,
                        54.0646017
                    ],
                    [
                        9.9749313,
                        54.0648318
                    ],
                    [
                        9.9748446,
                        54.0649646
                    ],
                    [
                        9.9746702,
                        54.0653008
                    ],
                    [
                        9.9745225,
                        54.0656494
                    ],
                    [
                        9.9744141,
                        54.066008
                    ],
                    [
                        9.9743473,
                        54.066368
                    ],
                    [
                        9.9743413,
                        54.0666318
                    ],
                    [
                        9.9743399,
                        54.0667077
                    ],
                    [
                        9.9743441,
                        54.0670461
                    ],
                    [
                        9.9743785,
                        54.0673087
                    ],
                    [
                        9.9744317,
                        54.0675764
                    ],
                    [
                        9.9744854,
                        54.0677656
                    ],
                    [
                        9.9744919,
                        54.0677884
                    ],
                    [
                        9.9745648,
                        54.0679997
                    ],
                    [
                        9.9746252,
                        54.0681392
                    ],
                    [
                        9.9746886,
                        54.0682764
                    ],
                    [
                        9.974749,
                        54.0683958
                    ],
                    [
                        9.9748187,
                        54.0685138
                    ],
                    [
                        9.9748865,
                        54.0686165
                    ],
                    [
                        9.9749803,
                        54.0687432
                    ],
                    [
                        9.9750471,
                        54.0688234
                    ],
                    [
                        9.9751867,
                        54.0689875
                    ],
                    [
                        9.9752882,
                        54.0690976
                    ],
                    [
                        9.9754494,
                        54.06927
                    ],
                    [
                        9.9758733,
                        54.0697019
                    ],
                    [
                        9.9759704,
                        54.0697986
                    ],
                    [
                        9.9762772,
                        54.0701138
                    ],
                    [
                        9.9765162,
                        54.0703718
                    ],
                    [
                        9.9766261,
                        54.0705018
                    ],
                    [
                        9.9766359,
                        54.0705131
                    ],
                    [
                        9.9768216,
                        54.0707336
                    ],
                    [
                        9.9768413,
                        54.0707556
                    ],
                    [
                        9.9770457,
                        54.0709856
                    ],
                    [
                        9.9773396,
                        54.0713765
                    ],
                    [
                        9.9774865,
                        54.0715626
                    ],
                    [
                        9.9776014,
                        54.0716973
                    ],
                    [
                        9.9780713,
                        54.072234
                    ],
                    [
                        9.9781545,
                        54.0723264
                    ],
                    [
                        9.9784684,
                        54.0726924
                    ],
                    [
                        9.9785886,
                        54.0728352
                    ],
                    [
                        9.9786476,
                        54.0729004
                    ],
                    [
                        9.9787027,
                        54.0729668
                    ],
                    [
                        9.9787454,
                        54.073023
                    ],
                    [
                        9.9788996,
                        54.0732318
                    ],
                    [
                        9.9790139,
                        54.0734106
                    ],
                    [
                        9.9790837,
                        54.0735316
                    ],
                    [
                        9.979178,
                        54.0737277
                    ],
                    [
                        9.979219,
                        54.0738197
                    ],
                    [
                        9.979289,
                        54.0739989
                    ],
                    [
                        9.9792954,
                        54.0740114
                    ],
                    [
                        9.9794524,
                        54.0743162
                    ],
                    [
                        9.9795025,
                        54.0744151
                    ],
                    [
                        9.979636,
                        54.074698
                    ],
                    [
                        9.9796518,
                        54.0747287
                    ],
                    [
                        9.9796818,
                        54.0747829
                    ],
                    [
                        9.9799159,
                        54.0752619
                    ],
                    [
                        9.9801251,
                        54.0756931
                    ],
                    [
                        9.9805836,
                        54.0766423
                    ],
                    [
                        9.980766,
                        54.077006
                    ],
                    [
                        9.9808506,
                        54.0772009
                    ],
                    [
                        9.9808602,
                        54.0772385
                    ],
                    [
                        9.980916,
                        54.0775145
                    ],
                    [
                        9.9810052,
                        54.077761
                    ],
                    [
                        9.9810934,
                        54.0782075
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "ea92adb9-ff0d-4bb9-a337-0c28e12fbc85",
            "railwayEdgeName": "E78",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 296.81928835223886,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9413113,
                        53.5629409
                    ],
                    [
                        9.9414992,
                        53.5629379
                    ],
                    [
                        9.9416497,
                        53.562933
                    ],
                    [
                        9.9418305,
                        53.5629258
                    ],
                    [
                        9.9422981,
                        53.5628849
                    ],
                    [
                        9.9424927,
                        53.5628655
                    ],
                    [
                        9.9425263,
                        53.5628621
                    ],
                    [
                        9.9425994,
                        53.562854
                    ],
                    [
                        9.9435234,
                        53.5627421
                    ],
                    [
                        9.9438879,
                        53.562695
                    ],
                    [
                        9.9441138,
                        53.5626661
                    ],
                    [
                        9.9453965,
                        53.5624794
                    ],
                    [
                        9.9454777,
                        53.562467
                    ],
                    [
                        9.9457017,
                        53.562432
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "357bb902-2fc7-410a-a500-106521f4d98e",
            "railwayEdgeName": "E39",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 745.5486135587145,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9818757,
                        54.0808692
                    ],
                    [
                        9.9816949,
                        54.080372
                    ],
                    [
                        9.9815847,
                        54.0800287
                    ],
                    [
                        9.9815716,
                        54.0799923
                    ],
                    [
                        9.9815516,
                        54.0799357
                    ],
                    [
                        9.981524,
                        54.0798535
                    ],
                    [
                        9.9814273,
                        54.0795678
                    ],
                    [
                        9.9812306,
                        54.0790089
                    ],
                    [
                        9.9811776,
                        54.0788472
                    ],
                    [
                        9.9810963,
                        54.0786164
                    ],
                    [
                        9.9809869,
                        54.0783057
                    ],
                    [
                        9.9807547,
                        54.0776422
                    ],
                    [
                        9.9806627,
                        54.0774392
                    ],
                    [
                        9.9806368,
                        54.07738
                    ],
                    [
                        9.9805922,
                        54.0772929
                    ],
                    [
                        9.9805573,
                        54.0772354
                    ],
                    [
                        9.9805312,
                        54.0771924
                    ],
                    [
                        9.9803373,
                        54.0768993
                    ],
                    [
                        9.9803155,
                        54.076869
                    ],
                    [
                        9.9801499,
                        54.0766385
                    ],
                    [
                        9.9799989,
                        54.0764071
                    ],
                    [
                        9.9799139,
                        54.0762595
                    ],
                    [
                        9.9798956,
                        54.0762277
                    ],
                    [
                        9.9797909,
                        54.076035
                    ],
                    [
                        9.9796589,
                        54.075752
                    ],
                    [
                        9.9796432,
                        54.075719
                    ],
                    [
                        9.9795969,
                        54.0756225
                    ],
                    [
                        9.9795203,
                        54.0754534
                    ],
                    [
                        9.9794463,
                        54.0752829
                    ],
                    [
                        9.9793456,
                        54.0750019
                    ],
                    [
                        9.9793079,
                        54.0748903
                    ],
                    [
                        9.9792763,
                        54.0747794
                    ],
                    [
                        9.9791762,
                        54.0743753
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "c246260c-280b-4f42-9103-13099fdc9ac3",
            "railwayEdgeName": "E47",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 13518.565439882399,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9782894,
                        54.0726655
                    ],
                    [
                        9.9781154,
                        54.0724619
                    ],
                    [
                        9.9776062,
                        54.0718681
                    ],
                    [
                        9.9774684,
                        54.0717028
                    ],
                    [
                        9.977353,
                        54.0715644
                    ],
                    [
                        9.9771645,
                        54.0713306
                    ],
                    [
                        9.9768937,
                        54.0710067
                    ],
                    [
                        9.9766645,
                        54.070745
                    ],
                    [
                        9.9763943,
                        54.070453
                    ],
                    [
                        9.9763694,
                        54.0704269
                    ],
                    [
                        9.9762506,
                        54.0703057
                    ],
                    [
                        9.9758019,
                        54.0698458
                    ],
                    [
                        9.9752565,
                        54.0692919
                    ],
                    [
                        9.9750919,
                        54.0691281
                    ],
                    [
                        9.9749752,
                        54.0690159
                    ],
                    [
                        9.9748865,
                        54.0689342
                    ],
                    [
                        9.9743915,
                        54.0685025
                    ],
                    [
                        9.9740358,
                        54.068202
                    ],
                    [
                        9.9738503,
                        54.0680516
                    ],
                    [
                        9.9727734,
                        54.0672227
                    ],
                    [
                        9.9723404,
                        54.0669022
                    ],
                    [
                        9.9714695,
                        54.066289
                    ],
                    [
                        9.9710693,
                        54.0660238
                    ],
                    [
                        9.9703964,
                        54.0655903
                    ],
                    [
                        9.9696946,
                        54.0651631
                    ],
                    [
                        9.9694932,
                        54.0650382
                    ],
                    [
                        9.9686737,
                        54.0645641
                    ],
                    [
                        9.9674784,
                        54.0639243
                    ],
                    [
                        9.9672549,
                        54.0637962
                    ],
                    [
                        9.9667901,
                        54.0635557
                    ],
                    [
                        9.9666812,
                        54.0634985
                    ],
                    [
                        9.9659817,
                        54.063138
                    ],
                    [
                        9.9628789,
                        54.0615428
                    ],
                    [
                        9.958623,
                        54.0593587
                    ],
                    [
                        9.9528056,
                        54.0563701
                    ],
                    [
                        9.9525462,
                        54.0562369
                    ],
                    [
                        9.9518271,
                        54.0558733
                    ],
                    [
                        9.9445016,
                        54.0521155
                    ],
                    [
                        9.9443496,
                        54.0520305
                    ],
                    [
                        9.9406263,
                        54.050123
                    ],
                    [
                        9.9398562,
                        54.049733
                    ],
                    [
                        9.9395326,
                        54.0495632
                    ],
                    [
                        9.9387377,
                        54.0491566
                    ],
                    [
                        9.9382354,
                        54.0489021
                    ],
                    [
                        9.9305421,
                        54.0449634
                    ],
                    [
                        9.9284264,
                        54.0438788
                    ],
                    [
                        9.9277863,
                        54.0435519
                    ],
                    [
                        9.927363,
                        54.0433355
                    ],
                    [
                        9.9216551,
                        54.0404028
                    ],
                    [
                        9.914608,
                        54.0367992
                    ],
                    [
                        9.9071804,
                        54.0329853
                    ],
                    [
                        9.8993702,
                        54.028993
                    ],
                    [
                        9.8939925,
                        54.026231
                    ],
                    [
                        9.892139,
                        54.0252666
                    ],
                    [
                        9.8910762,
                        54.0247336
                    ],
                    [
                        9.8844398,
                        54.0213229
                    ],
                    [
                        9.8824504,
                        54.0202996
                    ],
                    [
                        9.8816763,
                        54.0199075
                    ],
                    [
                        9.8809523,
                        54.0195383
                    ],
                    [
                        9.8785409,
                        54.0183006
                    ],
                    [
                        9.871832,
                        54.0148561
                    ],
                    [
                        9.8693669,
                        54.0135914
                    ],
                    [
                        9.8648085,
                        54.0112479
                    ],
                    [
                        9.8587659,
                        54.0081427
                    ],
                    [
                        9.8518765,
                        54.0046007
                    ],
                    [
                        9.8449461,
                        54.0010314
                    ],
                    [
                        9.8415805,
                        53.9992976
                    ],
                    [
                        9.8388696,
                        53.9978932
                    ],
                    [
                        9.832003,
                        53.9943624
                    ],
                    [
                        9.8300724,
                        53.9933663
                    ],
                    [
                        9.8274674,
                        53.9920203
                    ],
                    [
                        9.8259148,
                        53.9912194
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "bb481aaf-e568-4944-b141-1574895b3f5a",
            "railwayEdgeName": "E23",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 705.1578410963809,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.6587612,
                        53.7562223
                    ],
                    [
                        9.6588057,
                        53.7560613
                    ],
                    [
                        9.6589711,
                        53.7554982
                    ],
                    [
                        9.6589937,
                        53.755415
                    ],
                    [
                        9.6590393,
                        53.7552601
                    ],
                    [
                        9.6590398,
                        53.7552581
                    ],
                    [
                        9.6590513,
                        53.7552188
                    ],
                    [
                        9.6590941,
                        53.7550721
                    ],
                    [
                        9.6592069,
                        53.7546624
                    ],
                    [
                        9.6592717,
                        53.7544316
                    ],
                    [
                        9.6593327,
                        53.7542172
                    ],
                    [
                        9.6593579,
                        53.7541266
                    ],
                    [
                        9.6594399,
                        53.7538278
                    ],
                    [
                        9.6595208,
                        53.7535319
                    ],
                    [
                        9.6598379,
                        53.7523952
                    ],
                    [
                        9.6600258,
                        53.7517249
                    ],
                    [
                        9.6600272,
                        53.7517181
                    ],
                    [
                        9.6602448,
                        53.7509327
                    ],
                    [
                        9.6605136,
                        53.74997
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "574867c6-e2ba-420b-b45f-15fe8fddf6c3",
            "railwayEdgeName": "E26",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 199.8078659101276,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9782894,
                        54.0726655
                    ],
                    [
                        9.978515,
                        54.0729601
                    ],
                    [
                        9.9785904,
                        54.073069
                    ],
                    [
                        9.9787332,
                        54.0733026
                    ],
                    [
                        9.9788191,
                        54.0734443
                    ],
                    [
                        9.9788837,
                        54.0735638
                    ],
                    [
                        9.9789622,
                        54.0737106
                    ],
                    [
                        9.9790036,
                        54.0738037
                    ],
                    [
                        9.9790611,
                        54.073953
                    ],
                    [
                        9.979126,
                        54.0741659
                    ],
                    [
                        9.9791343,
                        54.0741922
                    ],
                    [
                        9.9791762,
                        54.0743753
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "d983fa0c-0b6e-4d1e-8b7a-17f4a4348bea",
            "railwayEdgeName": "E8",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 978.3643760074214,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8988675,
                        53.6014657
                    ],
                    [
                        9.8988943,
                        53.6017664
                    ],
                    [
                        9.8989358,
                        53.6020444
                    ],
                    [
                        9.8989423,
                        53.6020943
                    ],
                    [
                        9.8989581,
                        53.6022157
                    ],
                    [
                        9.8989644,
                        53.6024335
                    ],
                    [
                        9.8989578,
                        53.602691
                    ],
                    [
                        9.8989165,
                        53.6029408
                    ],
                    [
                        9.8987898,
                        53.6033592
                    ],
                    [
                        9.8986438,
                        53.6038386
                    ],
                    [
                        9.8986408,
                        53.6038486
                    ],
                    [
                        9.8986109,
                        53.6039467
                    ],
                    [
                        9.8982434,
                        53.6050703
                    ],
                    [
                        9.8981834,
                        53.6052598
                    ],
                    [
                        9.8981158,
                        53.6054724
                    ],
                    [
                        9.8980218,
                        53.6058874
                    ],
                    [
                        9.8980071,
                        53.6061597
                    ],
                    [
                        9.8980478,
                        53.6064328
                    ],
                    [
                        9.8981337,
                        53.6067164
                    ],
                    [
                        9.8982393,
                        53.6069294
                    ],
                    [
                        9.8982794,
                        53.6069964
                    ],
                    [
                        9.898382,
                        53.6071451
                    ],
                    [
                        9.8985371,
                        53.6073483
                    ],
                    [
                        9.8987882,
                        53.6075935
                    ],
                    [
                        9.8992052,
                        53.6079416
                    ],
                    [
                        9.8996251,
                        53.6082774
                    ],
                    [
                        9.9004523,
                        53.6089631
                    ],
                    [
                        9.9006664,
                        53.6091668
                    ],
                    [
                        9.9006855,
                        53.6091849
                    ],
                    [
                        9.9008616,
                        53.6093796
                    ],
                    [
                        9.9009794,
                        53.6095305
                    ],
                    [
                        9.9010795,
                        53.6096839
                    ],
                    [
                        9.9010892,
                        53.6097011
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "b26ad56a-8575-43a1-bba3-1d138ee6ff2c",
            "railwayEdgeName": "E76",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 74.93483170164184,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8259148,
                        53.9912194
                    ],
                    [
                        9.8268189,
                        53.9916314
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "5e98aa54-2b2e-45fb-8302-1f28e2bd8c65",
            "railwayEdgeName": "E62",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 827.2371355361322,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.6829949,
                        53.8551984
                    ],
                    [
                        9.6831369,
                        53.8553515
                    ],
                    [
                        9.6833046,
                        53.855518
                    ],
                    [
                        9.6834205,
                        53.8556322
                    ],
                    [
                        9.6836825,
                        53.8559271
                    ],
                    [
                        9.6837967,
                        53.8560639
                    ],
                    [
                        9.6856987,
                        53.858327
                    ],
                    [
                        9.6880667,
                        53.861138
                    ],
                    [
                        9.6881385,
                        53.86123
                    ],
                    [
                        9.6885854,
                        53.8618558
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "54a440ba-6cd4-4c41-b10b-278ac044c46e",
            "railwayEdgeName": "E9",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 451.3853445280671,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9023147,
                        53.5982046
                    ],
                    [
                        9.9020919,
                        53.5983157
                    ],
                    [
                        9.9020731,
                        53.5983251
                    ],
                    [
                        9.9014622,
                        53.5986354
                    ],
                    [
                        9.9009955,
                        53.5988687
                    ],
                    [
                        9.9002245,
                        53.5992613
                    ],
                    [
                        9.8998768,
                        53.5994824
                    ],
                    [
                        9.8996516,
                        53.5996705
                    ],
                    [
                        9.8994202,
                        53.5998821
                    ],
                    [
                        9.8992206,
                        53.6001274
                    ],
                    [
                        9.8991005,
                        53.6003246
                    ],
                    [
                        9.8989991,
                        53.6005247
                    ],
                    [
                        9.8989013,
                        53.6007972
                    ],
                    [
                        9.8988607,
                        53.6011439
                    ],
                    [
                        9.8988674,
                        53.6014633
                    ],
                    [
                        9.8988675,
                        53.6014657
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "d4b0416a-0368-4440-9b1d-2d5af6bb9028",
            "railwayEdgeName": "E80",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 70.14433229319245,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.144244,
                        54.2958514
                    ],
                    [
                        10.1447739,
                        54.2956884
                    ],
                    [
                        10.1451711,
                        54.2955665
                    ],
                    [
                        10.1451981,
                        54.2955583
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "569703f2-82e3-4cf1-8066-2e1844773a28",
            "railwayEdgeName": "E73",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 241.1610763748444,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7944421,
                        53.6574288
                    ],
                    [
                        9.7953819,
                        53.656777
                    ],
                    [
                        9.7959365,
                        53.6564008
                    ],
                    [
                        9.7962642,
                        53.6561763
                    ],
                    [
                        9.796479,
                        53.6560104
                    ],
                    [
                        9.7967746,
                        53.6557636
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "07d522ee-a53f-4c02-bfde-309efe21e5b5",
            "railwayEdgeName": "E67",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 6276.803064781001,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8124437,
                        53.9842716
                    ],
                    [
                        9.810253,
                        53.9831407
                    ],
                    [
                        9.808426,
                        53.9821768
                    ],
                    [
                        9.8077008,
                        53.9818219
                    ],
                    [
                        9.7959275,
                        53.9757336
                    ],
                    [
                        9.7916308,
                        53.9735132
                    ],
                    [
                        9.7882448,
                        53.9717652
                    ],
                    [
                        9.783458,
                        53.9692916
                    ],
                    [
                        9.7814293,
                        53.9682461
                    ],
                    [
                        9.7795476,
                        53.9672609
                    ],
                    [
                        9.7787275,
                        53.9667963
                    ],
                    [
                        9.7784515,
                        53.9666309
                    ],
                    [
                        9.7779939,
                        53.9663452
                    ],
                    [
                        9.7770251,
                        53.9656983
                    ],
                    [
                        9.7766658,
                        53.9654366
                    ],
                    [
                        9.7764443,
                        53.9652695
                    ],
                    [
                        9.7762625,
                        53.9651319
                    ],
                    [
                        9.7756976,
                        53.964683
                    ],
                    [
                        9.7750561,
                        53.9641268
                    ],
                    [
                        9.7745858,
                        53.96368
                    ],
                    [
                        9.7737992,
                        53.9628762
                    ],
                    [
                        9.7732635,
                        53.9622651
                    ],
                    [
                        9.7722281,
                        53.9610481
                    ],
                    [
                        9.7684898,
                        53.9566292
                    ],
                    [
                        9.7676596,
                        53.9556508
                    ],
                    [
                        9.7637883,
                        53.9510711
                    ],
                    [
                        9.7604375,
                        53.9471032
                    ],
                    [
                        9.7603834,
                        53.9470415
                    ],
                    [
                        9.7571793,
                        53.9432593
                    ],
                    [
                        9.7569904,
                        53.9430327
                    ],
                    [
                        9.756894,
                        53.9429148
                    ],
                    [
                        9.7563894,
                        53.9423322
                    ],
                    [
                        9.7552166,
                        53.9409333
                    ],
                    [
                        9.7549152,
                        53.9405779
                    ],
                    [
                        9.7548193,
                        53.9404666
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "8a177ecf-1ef4-47c2-bdd3-362290f9ba3b",
            "railwayEdgeName": "E3",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 1644.9028970646448,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9348758,
                        53.5525635
                    ],
                    [
                        9.9348761,
                        53.5525677
                    ],
                    [
                        9.9348761,
                        53.5525714
                    ],
                    [
                        9.9348952,
                        53.5530074
                    ],
                    [
                        9.9348983,
                        53.5530832
                    ],
                    [
                        9.9349,
                        53.5531763
                    ],
                    [
                        9.9349135,
                        53.5535046
                    ],
                    [
                        9.9349213,
                        53.5536882
                    ],
                    [
                        9.9349247,
                        53.5537698
                    ],
                    [
                        9.9349783,
                        53.5550164
                    ],
                    [
                        9.9349787,
                        53.5550231
                    ],
                    [
                        9.9349793,
                        53.5550361
                    ],
                    [
                        9.9349993,
                        53.5554354
                    ],
                    [
                        9.9350081,
                        53.5555806
                    ],
                    [
                        9.9350101,
                        53.5557217
                    ],
                    [
                        9.9350194,
                        53.5559534
                    ],
                    [
                        9.9350206,
                        53.5559987
                    ],
                    [
                        9.9350205,
                        53.5560207
                    ],
                    [
                        9.9350225,
                        53.5561959
                    ],
                    [
                        9.9350202,
                        53.556276
                    ],
                    [
                        9.9350073,
                        53.5564703
                    ],
                    [
                        9.935002,
                        53.5566072
                    ],
                    [
                        9.9349452,
                        53.556851
                    ],
                    [
                        9.9348702,
                        53.5570316
                    ],
                    [
                        9.9347753,
                        53.5572034
                    ],
                    [
                        9.9346258,
                        53.5574099
                    ],
                    [
                        9.9344609,
                        53.5576036
                    ],
                    [
                        9.9342837,
                        53.5578061
                    ],
                    [
                        9.9340824,
                        53.5579835
                    ],
                    [
                        9.9338544,
                        53.5581811
                    ],
                    [
                        9.9336236,
                        53.558364
                    ],
                    [
                        9.9334245,
                        53.5585305
                    ],
                    [
                        9.9332531,
                        53.5586997
                    ],
                    [
                        9.9331287,
                        53.5588307
                    ],
                    [
                        9.9330095,
                        53.558996
                    ],
                    [
                        9.9329353,
                        53.5591136
                    ],
                    [
                        9.9328739,
                        53.5592262
                    ],
                    [
                        9.9328073,
                        53.5593803
                    ],
                    [
                        9.9327599,
                        53.5595258
                    ],
                    [
                        9.9327257,
                        53.5596593
                    ],
                    [
                        9.9327128,
                        53.5597949
                    ],
                    [
                        9.9326932,
                        53.560143
                    ],
                    [
                        9.9327308,
                        53.5603742
                    ],
                    [
                        9.9327538,
                        53.5604631
                    ],
                    [
                        9.9328084,
                        53.5606103
                    ],
                    [
                        9.932815,
                        53.5606305
                    ],
                    [
                        9.9329281,
                        53.5608795
                    ],
                    [
                        9.9330366,
                        53.5610814
                    ],
                    [
                        9.9332674,
                        53.5613583
                    ],
                    [
                        9.933578,
                        53.5616486
                    ],
                    [
                        9.9339262,
                        53.5619245
                    ],
                    [
                        9.9344715,
                        53.5622462
                    ],
                    [
                        9.9346159,
                        53.5623136
                    ],
                    [
                        9.9349853,
                        53.5624859
                    ],
                    [
                        9.9353248,
                        53.5626056
                    ],
                    [
                        9.9356441,
                        53.5626972
                    ],
                    [
                        9.93595,
                        53.5627662
                    ],
                    [
                        9.9362776,
                        53.5628184
                    ],
                    [
                        9.9366121,
                        53.5628616
                    ],
                    [
                        9.9367474,
                        53.5628743
                    ],
                    [
                        9.9367588,
                        53.5628754
                    ],
                    [
                        9.9377889,
                        53.5629524
                    ],
                    [
                        9.9379149,
                        53.5629609
                    ],
                    [
                        9.9385625,
                        53.5630048
                    ],
                    [
                        9.9390337,
                        53.5630318
                    ],
                    [
                        9.9394465,
                        53.5630481
                    ],
                    [
                        9.9399531,
                        53.5630585
                    ],
                    [
                        9.9404809,
                        53.5630458
                    ],
                    [
                        9.9407902,
                        53.5630376
                    ],
                    [
                        9.9410902,
                        53.5630222
                    ],
                    [
                        9.9412634,
                        53.5630124
                    ],
                    [
                        9.9413147,
                        53.5630086
                    ],
                    [
                        9.9416552,
                        53.5629822
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "f4bdd39c-58e2-45da-a12e-37893fc260cf",
            "railwayEdgeName": "E54",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 53.67347787292995,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9813629,
                        54.0789797
                    ],
                    [
                        9.9815931,
                        54.0794427
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "54ba477c-045a-4da6-8aa2-37e7812365e6",
            "railwayEdgeName": "E24",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 2298.54225437856,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9791762,
                        54.0743753
                    ],
                    [
                        9.9791889,
                        54.0744587
                    ],
                    [
                        9.9792049,
                        54.0745888
                    ],
                    [
                        9.9792145,
                        54.0746846
                    ],
                    [
                        9.9792194,
                        54.0747787
                    ],
                    [
                        9.9792272,
                        54.074895
                    ],
                    [
                        9.9792355,
                        54.0749852
                    ],
                    [
                        9.9792411,
                        54.0750208
                    ],
                    [
                        9.9792582,
                        54.0751424
                    ],
                    [
                        9.9792826,
                        54.0752692
                    ],
                    [
                        9.9793768,
                        54.0755859
                    ],
                    [
                        9.9794022,
                        54.0756483
                    ],
                    [
                        9.9795958,
                        54.0760669
                    ],
                    [
                        9.9797176,
                        54.0762943
                    ],
                    [
                        9.9797884,
                        54.0764237
                    ],
                    [
                        9.9798773,
                        54.0765818
                    ],
                    [
                        9.9799807,
                        54.0767323
                    ],
                    [
                        9.980116,
                        54.0769102
                    ],
                    [
                        9.9802105,
                        54.0770366
                    ],
                    [
                        9.9803515,
                        54.0772308
                    ],
                    [
                        9.9804368,
                        54.0773645
                    ],
                    [
                        9.9805284,
                        54.0775221
                    ],
                    [
                        9.9806034,
                        54.0776691
                    ],
                    [
                        9.9806751,
                        54.0778346
                    ],
                    [
                        9.9807435,
                        54.0780106
                    ],
                    [
                        9.9808344,
                        54.0782764
                    ],
                    [
                        9.9808612,
                        54.0783563
                    ],
                    [
                        9.9809658,
                        54.0786183
                    ],
                    [
                        9.9810749,
                        54.0788605
                    ],
                    [
                        9.9811077,
                        54.078931
                    ],
                    [
                        9.9811547,
                        54.0790298
                    ],
                    [
                        9.9812398,
                        54.0792504
                    ],
                    [
                        9.9812974,
                        54.0794227
                    ],
                    [
                        9.9813767,
                        54.0796371
                    ],
                    [
                        9.9814261,
                        54.0797832
                    ],
                    [
                        9.9815638,
                        54.0801836
                    ],
                    [
                        9.9816043,
                        54.0803035
                    ],
                    [
                        9.9816258,
                        54.0803885
                    ],
                    [
                        9.9816462,
                        54.0805412
                    ],
                    [
                        9.9816461,
                        54.0805834
                    ],
                    [
                        9.9816492,
                        54.0807511
                    ],
                    [
                        9.981625,
                        54.0811209
                    ],
                    [
                        9.9816044,
                        54.0813573
                    ],
                    [
                        9.9815805,
                        54.0815061
                    ],
                    [
                        9.9815688,
                        54.081558
                    ],
                    [
                        9.9815427,
                        54.0816439
                    ],
                    [
                        9.9815199,
                        54.0817028
                    ],
                    [
                        9.9814831,
                        54.0817727
                    ],
                    [
                        9.981439,
                        54.0818432
                    ],
                    [
                        9.9813466,
                        54.0819775
                    ],
                    [
                        9.9811247,
                        54.0822975
                    ],
                    [
                        9.9808431,
                        54.0826127
                    ],
                    [
                        9.9805598,
                        54.0828964
                    ],
                    [
                        9.9804579,
                        54.0829898
                    ],
                    [
                        9.9802599,
                        54.0831605
                    ],
                    [
                        9.9801859,
                        54.0832186
                    ],
                    [
                        9.9800323,
                        54.0833285
                    ],
                    [
                        9.9798014,
                        54.0834921
                    ],
                    [
                        9.9795157,
                        54.0836643
                    ],
                    [
                        9.9792742,
                        54.0837935
                    ],
                    [
                        9.979125,
                        54.0838635
                    ],
                    [
                        9.9789701,
                        54.0839372
                    ],
                    [
                        9.978815,
                        54.084003
                    ],
                    [
                        9.9786564,
                        54.0840672
                    ],
                    [
                        9.9784021,
                        54.0841721
                    ],
                    [
                        9.9783555,
                        54.0841886
                    ],
                    [
                        9.9780391,
                        54.0843008
                    ],
                    [
                        9.9779508,
                        54.0843268
                    ],
                    [
                        9.9777085,
                        54.0843981
                    ],
                    [
                        9.9773205,
                        54.0844961
                    ],
                    [
                        9.9770352,
                        54.0845586
                    ],
                    [
                        9.9766468,
                        54.0846292
                    ],
                    [
                        9.9762591,
                        54.0846885
                    ],
                    [
                        9.9759742,
                        54.0847238
                    ],
                    [
                        9.9757917,
                        54.0847395
                    ],
                    [
                        9.9756003,
                        54.0847554
                    ],
                    [
                        9.9752914,
                        54.084767
                    ],
                    [
                        9.9749324,
                        54.0847736
                    ],
                    [
                        9.9746975,
                        54.0847762
                    ],
                    [
                        9.9744876,
                        54.0847684
                    ],
                    [
                        9.9739322,
                        54.0847346
                    ],
                    [
                        9.9731736,
                        54.084657
                    ],
                    [
                        9.972424,
                        54.0845651
                    ],
                    [
                        9.9702933,
                        54.0843103
                    ],
                    [
                        9.962895,
                        54.0834308
                    ],
                    [
                        9.9619839,
                        54.0833297
                    ],
                    [
                        9.9618543,
                        54.0833133
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "87fdb318-b4cb-49ab-b1d6-4544cdb87c75",
            "railwayEdgeName": "E71",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 113.52581045844607,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9853095,
                        54.0920134
                    ],
                    [
                        9.9852918,
                        54.0919559
                    ],
                    [
                        9.98507,
                        54.0912286
                    ],
                    [
                        9.9850034,
                        54.0910091
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "7dd80fbb-e897-402f-9f15-4d9aff084ccb",
            "railwayEdgeName": "E75",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 843.7508208328967,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8129352,
                        53.9845251
                    ],
                    [
                        9.8136768,
                        53.9849612
                    ],
                    [
                        9.8138925,
                        53.9850743
                    ],
                    [
                        9.8151664,
                        53.9857331
                    ],
                    [
                        9.815247,
                        53.9857744
                    ],
                    [
                        9.8157732,
                        53.9860465
                    ],
                    [
                        9.819516,
                        53.9879378
                    ],
                    [
                        9.8212858,
                        53.9888895
                    ],
                    [
                        9.8215297,
                        53.9890107
                    ],
                    [
                        9.821784,
                        53.9891329
                    ],
                    [
                        9.8221659,
                        53.9893044
                    ],
                    [
                        9.8223891,
                        53.989406
                    ],
                    [
                        9.8226131,
                        53.9895183
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "9b0e6197-022f-4ae4-84a7-4eecf23d693f",
            "railwayEdgeName": "E36",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 2218.1969491357813,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9283617,
                        53.5595659
                    ],
                    [
                        9.9286988,
                        53.5595786
                    ],
                    [
                        9.9288902,
                        53.5595871
                    ],
                    [
                        9.9290855,
                        53.5595979
                    ],
                    [
                        9.9293275,
                        53.5596209
                    ],
                    [
                        9.9295453,
                        53.5596471
                    ],
                    [
                        9.9297092,
                        53.5596724
                    ],
                    [
                        9.9298678,
                        53.559704
                    ],
                    [
                        9.9300168,
                        53.5597358
                    ],
                    [
                        9.9301632,
                        53.5597724
                    ],
                    [
                        9.9303139,
                        53.559814
                    ],
                    [
                        9.930462,
                        53.5598603
                    ],
                    [
                        9.9306284,
                        53.559916
                    ],
                    [
                        9.9307627,
                        53.5599645
                    ],
                    [
                        9.9308923,
                        53.5600156
                    ],
                    [
                        9.9310192,
                        53.5600723
                    ],
                    [
                        9.9311569,
                        53.5601373
                    ],
                    [
                        9.9312853,
                        53.5602048
                    ],
                    [
                        9.9314359,
                        53.560301
                    ],
                    [
                        9.9315784,
                        53.5603987
                    ],
                    [
                        9.9317109,
                        53.560511
                    ],
                    [
                        9.9318053,
                        53.5606036
                    ],
                    [
                        9.9319037,
                        53.5607106
                    ],
                    [
                        9.9319734,
                        53.5607943
                    ],
                    [
                        9.9322873,
                        53.5612023
                    ],
                    [
                        9.9324385,
                        53.5613883
                    ],
                    [
                        9.9326237,
                        53.5615978
                    ],
                    [
                        9.9328429,
                        53.5618116
                    ],
                    [
                        9.9329024,
                        53.5618642
                    ],
                    [
                        9.9330307,
                        53.5619774
                    ],
                    [
                        9.9332744,
                        53.5622033
                    ],
                    [
                        9.9333779,
                        53.5623104
                    ],
                    [
                        9.9335342,
                        53.5624881
                    ],
                    [
                        9.9335997,
                        53.5625779
                    ],
                    [
                        9.9336428,
                        53.5626425
                    ],
                    [
                        9.933723,
                        53.5628026
                    ],
                    [
                        9.9337665,
                        53.5629283
                    ],
                    [
                        9.9337918,
                        53.563062
                    ],
                    [
                        9.9338007,
                        53.5631575
                    ],
                    [
                        9.9338058,
                        53.5634118
                    ],
                    [
                        9.9337878,
                        53.5636035
                    ],
                    [
                        9.9337663,
                        53.5637842
                    ],
                    [
                        9.9336574,
                        53.5648126
                    ],
                    [
                        9.9335934,
                        53.5653769
                    ],
                    [
                        9.9335179,
                        53.5661508
                    ],
                    [
                        9.9334801,
                        53.5664437
                    ],
                    [
                        9.9334512,
                        53.5666021
                    ],
                    [
                        9.9334483,
                        53.5666289
                    ],
                    [
                        9.9334222,
                        53.5668783
                    ],
                    [
                        9.9334182,
                        53.5669692
                    ],
                    [
                        9.9334155,
                        53.566989
                    ],
                    [
                        9.9333757,
                        53.5672791
                    ],
                    [
                        9.9333473,
                        53.5675013
                    ],
                    [
                        9.9332314,
                        53.5685525
                    ],
                    [
                        9.933213,
                        53.568721
                    ],
                    [
                        9.9332043,
                        53.5688146
                    ],
                    [
                        9.9331425,
                        53.5693814
                    ],
                    [
                        9.9331265,
                        53.5695976
                    ],
                    [
                        9.9331027,
                        53.5698551
                    ],
                    [
                        9.933063,
                        53.5701887
                    ],
                    [
                        9.9329916,
                        53.5707371
                    ],
                    [
                        9.9329084,
                        53.5712231
                    ],
                    [
                        9.9327201,
                        53.5721453
                    ],
                    [
                        9.9326181,
                        53.5724311
                    ],
                    [
                        9.9324523,
                        53.5727499
                    ],
                    [
                        9.9322755,
                        53.5729982
                    ],
                    [
                        9.9319835,
                        53.5733421
                    ],
                    [
                        9.9315933,
                        53.5737692
                    ],
                    [
                        9.931128,
                        53.5742462
                    ],
                    [
                        9.9304935,
                        53.5748293
                    ],
                    [
                        9.9304511,
                        53.5748686
                    ],
                    [
                        9.9298272,
                        53.5754226
                    ],
                    [
                        9.929095,
                        53.5760419
                    ],
                    [
                        9.9288318,
                        53.5762438
                    ],
                    [
                        9.928632,
                        53.5764263
                    ],
                    [
                        9.9285806,
                        53.5764732
                    ],
                    [
                        9.9282065,
                        53.5768394
                    ],
                    [
                        9.9280216,
                        53.5770445
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "921ab941-ec16-4bcc-b3af-51bad7e80e1c",
            "railwayEdgeName": "E35",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 826.9563677514024,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.6829949,
                        53.8551984
                    ],
                    [
                        9.6831323,
                        53.8553577
                    ],
                    [
                        9.6836179,
                        53.8559427
                    ],
                    [
                        9.6856352,
                        53.8583435
                    ],
                    [
                        9.6880704,
                        53.8612463
                    ],
                    [
                        9.6885854,
                        53.8618558
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "70a2bb61-cf4e-476b-8db2-51f6a428e0ba",
            "railwayEdgeName": "E72",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 307.56385087625705,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7493103,
                        53.9340205
                    ],
                    [
                        9.749468,
                        53.9342605
                    ],
                    [
                        9.7495338,
                        53.9343681
                    ],
                    [
                        9.749595,
                        53.9344697
                    ],
                    [
                        9.7497165,
                        53.9346669
                    ],
                    [
                        9.7498155,
                        53.9348268
                    ],
                    [
                        9.7499078,
                        53.9349922
                    ],
                    [
                        9.7499943,
                        53.9351646
                    ],
                    [
                        9.7500618,
                        53.9353654
                    ],
                    [
                        9.7501015,
                        53.935521
                    ],
                    [
                        9.7501293,
                        53.9356917
                    ],
                    [
                        9.7501485,
                        53.9358349
                    ],
                    [
                        9.7501518,
                        53.9360059
                    ],
                    [
                        9.7501422,
                        53.9361676
                    ],
                    [
                        9.7501135,
                        53.9363407
                    ],
                    [
                        9.7500905,
                        53.9364315
                    ],
                    [
                        9.7500726,
                        53.9365162
                    ],
                    [
                        9.7500574,
                        53.9365677
                    ],
                    [
                        9.7500178,
                        53.936703
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "476a3700-a98f-44fa-b557-5e3fe68dcc78",
            "railwayEdgeName": "E49",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 781.6568428042298,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9821678,
                        54.0824004
                    ],
                    [
                        9.9822005,
                        54.0825322
                    ],
                    [
                        9.9823471,
                        54.083015
                    ],
                    [
                        9.9824561,
                        54.0833677
                    ],
                    [
                        9.9826895,
                        54.0841169
                    ],
                    [
                        9.9839916,
                        54.08839
                    ],
                    [
                        9.9841006,
                        54.0887503
                    ],
                    [
                        9.9842724,
                        54.0893155
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "deba2f3e-0ad6-4738-b61a-6a79dee9e199",
            "railwayEdgeName": "E19",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 271.4306639675083,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9456612,
                        53.5624754
                    ],
                    [
                        9.9451492,
                        53.562555
                    ],
                    [
                        9.9441257,
                        53.5627
                    ],
                    [
                        9.9438163,
                        53.5627417
                    ],
                    [
                        9.9431665,
                        53.5628276
                    ],
                    [
                        9.942837,
                        53.5628657
                    ],
                    [
                        9.9425214,
                        53.562899
                    ],
                    [
                        9.9423421,
                        53.5629186
                    ],
                    [
                        9.9418325,
                        53.5629688
                    ],
                    [
                        9.9416552,
                        53.5629822
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "4b37b5ef-9503-4ad7-b8ed-6e2c1bcb2579",
            "railwayEdgeName": "E58",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 915.0861537700581,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9821848,
                        54.0820285
                    ],
                    [
                        9.9823777,
                        54.082654
                    ],
                    [
                        9.9824801,
                        54.0829938
                    ],
                    [
                        9.9828208,
                        54.0841011
                    ],
                    [
                        9.9842358,
                        54.0887461
                    ],
                    [
                        9.9843688,
                        54.0892787
                    ],
                    [
                        9.9844101,
                        54.0894921
                    ],
                    [
                        9.9845795,
                        54.0901305
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "52411956-223c-4c11-a645-6e829ffeab50",
            "railwayEdgeName": "E28",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 87.71545682441248,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9810934,
                        54.0782075
                    ],
                    [
                        9.9811975,
                        54.0785187
                    ],
                    [
                        9.981253,
                        54.0786643
                    ],
                    [
                        9.9813629,
                        54.0789797
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "94ab70d6-8c95-452a-ba9b-70dac21b7969",
            "railwayEdgeName": "E59",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 822.5066077579395,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9821848,
                        54.0820285
                    ],
                    [
                        9.9822078,
                        54.0821845
                    ],
                    [
                        9.9822266,
                        54.0823316
                    ],
                    [
                        9.9822459,
                        54.0824349
                    ],
                    [
                        9.982272,
                        54.082539
                    ],
                    [
                        9.982307,
                        54.0826594
                    ],
                    [
                        9.9824119,
                        54.0830037
                    ],
                    [
                        9.9827553,
                        54.0841065
                    ],
                    [
                        9.9840571,
                        54.0883823
                    ],
                    [
                        9.9841626,
                        54.0887487
                    ],
                    [
                        9.9842724,
                        54.0893155
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "13e0275f-6d6f-45b7-b6a2-7247959aaa3e",
            "railwayEdgeName": "E37",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 2080.8540260977834,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9416552,
                        53.5629822
                    ],
                    [
                        9.9413141,
                        53.5629967
                    ],
                    [
                        9.9410531,
                        53.5630001
                    ],
                    [
                        9.9408186,
                        53.5629957
                    ],
                    [
                        9.9405715,
                        53.562986
                    ],
                    [
                        9.940314,
                        53.5629618
                    ],
                    [
                        9.9400178,
                        53.5629249
                    ],
                    [
                        9.9396588,
                        53.5628623
                    ],
                    [
                        9.9391873,
                        53.5627721
                    ],
                    [
                        9.9387902,
                        53.5627049
                    ],
                    [
                        9.9384858,
                        53.5626667
                    ],
                    [
                        9.9381513,
                        53.5626382
                    ],
                    [
                        9.9380284,
                        53.5626342
                    ],
                    [
                        9.9378968,
                        53.56263
                    ],
                    [
                        9.937671,
                        53.5626308
                    ],
                    [
                        9.9373936,
                        53.5626439
                    ],
                    [
                        9.9370993,
                        53.5626711
                    ],
                    [
                        9.9367344,
                        53.5627281
                    ],
                    [
                        9.9364629,
                        53.5627898
                    ],
                    [
                        9.9361583,
                        53.5628816
                    ],
                    [
                        9.9358467,
                        53.5630045
                    ],
                    [
                        9.9355615,
                        53.5631549
                    ],
                    [
                        9.9353189,
                        53.5633187
                    ],
                    [
                        9.935148,
                        53.5634698
                    ],
                    [
                        9.9350606,
                        53.56356
                    ],
                    [
                        9.9349812,
                        53.5636663
                    ],
                    [
                        9.9348674,
                        53.5638391
                    ],
                    [
                        9.9348287,
                        53.5639171
                    ],
                    [
                        9.9348243,
                        53.5639275
                    ],
                    [
                        9.9348124,
                        53.5639554
                    ],
                    [
                        9.934794,
                        53.5639985
                    ],
                    [
                        9.9346786,
                        53.564417
                    ],
                    [
                        9.9346576,
                        53.5645138
                    ],
                    [
                        9.9346028,
                        53.5647661
                    ],
                    [
                        9.9344988,
                        53.5652747
                    ],
                    [
                        9.934338,
                        53.5664102
                    ],
                    [
                        9.9342737,
                        53.5666811
                    ],
                    [
                        9.9342076,
                        53.5669166
                    ],
                    [
                        9.9340064,
                        53.5676059
                    ],
                    [
                        9.9338874,
                        53.5680555
                    ],
                    [
                        9.9338485,
                        53.5682191
                    ],
                    [
                        9.933847,
                        53.5682283
                    ],
                    [
                        9.9338191,
                        53.5684116
                    ],
                    [
                        9.9337876,
                        53.5686473
                    ],
                    [
                        9.9337838,
                        53.5687923
                    ],
                    [
                        9.9337563,
                        53.5690485
                    ],
                    [
                        9.9337319,
                        53.569675
                    ],
                    [
                        9.9337197,
                        53.5699201
                    ],
                    [
                        9.9336735,
                        53.5702451
                    ],
                    [
                        9.9336649,
                        53.5703057
                    ],
                    [
                        9.9336079,
                        53.570549
                    ],
                    [
                        9.9334999,
                        53.5708663
                    ],
                    [
                        9.933436,
                        53.5710093
                    ],
                    [
                        9.9334266,
                        53.5710302
                    ],
                    [
                        9.9332637,
                        53.5713268
                    ],
                    [
                        9.9331801,
                        53.5714581
                    ],
                    [
                        9.9329421,
                        53.5717783
                    ],
                    [
                        9.9326095,
                        53.5721566
                    ],
                    [
                        9.9325876,
                        53.5721794
                    ],
                    [
                        9.9319591,
                        53.572834
                    ],
                    [
                        9.9316609,
                        53.5731288
                    ],
                    [
                        9.930819,
                        53.5739774
                    ],
                    [
                        9.9301398,
                        53.5746728
                    ],
                    [
                        9.9297364,
                        53.5750962
                    ],
                    [
                        9.9296811,
                        53.5751542
                    ],
                    [
                        9.9292457,
                        53.5756098
                    ],
                    [
                        9.9289198,
                        53.575962
                    ],
                    [
                        9.9284592,
                        53.5764998
                    ],
                    [
                        9.9280216,
                        53.5770445
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "57741d2b-9e8c-480c-98bc-7bae4ca2700a",
            "railwayEdgeName": "E7",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 1376.31849655314,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9354462,
                        53.5525571
                    ],
                    [
                        9.9354464,
                        53.5525609
                    ],
                    [
                        9.9354715,
                        53.5530698
                    ],
                    [
                        9.9354775,
                        53.5531705
                    ],
                    [
                        9.935491,
                        53.5534988
                    ],
                    [
                        9.935504,
                        53.5537591
                    ],
                    [
                        9.9355301,
                        53.5543216
                    ],
                    [
                        9.9355329,
                        53.5543818
                    ],
                    [
                        9.9355659,
                        53.5553991
                    ],
                    [
                        9.9355843,
                        53.5559687
                    ],
                    [
                        9.9356121,
                        53.5563852
                    ],
                    [
                        9.9356422,
                        53.5568545
                    ],
                    [
                        9.9356619,
                        53.5573781
                    ],
                    [
                        9.9356751,
                        53.557664
                    ],
                    [
                        9.9356832,
                        53.5580309
                    ],
                    [
                        9.9356594,
                        53.5583116
                    ],
                    [
                        9.9355926,
                        53.5588656
                    ],
                    [
                        9.9355913,
                        53.5588765
                    ],
                    [
                        9.9355231,
                        53.5594414
                    ],
                    [
                        9.9355361,
                        53.5597542
                    ],
                    [
                        9.9355424,
                        53.5599075
                    ],
                    [
                        9.9355752,
                        53.5601624
                    ],
                    [
                        9.9356855,
                        53.5604754
                    ],
                    [
                        9.9358163,
                        53.5607131
                    ],
                    [
                        9.9359165,
                        53.5608667
                    ],
                    [
                        9.9359587,
                        53.5609315
                    ],
                    [
                        9.9361187,
                        53.5611251
                    ],
                    [
                        9.9363309,
                        53.5613417
                    ],
                    [
                        9.9365356,
                        53.5615131
                    ],
                    [
                        9.9368073,
                        53.5617164
                    ],
                    [
                        9.937098,
                        53.5618922
                    ],
                    [
                        9.9374108,
                        53.5620651
                    ],
                    [
                        9.9379827,
                        53.5623156
                    ],
                    [
                        9.938338,
                        53.5624371
                    ],
                    [
                        9.9387568,
                        53.5625445
                    ],
                    [
                        9.9387797,
                        53.5625513
                    ],
                    [
                        9.9388699,
                        53.5625731
                    ],
                    [
                        9.9388986,
                        53.56258
                    ],
                    [
                        9.939458,
                        53.5626985
                    ],
                    [
                        9.9397795,
                        53.5627625
                    ],
                    [
                        9.9399635,
                        53.5627991
                    ],
                    [
                        9.9401356,
                        53.5628294
                    ],
                    [
                        9.9402435,
                        53.5628467
                    ],
                    [
                        9.9403631,
                        53.562863
                    ],
                    [
                        9.9405091,
                        53.5628825
                    ],
                    [
                        9.9406776,
                        53.5629003
                    ],
                    [
                        9.9409944,
                        53.5629238
                    ],
                    [
                        9.9413113,
                        53.5629409
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "e83a8d8e-2329-42ce-95fe-7da691099249",
            "railwayEdgeName": "E63",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 21223.42873190756,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7462249,
                        53.9303097
                    ],
                    [
                        9.7461298,
                        53.9301962
                    ],
                    [
                        9.7461273,
                        53.9301932
                    ],
                    [
                        9.7461067,
                        53.9301686
                    ],
                    [
                        9.745928,
                        53.929955
                    ],
                    [
                        9.7458596,
                        53.9298716
                    ],
                    [
                        9.7455868,
                        53.9295406
                    ],
                    [
                        9.7449451,
                        53.9287826
                    ],
                    [
                        9.7438388,
                        53.9274748
                    ],
                    [
                        9.7428268,
                        53.926279
                    ],
                    [
                        9.7418579,
                        53.9251299
                    ],
                    [
                        9.737016,
                        53.9193934
                    ],
                    [
                        9.7348943,
                        53.9168786
                    ],
                    [
                        9.7313048,
                        53.9126314
                    ],
                    [
                        9.7293628,
                        53.9103323
                    ],
                    [
                        9.7277451,
                        53.9084094
                    ],
                    [
                        9.725337,
                        53.9055616
                    ],
                    [
                        9.7243175,
                        53.904352
                    ],
                    [
                        9.7242818,
                        53.9043111
                    ],
                    [
                        9.7180685,
                        53.8969458
                    ],
                    [
                        9.717528,
                        53.8963029
                    ],
                    [
                        9.7170841,
                        53.8957779
                    ],
                    [
                        9.7166207,
                        53.89523
                    ],
                    [
                        9.7151958,
                        53.8935394
                    ],
                    [
                        9.7130577,
                        53.8909997
                    ],
                    [
                        9.712908,
                        53.8908243
                    ],
                    [
                        9.7128694,
                        53.890778
                    ],
                    [
                        9.7118704,
                        53.8895923
                    ],
                    [
                        9.7089956,
                        53.8861869
                    ],
                    [
                        9.7058911,
                        53.8824985
                    ],
                    [
                        9.7033689,
                        53.8795052
                    ],
                    [
                        9.7033184,
                        53.8794424
                    ],
                    [
                        9.7019802,
                        53.8778566
                    ],
                    [
                        9.6985887,
                        53.8738293
                    ],
                    [
                        9.6976371,
                        53.8726933
                    ],
                    [
                        9.6922673,
                        53.8663093
                    ],
                    [
                        9.6908758,
                        53.8646591
                    ],
                    [
                        9.6892165,
                        53.8626844
                    ],
                    [
                        9.6886452,
                        53.8620141
                    ],
                    [
                        9.6880093,
                        53.8612585
                    ],
                    [
                        9.6855702,
                        53.8583596
                    ],
                    [
                        9.6835512,
                        53.8559561
                    ],
                    [
                        9.681686,
                        53.8537448
                    ],
                    [
                        9.6812979,
                        53.853291
                    ],
                    [
                        9.6810108,
                        53.8529535
                    ],
                    [
                        9.6807088,
                        53.8525943
                    ],
                    [
                        9.6806286,
                        53.8524994
                    ],
                    [
                        9.6805981,
                        53.8524633
                    ],
                    [
                        9.6805616,
                        53.8524215
                    ],
                    [
                        9.680521,
                        53.8523791
                    ],
                    [
                        9.6803461,
                        53.8521855
                    ],
                    [
                        9.6800226,
                        53.8518273
                    ],
                    [
                        9.6798882,
                        53.8516837
                    ],
                    [
                        9.6797538,
                        53.8515425
                    ],
                    [
                        9.6796421,
                        53.8514264
                    ],
                    [
                        9.6795282,
                        53.8513139
                    ],
                    [
                        9.6793877,
                        53.8511758
                    ],
                    [
                        9.6792959,
                        53.8510863
                    ],
                    [
                        9.6790858,
                        53.8508823
                    ],
                    [
                        9.6789639,
                        53.8507673
                    ],
                    [
                        9.6788424,
                        53.8506594
                    ],
                    [
                        9.6783035,
                        53.850195
                    ],
                    [
                        9.6777626,
                        53.8497355
                    ],
                    [
                        9.6768827,
                        53.8489967
                    ],
                    [
                        9.6762056,
                        53.8484348
                    ],
                    [
                        9.6747392,
                        53.8472034
                    ],
                    [
                        9.6717246,
                        53.8446759
                    ],
                    [
                        9.6681208,
                        53.8416598
                    ],
                    [
                        9.6659817,
                        53.839873
                    ],
                    [
                        9.66488,
                        53.8389488
                    ],
                    [
                        9.664727,
                        53.8388187
                    ],
                    [
                        9.6645782,
                        53.8386994
                    ],
                    [
                        9.6634822,
                        53.8377772
                    ],
                    [
                        9.6594873,
                        53.8344372
                    ],
                    [
                        9.655226,
                        53.8308706
                    ],
                    [
                        9.6496698,
                        53.8262199
                    ],
                    [
                        9.6479516,
                        53.8247808
                    ],
                    [
                        9.6472928,
                        53.824216
                    ],
                    [
                        9.6467317,
                        53.8236989
                    ],
                    [
                        9.646447,
                        53.8234235
                    ],
                    [
                        9.646177,
                        53.8231465
                    ],
                    [
                        9.6456947,
                        53.8226205
                    ],
                    [
                        9.6452411,
                        53.8220808
                    ],
                    [
                        9.6449325,
                        53.8216823
                    ],
                    [
                        9.6445858,
                        53.8211984
                    ],
                    [
                        9.6441131,
                        53.8204623
                    ],
                    [
                        9.6438872,
                        53.8200679
                    ],
                    [
                        9.643679,
                        53.8196715
                    ],
                    [
                        9.6434261,
                        53.8191305
                    ],
                    [
                        9.6431568,
                        53.8184529
                    ],
                    [
                        9.643037,
                        53.8181067
                    ],
                    [
                        9.6429358,
                        53.8177676
                    ],
                    [
                        9.6428569,
                        53.8174797
                    ],
                    [
                        9.6427923,
                        53.8171926
                    ],
                    [
                        9.6427135,
                        53.8168106
                    ],
                    [
                        9.6426547,
                        53.8164327
                    ],
                    [
                        9.64261,
                        53.8160485
                    ],
                    [
                        9.6425811,
                        53.8156609
                    ],
                    [
                        9.6425691,
                        53.8149676
                    ],
                    [
                        9.6425731,
                        53.8148447
                    ],
                    [
                        9.6426016,
                        53.814269
                    ],
                    [
                        9.6426541,
                        53.8137297
                    ],
                    [
                        9.6427395,
                        53.8131565
                    ],
                    [
                        9.6428624,
                        53.8126137
                    ],
                    [
                        9.6430049,
                        53.8120742
                    ],
                    [
                        9.6448573,
                        53.8055052
                    ],
                    [
                        9.6451027,
                        53.8046356
                    ],
                    [
                        9.6454722,
                        53.8033187
                    ],
                    [
                        9.6478116,
                        53.7950074
                    ],
                    [
                        9.6480917,
                        53.7940256
                    ],
                    [
                        9.6488617,
                        53.7912076
                    ],
                    [
                        9.6507893,
                        53.7844498
                    ],
                    [
                        9.6513022,
                        53.7826299
                    ],
                    [
                        9.6514109,
                        53.7822429
                    ],
                    [
                        9.6519274,
                        53.7804166
                    ],
                    [
                        9.6526279,
                        53.7779356
                    ],
                    [
                        9.6536552,
                        53.7742873
                    ],
                    [
                        9.6538006,
                        53.7737771
                    ],
                    [
                        9.653846,
                        53.773603
                    ],
                    [
                        9.6539453,
                        53.7732583
                    ],
                    [
                        9.6543702,
                        53.7717488
                    ],
                    [
                        9.6548002,
                        53.7702225
                    ],
                    [
                        9.6549934,
                        53.7695376
                    ],
                    [
                        9.6550069,
                        53.7694905
                    ],
                    [
                        9.6551808,
                        53.7688903
                    ],
                    [
                        9.6551923,
                        53.7688515
                    ],
                    [
                        9.6554578,
                        53.7679545
                    ],
                    [
                        9.655694,
                        53.7671411
                    ],
                    [
                        9.6565954,
                        53.7640748
                    ],
                    [
                        9.6570608,
                        53.7624286
                    ],
                    [
                        9.6572352,
                        53.7618166
                    ],
                    [
                        9.6577089,
                        53.759905
                    ],
                    [
                        9.657906,
                        53.7592059
                    ],
                    [
                        9.6583485,
                        53.7576388
                    ],
                    [
                        9.6583745,
                        53.7575502
                    ],
                    [
                        9.6585869,
                        53.7568227
                    ],
                    [
                        9.6587612,
                        53.7562223
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "102e706f-81d5-4a49-8b81-7f4d6f98c122",
            "railwayEdgeName": "E69",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 460.0482883763562,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7462249,
                        53.9303097
                    ],
                    [
                        9.7465727,
                        53.9307931
                    ],
                    [
                        9.7467528,
                        53.9310256
                    ],
                    [
                        9.7469389,
                        53.9312359
                    ],
                    [
                        9.7469965,
                        53.931306
                    ],
                    [
                        9.747376,
                        53.9317835
                    ],
                    [
                        9.7482584,
                        53.9328031
                    ],
                    [
                        9.7491695,
                        53.93385
                    ],
                    [
                        9.7493103,
                        53.9340205
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "6aefdd2c-a48a-445c-958d-80328920e713",
            "railwayEdgeName": "E29",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 169.2749675864303,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9023147,
                        53.5982046
                    ],
                    [
                        9.9027855,
                        53.5979627
                    ],
                    [
                        9.9037236,
                        53.5974353
                    ],
                    [
                        9.9042087,
                        53.5971826
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "56c4edb2-e3c0-4324-8109-82a1b27a5cbd",
            "railwayEdgeName": "E38",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 5083.589782795267,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9280216,
                        53.5770445
                    ],
                    [
                        9.9279333,
                        53.5771555
                    ],
                    [
                        9.9276698,
                        53.5775016
                    ],
                    [
                        9.9275152,
                        53.5777047
                    ],
                    [
                        9.9270183,
                        53.5783504
                    ],
                    [
                        9.9265402,
                        53.5789752
                    ],
                    [
                        9.9260448,
                        53.5796228
                    ],
                    [
                        9.9250779,
                        53.580881
                    ],
                    [
                        9.9245036,
                        53.5816377
                    ],
                    [
                        9.9232961,
                        53.5832087
                    ],
                    [
                        9.9224319,
                        53.5843353
                    ],
                    [
                        9.9215063,
                        53.5855489
                    ],
                    [
                        9.9206052,
                        53.5867214
                    ],
                    [
                        9.9202832,
                        53.5871354
                    ],
                    [
                        9.9201945,
                        53.5872446
                    ],
                    [
                        9.919806,
                        53.5877033
                    ],
                    [
                        9.9194138,
                        53.5881477
                    ],
                    [
                        9.9193238,
                        53.5882373
                    ],
                    [
                        9.9189693,
                        53.5885903
                    ],
                    [
                        9.9184703,
                        53.5890596
                    ],
                    [
                        9.9175526,
                        53.5899101
                    ],
                    [
                        9.9172011,
                        53.5902049
                    ],
                    [
                        9.9166837,
                        53.5905901
                    ],
                    [
                        9.9161399,
                        53.5909411
                    ],
                    [
                        9.9151658,
                        53.5914855
                    ],
                    [
                        9.9132409,
                        53.5924951
                    ],
                    [
                        9.9115162,
                        53.5933842
                    ],
                    [
                        9.9106778,
                        53.5938048
                    ],
                    [
                        9.9098008,
                        53.594241
                    ],
                    [
                        9.9095395,
                        53.5943748
                    ],
                    [
                        9.9090407,
                        53.5946344
                    ],
                    [
                        9.9082653,
                        53.5950422
                    ],
                    [
                        9.9075843,
                        53.5954029
                    ],
                    [
                        9.9067825,
                        53.5958199
                    ],
                    [
                        9.9059002,
                        53.5962566
                    ],
                    [
                        9.9055447,
                        53.5964255
                    ],
                    [
                        9.9042392,
                        53.5970541
                    ],
                    [
                        9.9037005,
                        53.5973176
                    ],
                    [
                        9.9031652,
                        53.5975867
                    ],
                    [
                        9.9024708,
                        53.5979374
                    ],
                    [
                        9.9014521,
                        53.5984442
                    ],
                    [
                        9.9007751,
                        53.5987776
                    ],
                    [
                        9.8971195,
                        53.6006104
                    ],
                    [
                        9.8957252,
                        53.6012878
                    ],
                    [
                        9.8939617,
                        53.6021895
                    ],
                    [
                        9.8923801,
                        53.6029951
                    ],
                    [
                        9.8922859,
                        53.6030447
                    ],
                    [
                        9.892268,
                        53.6030515
                    ],
                    [
                        9.8921274,
                        53.6031218
                    ],
                    [
                        9.8918722,
                        53.6032576
                    ],
                    [
                        9.8918077,
                        53.6032915
                    ],
                    [
                        9.8910309,
                        53.6036106
                    ],
                    [
                        9.8906657,
                        53.6037718
                    ],
                    [
                        9.890305,
                        53.603957
                    ],
                    [
                        9.8890214,
                        53.6046146
                    ],
                    [
                        9.887333,
                        53.6054764
                    ],
                    [
                        9.8860806,
                        53.6061209
                    ],
                    [
                        9.8847972,
                        53.6067711
                    ],
                    [
                        9.8832262,
                        53.6075847
                    ],
                    [
                        9.8824865,
                        53.6080116
                    ],
                    [
                        9.881971,
                        53.608282
                    ],
                    [
                        9.8814257,
                        53.6085765
                    ],
                    [
                        9.8808813,
                        53.6089233
                    ],
                    [
                        9.880417,
                        53.6091952
                    ],
                    [
                        9.8793944,
                        53.6097233
                    ],
                    [
                        9.879357,
                        53.6097426
                    ],
                    [
                        9.8786611,
                        53.6100804
                    ],
                    [
                        9.8783744,
                        53.6102441
                    ],
                    [
                        9.8781778,
                        53.6103726
                    ],
                    [
                        9.8778771,
                        53.610541
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "e6008ce4-e16a-49b3-8c40-85d0c8e7bc2c",
            "railwayEdgeName": "E40",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 612.914694262678,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.929778,
                        53.5747766
                    ],
                    [
                        9.9295271,
                        53.5750339
                    ],
                    [
                        9.9294664,
                        53.5750929
                    ],
                    [
                        9.9292857,
                        53.5752902
                    ],
                    [
                        9.9290392,
                        53.5755411
                    ],
                    [
                        9.9287432,
                        53.5758495
                    ],
                    [
                        9.928387,
                        53.576236
                    ],
                    [
                        9.9282239,
                        53.5764314
                    ],
                    [
                        9.9277672,
                        53.576995
                    ],
                    [
                        9.9264558,
                        53.5787155
                    ],
                    [
                        9.9260667,
                        53.5792197
                    ],
                    [
                        9.9256859,
                        53.5797131
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "386b3615-6a2d-4db8-8a52-8634356921a0",
            "railwayEdgeName": "E64",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 287.5617330585349,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8259148,
                        53.9912194
                    ],
                    [
                        9.8257074,
                        53.9911103
                    ],
                    [
                        9.8238572,
                        53.9901564
                    ],
                    [
                        9.8231045,
                        53.9897694
                    ],
                    [
                        9.8230252,
                        53.9897267
                    ],
                    [
                        9.8229527,
                        53.9896886
                    ],
                    [
                        9.8228902,
                        53.9896572
                    ],
                    [
                        9.8226131,
                        53.9895183
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "40936f37-6ae2-4f53-8a56-86f5323d084d",
            "railwayEdgeName": "E22",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 24920.469806013312,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9813629,
                        54.0789797
                    ],
                    [
                        9.9815111,
                        54.0794037
                    ],
                    [
                        9.9815352,
                        54.079474
                    ],
                    [
                        9.9815605,
                        54.079545
                    ],
                    [
                        9.9816398,
                        54.0797866
                    ],
                    [
                        9.9817426,
                        54.0800715
                    ],
                    [
                        9.9818532,
                        54.0803927
                    ],
                    [
                        9.982054,
                        54.0809618
                    ],
                    [
                        9.9823295,
                        54.0818079
                    ],
                    [
                        9.9826826,
                        54.0829654
                    ],
                    [
                        9.9830073,
                        54.0840861
                    ],
                    [
                        9.9835645,
                        54.0859097
                    ],
                    [
                        9.9842056,
                        54.0879797
                    ],
                    [
                        9.9844426,
                        54.0887551
                    ],
                    [
                        9.9848483,
                        54.0900666
                    ],
                    [
                        9.9849354,
                        54.0903627
                    ],
                    [
                        9.9851393,
                        54.0910187
                    ],
                    [
                        9.9857176,
                        54.0929337
                    ],
                    [
                        9.9858646,
                        54.0934311
                    ],
                    [
                        9.9858772,
                        54.0934736
                    ],
                    [
                        9.9859086,
                        54.0935911
                    ],
                    [
                        9.9860529,
                        54.0941228
                    ],
                    [
                        9.9861754,
                        54.094605
                    ],
                    [
                        9.9869802,
                        54.0973345
                    ],
                    [
                        9.9872489,
                        54.0982006
                    ],
                    [
                        9.9883339,
                        54.1017761
                    ],
                    [
                        9.9894108,
                        54.1052942
                    ],
                    [
                        9.9910915,
                        54.1108386
                    ],
                    [
                        9.9922328,
                        54.1145402
                    ],
                    [
                        9.9933962,
                        54.1183488
                    ],
                    [
                        9.9942415,
                        54.1211191
                    ],
                    [
                        9.9948908,
                        54.1232489
                    ],
                    [
                        9.9951257,
                        54.1240143
                    ],
                    [
                        9.9955852,
                        54.1254249
                    ],
                    [
                        9.9957329,
                        54.1257925
                    ],
                    [
                        9.9959248,
                        54.1262353
                    ],
                    [
                        9.996075,
                        54.1265523
                    ],
                    [
                        9.9962827,
                        54.1269519
                    ],
                    [
                        9.9965355,
                        54.1273835
                    ],
                    [
                        9.9966644,
                        54.1275953
                    ],
                    [
                        9.9969791,
                        54.1280741
                    ],
                    [
                        9.9972634,
                        54.1284725
                    ],
                    [
                        9.9975514,
                        54.1288419
                    ],
                    [
                        9.997595,
                        54.1288963
                    ],
                    [
                        9.9976754,
                        54.1290004
                    ],
                    [
                        9.9979485,
                        54.129322
                    ],
                    [
                        9.9982144,
                        54.1296219
                    ],
                    [
                        9.9989102,
                        54.1303341
                    ],
                    [
                        9.9994302,
                        54.1308253
                    ],
                    [
                        9.9999038,
                        54.1312426
                    ],
                    [
                        10.0003926,
                        54.131658
                    ],
                    [
                        10.001137,
                        54.1322269
                    ],
                    [
                        10.0019788,
                        54.1328079
                    ],
                    [
                        10.0031446,
                        54.1335301
                    ],
                    [
                        10.0041934,
                        54.1341829
                    ],
                    [
                        10.0069247,
                        54.1358608
                    ],
                    [
                        10.008405,
                        54.1367968
                    ],
                    [
                        10.0088613,
                        54.1370825
                    ],
                    [
                        10.0091775,
                        54.1373021
                    ],
                    [
                        10.0099769,
                        54.1378912
                    ],
                    [
                        10.010756,
                        54.1385171
                    ],
                    [
                        10.0112858,
                        54.1389843
                    ],
                    [
                        10.0117857,
                        54.1394575
                    ],
                    [
                        10.011855,
                        54.1395259
                    ],
                    [
                        10.0121317,
                        54.1398081
                    ],
                    [
                        10.0124955,
                        54.1402031
                    ],
                    [
                        10.0131195,
                        54.1409411
                    ],
                    [
                        10.0137414,
                        54.1417787
                    ],
                    [
                        10.0142212,
                        54.1424489
                    ],
                    [
                        10.0145972,
                        54.142979
                    ],
                    [
                        10.0167042,
                        54.145989
                    ],
                    [
                        10.0167692,
                        54.1460814
                    ],
                    [
                        10.0204879,
                        54.1513929
                    ],
                    [
                        10.0236214,
                        54.1558754
                    ],
                    [
                        10.0242797,
                        54.1568124
                    ],
                    [
                        10.0280773,
                        54.1622285
                    ],
                    [
                        10.0291218,
                        54.1637507
                    ],
                    [
                        10.0296503,
                        54.164445
                    ],
                    [
                        10.0299437,
                        54.164817
                    ],
                    [
                        10.0301328,
                        54.1650425
                    ],
                    [
                        10.0303989,
                        54.1653437
                    ],
                    [
                        10.0306982,
                        54.1656632
                    ],
                    [
                        10.0311701,
                        54.1661362
                    ],
                    [
                        10.0316948,
                        54.1666445
                    ],
                    [
                        10.0321477,
                        54.1670411
                    ],
                    [
                        10.0322907,
                        54.1671673
                    ],
                    [
                        10.032723,
                        54.1675346
                    ],
                    [
                        10.0330922,
                        54.1678162
                    ],
                    [
                        10.0336043,
                        54.1681935
                    ],
                    [
                        10.0338609,
                        54.1683743
                    ],
                    [
                        10.0342337,
                        54.1686297
                    ],
                    [
                        10.0348883,
                        54.1690604
                    ],
                    [
                        10.0357562,
                        54.1695704
                    ],
                    [
                        10.0367416,
                        54.1701506
                    ],
                    [
                        10.0368616,
                        54.1702232
                    ],
                    [
                        10.0374243,
                        54.170564
                    ],
                    [
                        10.0388139,
                        54.1714029
                    ],
                    [
                        10.040516,
                        54.1723899
                    ],
                    [
                        10.0412998,
                        54.1728486
                    ],
                    [
                        10.0416643,
                        54.1730682
                    ],
                    [
                        10.0426126,
                        54.1736329
                    ],
                    [
                        10.0427661,
                        54.1737234
                    ],
                    [
                        10.0434012,
                        54.1741016
                    ],
                    [
                        10.0437417,
                        54.1743152
                    ],
                    [
                        10.0450873,
                        54.1751175
                    ],
                    [
                        10.0462603,
                        54.1758243
                    ],
                    [
                        10.0471589,
                        54.1763825
                    ],
                    [
                        10.047863,
                        54.1768624
                    ],
                    [
                        10.0482364,
                        54.1771266
                    ],
                    [
                        10.0486068,
                        54.1773987
                    ],
                    [
                        10.0491478,
                        54.177816
                    ],
                    [
                        10.0496613,
                        54.1782512
                    ],
                    [
                        10.0501654,
                        54.1787022
                    ],
                    [
                        10.0506489,
                        54.1791635
                    ],
                    [
                        10.0509656,
                        54.1794952
                    ],
                    [
                        10.0514241,
                        54.1799937
                    ],
                    [
                        10.0517363,
                        54.1803503
                    ],
                    [
                        10.0520242,
                        54.1807092
                    ],
                    [
                        10.0522832,
                        54.1810503
                    ],
                    [
                        10.0524649,
                        54.1813057
                    ],
                    [
                        10.0525299,
                        54.181397
                    ],
                    [
                        10.052956,
                        54.1820602
                    ],
                    [
                        10.0530529,
                        54.1822279
                    ],
                    [
                        10.0531663,
                        54.1824239
                    ],
                    [
                        10.0533131,
                        54.1826977
                    ],
                    [
                        10.0534565,
                        54.1829734
                    ],
                    [
                        10.053538,
                        54.183136
                    ],
                    [
                        10.0536773,
                        54.1834464
                    ],
                    [
                        10.0538081,
                        54.1837561
                    ],
                    [
                        10.053984,
                        54.1842143
                    ],
                    [
                        10.0541376,
                        54.1846715
                    ],
                    [
                        10.0542631,
                        54.1851319
                    ],
                    [
                        10.0543654,
                        54.1855933
                    ],
                    [
                        10.0544258,
                        54.18591
                    ],
                    [
                        10.0544791,
                        54.1862298
                    ],
                    [
                        10.0545407,
                        54.1868734
                    ],
                    [
                        10.054558,
                        54.1872565
                    ],
                    [
                        10.0545549,
                        54.1876452
                    ],
                    [
                        10.0545404,
                        54.187988
                    ],
                    [
                        10.0545176,
                        54.1883325
                    ],
                    [
                        10.0544752,
                        54.1887352
                    ],
                    [
                        10.0544167,
                        54.1891323
                    ],
                    [
                        10.0543521,
                        54.1894598
                    ],
                    [
                        10.0542814,
                        54.189764
                    ],
                    [
                        10.0541539,
                        54.1902312
                    ],
                    [
                        10.0540213,
                        54.1906677
                    ],
                    [
                        10.0537963,
                        54.1913788
                    ],
                    [
                        10.0533908,
                        54.1926368
                    ],
                    [
                        10.0532969,
                        54.1929266
                    ],
                    [
                        10.053148,
                        54.1933229
                    ],
                    [
                        10.0530556,
                        54.1935533
                    ],
                    [
                        10.0529573,
                        54.1937702
                    ],
                    [
                        10.0527532,
                        54.1942162
                    ],
                    [
                        10.0525298,
                        54.1946383
                    ],
                    [
                        10.0522858,
                        54.1950574
                    ],
                    [
                        10.0517084,
                        54.1959514
                    ],
                    [
                        10.0510566,
                        54.1967864
                    ],
                    [
                        10.0507211,
                        54.1971788
                    ],
                    [
                        10.0502737,
                        54.197671
                    ],
                    [
                        10.0494997,
                        54.1984183
                    ],
                    [
                        10.0486394,
                        54.1992085
                    ],
                    [
                        10.044175,
                        54.2032301
                    ],
                    [
                        10.0439197,
                        54.2034601
                    ],
                    [
                        10.0433004,
                        54.204064
                    ],
                    [
                        10.0426823,
                        54.2047819
                    ],
                    [
                        10.0422044,
                        54.2054838
                    ],
                    [
                        10.0417728,
                        54.2062752
                    ],
                    [
                        10.0415626,
                        54.2067447
                    ],
                    [
                        10.0414355,
                        54.2071287
                    ],
                    [
                        10.0412987,
                        54.2077348
                    ],
                    [
                        10.0412318,
                        54.2082557
                    ],
                    [
                        10.0411981,
                        54.2088123
                    ],
                    [
                        10.0412389,
                        54.2092234
                    ],
                    [
                        10.0414335,
                        54.2117372
                    ],
                    [
                        10.0414358,
                        54.2117957
                    ],
                    [
                        10.0415239,
                        54.213486
                    ],
                    [
                        10.041524,
                        54.2136134
                    ],
                    [
                        10.0414572,
                        54.2143111
                    ],
                    [
                        10.0413011,
                        54.2151529
                    ],
                    [
                        10.0409819,
                        54.2167884
                    ],
                    [
                        10.0404151,
                        54.2193283
                    ],
                    [
                        10.0397349,
                        54.2226289
                    ],
                    [
                        10.0396573,
                        54.2233778
                    ],
                    [
                        10.0396847,
                        54.2241713
                    ],
                    [
                        10.0397954,
                        54.2248189
                    ],
                    [
                        10.0399706,
                        54.2254836
                    ],
                    [
                        10.0401791,
                        54.2260072
                    ],
                    [
                        10.0403008,
                        54.2263044
                    ],
                    [
                        10.0405619,
                        54.2267948
                    ],
                    [
                        10.0408082,
                        54.2271912
                    ],
                    [
                        10.0411691,
                        54.2276934
                    ],
                    [
                        10.0413527,
                        54.2279342
                    ],
                    [
                        10.041569,
                        54.2281799
                    ],
                    [
                        10.042023,
                        54.2286681
                    ],
                    [
                        10.0425126,
                        54.2291484
                    ],
                    [
                        10.0430348,
                        54.2295873
                    ],
                    [
                        10.0433243,
                        54.2298062
                    ],
                    [
                        10.0436437,
                        54.2300346
                    ],
                    [
                        10.0439048,
                        54.2302278
                    ],
                    [
                        10.0442662,
                        54.2304616
                    ],
                    [
                        10.0445841,
                        54.2306583
                    ],
                    [
                        10.044936,
                        54.2308609
                    ],
                    [
                        10.0456179,
                        54.2312305
                    ],
                    [
                        10.0467221,
                        54.2317859
                    ],
                    [
                        10.0478333,
                        54.232338
                    ],
                    [
                        10.0486167,
                        54.2327256
                    ],
                    [
                        10.0493641,
                        54.2331109
                    ],
                    [
                        10.0500609,
                        54.2334434
                    ],
                    [
                        10.0515567,
                        54.2341849
                    ],
                    [
                        10.0530753,
                        54.2349401
                    ],
                    [
                        10.053757,
                        54.2352778
                    ],
                    [
                        10.05414,
                        54.2354766
                    ],
                    [
                        10.054361,
                        54.2355912
                    ],
                    [
                        10.0544226,
                        54.2356243
                    ],
                    [
                        10.0550721,
                        54.2359922
                    ],
                    [
                        10.0554742,
                        54.236235
                    ],
                    [
                        10.0558579,
                        54.2364663
                    ],
                    [
                        10.0565544,
                        54.2369588
                    ],
                    [
                        10.0571798,
                        54.2374425
                    ],
                    [
                        10.057812,
                        54.2379918
                    ],
                    [
                        10.0580955,
                        54.2382573
                    ],
                    [
                        10.058691,
                        54.2388592
                    ],
                    [
                        10.060513,
                        54.2407652
                    ],
                    [
                        10.0606193,
                        54.2408773
                    ],
                    [
                        10.0607846,
                        54.2410491
                    ],
                    [
                        10.0624615,
                        54.2428201
                    ],
                    [
                        10.0631963,
                        54.2435996
                    ],
                    [
                        10.0633134,
                        54.2437228
                    ],
                    [
                        10.0647078,
                        54.2451993
                    ],
                    [
                        10.0653372,
                        54.2458799
                    ],
                    [
                        10.0654143,
                        54.2459651
                    ],
                    [
                        10.0657293,
                        54.2463195
                    ],
                    [
                        10.0659702,
                        54.246606
                    ],
                    [
                        10.0663388,
                        54.2470681
                    ],
                    [
                        10.0664808,
                        54.2472566
                    ],
                    [
                        10.0666787,
                        54.2475258
                    ],
                    [
                        10.0670172,
                        54.2480066
                    ],
                    [
                        10.0682803,
                        54.2498899
                    ],
                    [
                        10.0699867,
                        54.252432
                    ],
                    [
                        10.0728753,
                        54.2567377
                    ],
                    [
                        10.0732398,
                        54.2572796
                    ],
                    [
                        10.0734381,
                        54.2575709
                    ],
                    [
                        10.0735943,
                        54.2577902
                    ],
                    [
                        10.0737893,
                        54.2580586
                    ],
                    [
                        10.0740735,
                        54.25843
                    ],
                    [
                        10.0743765,
                        54.2587893
                    ],
                    [
                        10.0745434,
                        54.2589743
                    ],
                    [
                        10.0747249,
                        54.2591634
                    ],
                    [
                        10.0750711,
                        54.2594974
                    ],
                    [
                        10.0753272,
                        54.2597313
                    ],
                    [
                        10.0757356,
                        54.260073
                    ],
                    [
                        10.075957,
                        54.260246
                    ],
                    [
                        10.0761843,
                        54.2604161
                    ],
                    [
                        10.0764394,
                        54.2605985
                    ],
                    [
                        10.0768122,
                        54.2608499
                    ],
                    [
                        10.0772534,
                        54.2611269
                    ],
                    [
                        10.0776997,
                        54.2613861
                    ],
                    [
                        10.078178,
                        54.2616439
                    ],
                    [
                        10.0784932,
                        54.2618032
                    ],
                    [
                        10.0788115,
                        54.2619558
                    ],
                    [
                        10.0791686,
                        54.2621193
                    ],
                    [
                        10.0795383,
                        54.2622785
                    ],
                    [
                        10.0799638,
                        54.2624526
                    ],
                    [
                        10.0804019,
                        54.2626215
                    ],
                    [
                        10.0807958,
                        54.2627674
                    ],
                    [
                        10.0812473,
                        54.2629297
                    ],
                    [
                        10.0824623,
                        54.2633592
                    ],
                    [
                        10.0829208,
                        54.2635255
                    ],
                    [
                        10.0833772,
                        54.2636981
                    ],
                    [
                        10.0836727,
                        54.2638145
                    ],
                    [
                        10.0840989,
                        54.2639909
                    ],
                    [
                        10.084373,
                        54.2641119
                    ],
                    [
                        10.0848281,
                        54.2643284
                    ],
                    [
                        10.0851831,
                        54.2645102
                    ],
                    [
                        10.085468,
                        54.2646647
                    ],
                    [
                        10.0856841,
                        54.264789
                    ],
                    [
                        10.0860889,
                        54.2650356
                    ],
                    [
                        10.0863093,
                        54.2651798
                    ],
                    [
                        10.0865252,
                        54.2653271
                    ],
                    [
                        10.0867463,
                        54.2654862
                    ],
                    [
                        10.0869621,
                        54.2656471
                    ],
                    [
                        10.0872392,
                        54.2658684
                    ],
                    [
                        10.0875076,
                        54.2660989
                    ],
                    [
                        10.0876384,
                        54.2662183
                    ],
                    [
                        10.0878236,
                        54.2663956
                    ],
                    [
                        10.0881008,
                        54.2666783
                    ],
                    [
                        10.0882722,
                        54.2668704
                    ],
                    [
                        10.0883949,
                        54.2670098
                    ],
                    [
                        10.0885595,
                        54.2672094
                    ],
                    [
                        10.0887161,
                        54.2674062
                    ],
                    [
                        10.0889499,
                        54.2677116
                    ],
                    [
                        10.0891756,
                        54.2680226
                    ],
                    [
                        10.0903029,
                        54.2696133
                    ],
                    [
                        10.0913621,
                        54.2711124
                    ],
                    [
                        10.0916826,
                        54.271593
                    ],
                    [
                        10.0917951,
                        54.2717695
                    ],
                    [
                        10.0918977,
                        54.2719401
                    ],
                    [
                        10.0920225,
                        54.2721558
                    ],
                    [
                        10.0921385,
                        54.2723721
                    ],
                    [
                        10.0922425,
                        54.2725819
                    ],
                    [
                        10.0923441,
                        54.2727993
                    ],
                    [
                        10.0924323,
                        54.2730069
                    ],
                    [
                        10.0925152,
                        54.2732162
                    ],
                    [
                        10.0926395,
                        54.2735664
                    ],
                    [
                        10.0927381,
                        54.2738655
                    ],
                    [
                        10.0928542,
                        54.2742324
                    ],
                    [
                        10.0931222,
                        54.2751087
                    ],
                    [
                        10.0933207,
                        54.275736
                    ],
                    [
                        10.0933845,
                        54.2759207
                    ],
                    [
                        10.0935127,
                        54.2762692
                    ],
                    [
                        10.0937343,
                        54.2767925
                    ],
                    [
                        10.0937894,
                        54.2769053
                    ],
                    [
                        10.0938769,
                        54.2770769
                    ],
                    [
                        10.094035,
                        54.277363
                    ],
                    [
                        10.0942271,
                        54.2776797
                    ],
                    [
                        10.0943762,
                        54.277902
                    ],
                    [
                        10.0946166,
                        54.2782311
                    ],
                    [
                        10.0948882,
                        54.2785756
                    ],
                    [
                        10.0951,
                        54.278818
                    ],
                    [
                        10.0953004,
                        54.2790309
                    ],
                    [
                        10.0955026,
                        54.2792321
                    ],
                    [
                        10.095651,
                        54.2793732
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "8b1bb2d7-413a-4ddc-a982-8aa38d0012f2",
            "railwayEdgeName": "E74",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 87.57602055578033,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7940466,
                        53.6575762
                    ],
                    [
                        9.7937058,
                        53.657788
                    ],
                    [
                        9.7934895,
                        53.6579254
                    ],
                    [
                        9.7931419,
                        53.6581513
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "81d309ee-ca5e-41a6-a5d8-9144102c7563",
            "railwayEdgeName": "E79",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 803.6196285702482,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7493103,
                        53.9340205
                    ],
                    [
                        9.7496584,
                        53.9344205
                    ],
                    [
                        9.7498756,
                        53.9346629
                    ],
                    [
                        9.7500708,
                        53.9348724
                    ],
                    [
                        9.7505483,
                        53.9353797
                    ],
                    [
                        9.7509552,
                        53.9358502
                    ],
                    [
                        9.751398,
                        53.9363888
                    ],
                    [
                        9.7535579,
                        53.9390674
                    ],
                    [
                        9.7540381,
                        53.9396616
                    ],
                    [
                        9.7541008,
                        53.9397364
                    ],
                    [
                        9.7543418,
                        53.9399861
                    ],
                    [
                        9.754651,
                        53.9402816
                    ],
                    [
                        9.7548193,
                        53.9404666
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "b3596c69-f6f8-4f83-8f51-93278c3968d0",
            "railwayEdgeName": "E68",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 1263.51648406953,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7548193,
                        53.9404666
                    ],
                    [
                        9.753628,
                        53.9390517
                    ],
                    [
                        9.7514676,
                        53.9363713
                    ],
                    [
                        9.7510787,
                        53.9358891
                    ],
                    [
                        9.7504283,
                        53.9350952
                    ],
                    [
                        9.7488856,
                        53.933237
                    ],
                    [
                        9.748468,
                        53.9327404
                    ],
                    [
                        9.7481733,
                        53.9323892
                    ],
                    [
                        9.7480496,
                        53.9322517
                    ],
                    [
                        9.7475541,
                        53.9317347
                    ],
                    [
                        9.7471023,
                        53.9312724
                    ],
                    [
                        9.7470389,
                        53.9312052
                    ],
                    [
                        9.7466833,
                        53.9308452
                    ],
                    [
                        9.7464708,
                        53.9305882
                    ],
                    [
                        9.7462249,
                        53.9303097
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "c874d1cd-3a87-4f46-92ec-964153f00504",
            "railwayEdgeName": "E11",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 2583.1292181613976,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9349385,
                        53.5525624
                    ],
                    [
                        9.9349387,
                        53.5525664
                    ],
                    [
                        9.9349389,
                        53.5525697
                    ],
                    [
                        9.9349563,
                        53.5528933
                    ],
                    [
                        9.9349602,
                        53.552972
                    ],
                    [
                        9.9349606,
                        53.5529841
                    ],
                    [
                        9.9349637,
                        53.5530525
                    ],
                    [
                        9.9349648,
                        53.5530818
                    ],
                    [
                        9.9349683,
                        53.5531756
                    ],
                    [
                        9.9349817,
                        53.5535039
                    ],
                    [
                        9.9349916,
                        53.5537041
                    ],
                    [
                        9.9349957,
                        53.5537673
                    ],
                    [
                        9.935005,
                        53.5540456
                    ],
                    [
                        9.9350174,
                        53.5543238
                    ],
                    [
                        9.9350176,
                        53.5543304
                    ],
                    [
                        9.9350315,
                        53.5546701
                    ],
                    [
                        9.9350533,
                        53.555125
                    ],
                    [
                        9.9350638,
                        53.5554445
                    ],
                    [
                        9.9350674,
                        53.5555537
                    ],
                    [
                        9.9350672,
                        53.5555751
                    ],
                    [
                        9.9350671,
                        53.5555922
                    ],
                    [
                        9.9350669,
                        53.5556156
                    ],
                    [
                        9.9350862,
                        53.5558982
                    ],
                    [
                        9.935102,
                        53.5561809
                    ],
                    [
                        9.9351109,
                        53.556349
                    ],
                    [
                        9.9350957,
                        53.5566203
                    ],
                    [
                        9.9350772,
                        53.5567322
                    ],
                    [
                        9.9350405,
                        53.5568558
                    ],
                    [
                        9.935002,
                        53.5569606
                    ],
                    [
                        9.9349475,
                        53.5570734
                    ],
                    [
                        9.9348287,
                        53.557262
                    ],
                    [
                        9.9347822,
                        53.557325
                    ],
                    [
                        9.9347351,
                        53.5573833
                    ],
                    [
                        9.9346183,
                        53.5575204
                    ],
                    [
                        9.9345009,
                        53.5576519
                    ],
                    [
                        9.9344232,
                        53.5577427
                    ],
                    [
                        9.9339946,
                        53.5581339
                    ],
                    [
                        9.9335841,
                        53.5585183
                    ],
                    [
                        9.9333782,
                        53.5587043
                    ],
                    [
                        9.9332199,
                        53.5588603
                    ],
                    [
                        9.9330923,
                        53.5590262
                    ],
                    [
                        9.9329744,
                        53.5592026
                    ],
                    [
                        9.9328971,
                        53.5593754
                    ],
                    [
                        9.932845,
                        53.5595264
                    ],
                    [
                        9.9328164,
                        53.5596619
                    ],
                    [
                        9.9328034,
                        53.5597844
                    ],
                    [
                        9.9328069,
                        53.5600014
                    ],
                    [
                        9.9328453,
                        53.5602071
                    ],
                    [
                        9.9328482,
                        53.5602225
                    ],
                    [
                        9.9329158,
                        53.5604117
                    ],
                    [
                        9.9329469,
                        53.5604857
                    ],
                    [
                        9.933208,
                        53.5609021
                    ],
                    [
                        9.9337393,
                        53.5616447
                    ],
                    [
                        9.9337707,
                        53.5616885
                    ],
                    [
                        9.9339449,
                        53.5620219
                    ],
                    [
                        9.9340369,
                        53.5622725
                    ],
                    [
                        9.9340666,
                        53.5624614
                    ],
                    [
                        9.9340688,
                        53.5625408
                    ],
                    [
                        9.9340753,
                        53.5627699
                    ],
                    [
                        9.9340509,
                        53.5630168
                    ],
                    [
                        9.934015,
                        53.5632805
                    ],
                    [
                        9.933966,
                        53.5636166
                    ],
                    [
                        9.9339443,
                        53.5637847
                    ],
                    [
                        9.933934,
                        53.5638566
                    ],
                    [
                        9.9338458,
                        53.5645208
                    ],
                    [
                        9.933805,
                        53.5648206
                    ],
                    [
                        9.9337366,
                        53.5653934
                    ],
                    [
                        9.9337333,
                        53.5654196
                    ],
                    [
                        9.9336869,
                        53.5657973
                    ],
                    [
                        9.9335773,
                        53.5666371
                    ],
                    [
                        9.9335475,
                        53.5668844
                    ],
                    [
                        9.9334939,
                        53.5673285
                    ],
                    [
                        9.9334035,
                        53.5680818
                    ],
                    [
                        9.9333918,
                        53.5683348
                    ],
                    [
                        9.9333968,
                        53.5685456
                    ],
                    [
                        9.9334012,
                        53.568652
                    ],
                    [
                        9.9334256,
                        53.5693366
                    ],
                    [
                        9.9334382,
                        53.569603
                    ],
                    [
                        9.9334311,
                        53.5699612
                    ],
                    [
                        9.9334169,
                        53.5700845
                    ],
                    [
                        9.9333905,
                        53.5702918
                    ],
                    [
                        9.9333431,
                        53.5705207
                    ],
                    [
                        9.9332916,
                        53.5706793
                    ],
                    [
                        9.9332396,
                        53.570827
                    ],
                    [
                        9.9330384,
                        53.5712527
                    ],
                    [
                        9.932713,
                        53.5716969
                    ],
                    [
                        9.9322983,
                        53.5721402
                    ],
                    [
                        9.9317079,
                        53.5727436
                    ],
                    [
                        9.9311019,
                        53.5733392
                    ],
                    [
                        9.9308484,
                        53.5735794
                    ],
                    [
                        9.9303876,
                        53.5740385
                    ],
                    [
                        9.9301285,
                        53.5743339
                    ],
                    [
                        9.929778,
                        53.5747766
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "b110e6bf-9f95-4d4f-bef0-98339e1dab23",
            "railwayEdgeName": "E14",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 5906.8274006674965,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7931419,
                        53.6581513
                    ],
                    [
                        9.7935261,
                        53.6578772
                    ],
                    [
                        9.7939834,
                        53.6575502
                    ],
                    [
                        9.7940024,
                        53.6575366
                    ],
                    [
                        9.7942935,
                        53.6573284
                    ],
                    [
                        9.7952779,
                        53.6566251
                    ],
                    [
                        9.7957493,
                        53.6562819
                    ],
                    [
                        9.7962036,
                        53.6559512
                    ],
                    [
                        9.796924,
                        53.6554563
                    ],
                    [
                        9.7971959,
                        53.6552696
                    ],
                    [
                        9.7972653,
                        53.6552219
                    ],
                    [
                        9.7981491,
                        53.6546409
                    ],
                    [
                        9.798738,
                        53.6542672
                    ],
                    [
                        9.7987743,
                        53.6542436
                    ],
                    [
                        9.7996942,
                        53.6536496
                    ],
                    [
                        9.8002568,
                        53.6532786
                    ],
                    [
                        9.8006005,
                        53.6530466
                    ],
                    [
                        9.8010451,
                        53.6527454
                    ],
                    [
                        9.8015717,
                        53.6523884
                    ],
                    [
                        9.8019706,
                        53.652116
                    ],
                    [
                        9.8025551,
                        53.6517188
                    ],
                    [
                        9.8026519,
                        53.651653
                    ],
                    [
                        9.8036285,
                        53.6509833
                    ],
                    [
                        9.8048406,
                        53.6501828
                    ],
                    [
                        9.8050456,
                        53.6500451
                    ],
                    [
                        9.813701,
                        53.6442468
                    ],
                    [
                        9.8149554,
                        53.643406
                    ],
                    [
                        9.8173955,
                        53.6417672
                    ],
                    [
                        9.81883,
                        53.6408373
                    ],
                    [
                        9.8197793,
                        53.6402704
                    ],
                    [
                        9.8214717,
                        53.6393818
                    ],
                    [
                        9.8222816,
                        53.6389675
                    ],
                    [
                        9.8297346,
                        53.6351549
                    ],
                    [
                        9.8319435,
                        53.6340219
                    ],
                    [
                        9.8322001,
                        53.6338923
                    ],
                    [
                        9.8331609,
                        53.6333969
                    ],
                    [
                        9.8337533,
                        53.6330952
                    ],
                    [
                        9.8353901,
                        53.6322615
                    ],
                    [
                        9.8371652,
                        53.6312576
                    ],
                    [
                        9.8375906,
                        53.6310214
                    ],
                    [
                        9.8390413,
                        53.6302505
                    ],
                    [
                        9.8403124,
                        53.6296181
                    ],
                    [
                        9.8405073,
                        53.62952
                    ],
                    [
                        9.8438922,
                        53.6278403
                    ],
                    [
                        9.8468677,
                        53.6263727
                    ],
                    [
                        9.8519493,
                        53.6237846
                    ],
                    [
                        9.8540361,
                        53.622708
                    ],
                    [
                        9.8553045,
                        53.6220387
                    ],
                    [
                        9.8568145,
                        53.6211974
                    ],
                    [
                        9.8569123,
                        53.6211458
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "fe8dbbff-b5f9-4527-b44e-98f96d0af29b",
            "railwayEdgeName": "E77",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 86.33533544156,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8115009,
                        53.98373
                    ],
                    [
                        9.8124437,
                        53.9842716
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "da632810-acde-44d4-bbec-999b8106ee11",
            "railwayEdgeName": "E52",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 30.39021422937157,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9844604,
                        54.0898665
                    ],
                    [
                        9.9845795,
                        54.0901305
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "4cec9a4d-3083-4759-924f-99b7ca38048e",
            "railwayEdgeName": "E16",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 5340.775524239103,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8982304,
                        53.599695
                    ],
                    [
                        9.8984902,
                        53.5995432
                    ],
                    [
                        9.898938,
                        53.5992588
                    ],
                    [
                        9.8991617,
                        53.5991268
                    ],
                    [
                        9.8994153,
                        53.5990056
                    ],
                    [
                        9.8997618,
                        53.5988638
                    ],
                    [
                        9.9003316,
                        53.5986482
                    ],
                    [
                        9.9006783,
                        53.5985092
                    ],
                    [
                        9.9013833,
                        53.5982145
                    ],
                    [
                        9.9027216,
                        53.5976663
                    ],
                    [
                        9.9033814,
                        53.5973868
                    ],
                    [
                        9.9041943,
                        53.5970228
                    ],
                    [
                        9.9055172,
                        53.5963903
                    ],
                    [
                        9.9058571,
                        53.5962258
                    ],
                    [
                        9.9064699,
                        53.5959241
                    ],
                    [
                        9.9072466,
                        53.5955227
                    ],
                    [
                        9.9082253,
                        53.5950128
                    ],
                    [
                        9.9089941,
                        53.594604
                    ],
                    [
                        9.9094828,
                        53.5943481
                    ],
                    [
                        9.9097547,
                        53.5942105
                    ],
                    [
                        9.9106304,
                        53.5937711
                    ],
                    [
                        9.9114909,
                        53.5933431
                    ],
                    [
                        9.9131917,
                        53.5924618
                    ],
                    [
                        9.9151133,
                        53.5914533
                    ],
                    [
                        9.9160922,
                        53.5909066
                    ],
                    [
                        9.9165001,
                        53.5906456
                    ],
                    [
                        9.9166272,
                        53.5905643
                    ],
                    [
                        9.9171596,
                        53.5901642
                    ],
                    [
                        9.9174711,
                        53.5898978
                    ],
                    [
                        9.9184121,
                        53.5890377
                    ],
                    [
                        9.9189078,
                        53.5885694
                    ],
                    [
                        9.9192671,
                        53.5882149
                    ],
                    [
                        9.9193544,
                        53.5881288
                    ],
                    [
                        9.919749,
                        53.5876915
                    ],
                    [
                        9.9201158,
                        53.587258
                    ],
                    [
                        9.9206455,
                        53.5865815
                    ],
                    [
                        9.9207276,
                        53.5864712
                    ],
                    [
                        9.9214417,
                        53.5855374
                    ],
                    [
                        9.9222094,
                        53.5845419
                    ],
                    [
                        9.9232412,
                        53.5831941
                    ],
                    [
                        9.9244379,
                        53.581634
                    ],
                    [
                        9.9247347,
                        53.5812404
                    ],
                    [
                        9.9250197,
                        53.5808626
                    ],
                    [
                        9.9259852,
                        53.579609
                    ],
                    [
                        9.9264845,
                        53.57896
                    ],
                    [
                        9.9269654,
                        53.578335
                    ],
                    [
                        9.9273909,
                        53.5777791
                    ],
                    [
                        9.9274676,
                        53.5776784
                    ],
                    [
                        9.9279504,
                        53.5770478
                    ],
                    [
                        9.9283985,
                        53.576483
                    ],
                    [
                        9.9288585,
                        53.5759398
                    ],
                    [
                        9.9290848,
                        53.5756912
                    ],
                    [
                        9.9295439,
                        53.5751971
                    ],
                    [
                        9.9299747,
                        53.5747519
                    ],
                    [
                        9.9301971,
                        53.5745206
                    ],
                    [
                        9.9308856,
                        53.5738092
                    ],
                    [
                        9.9308928,
                        53.5738023
                    ],
                    [
                        9.9309836,
                        53.5737152
                    ],
                    [
                        9.9313073,
                        53.5733808
                    ],
                    [
                        9.9318894,
                        53.5728063
                    ],
                    [
                        9.9325133,
                        53.5721716
                    ],
                    [
                        9.9327132,
                        53.571948
                    ],
                    [
                        9.93288,
                        53.5717615
                    ],
                    [
                        9.9331215,
                        53.571437
                    ],
                    [
                        9.9332273,
                        53.5712631
                    ],
                    [
                        9.9333716,
                        53.5709996
                    ],
                    [
                        9.9334363,
                        53.5708507
                    ],
                    [
                        9.9335451,
                        53.5705417
                    ],
                    [
                        9.933602,
                        53.5703045
                    ],
                    [
                        9.933634,
                        53.5700904
                    ],
                    [
                        9.9336497,
                        53.5699167
                    ],
                    [
                        9.9336726,
                        53.5697061
                    ],
                    [
                        9.9336965,
                        53.5690463
                    ],
                    [
                        9.9337021,
                        53.5688909
                    ],
                    [
                        9.933741,
                        53.5685415
                    ],
                    [
                        9.9337726,
                        53.5683159
                    ],
                    [
                        9.9338262,
                        53.5680588
                    ],
                    [
                        9.9339253,
                        53.5676535
                    ],
                    [
                        9.9339783,
                        53.5674873
                    ],
                    [
                        9.9341416,
                        53.5669133
                    ],
                    [
                        9.9342108,
                        53.5666772
                    ],
                    [
                        9.9342793,
                        53.5663922
                    ],
                    [
                        9.9344395,
                        53.5652731
                    ],
                    [
                        9.9345281,
                        53.5648465
                    ],
                    [
                        9.9345614,
                        53.5646952
                    ],
                    [
                        9.9345924,
                        53.5645534
                    ],
                    [
                        9.9346226,
                        53.5644146
                    ],
                    [
                        9.9346923,
                        53.564119
                    ],
                    [
                        9.9347113,
                        53.5640571
                    ],
                    [
                        9.9347341,
                        53.5639832
                    ],
                    [
                        9.9347931,
                        53.5638315
                    ],
                    [
                        9.9348954,
                        53.5636616
                    ],
                    [
                        9.9349346,
                        53.5636148
                    ],
                    [
                        9.9350055,
                        53.5635213
                    ],
                    [
                        9.9350748,
                        53.5634446
                    ],
                    [
                        9.9352478,
                        53.5632818
                    ],
                    [
                        9.9354673,
                        53.5631253
                    ],
                    [
                        9.9357798,
                        53.5629484
                    ],
                    [
                        9.9358068,
                        53.5629374
                    ],
                    [
                        9.9360322,
                        53.5628476
                    ],
                    [
                        9.9362632,
                        53.5627671
                    ],
                    [
                        9.9364972,
                        53.5627046
                    ],
                    [
                        9.9366849,
                        53.5626626
                    ],
                    [
                        9.9369707,
                        53.5626181
                    ],
                    [
                        9.9372671,
                        53.5625881
                    ],
                    [
                        9.9376151,
                        53.5625783
                    ],
                    [
                        9.9378845,
                        53.5625812
                    ],
                    [
                        9.9381923,
                        53.5625974
                    ],
                    [
                        9.9385098,
                        53.5626253
                    ],
                    [
                        9.9388339,
                        53.5626661
                    ],
                    [
                        9.9391997,
                        53.5627284
                    ],
                    [
                        9.9397238,
                        53.5628307
                    ],
                    [
                        9.9400907,
                        53.5628872
                    ],
                    [
                        9.9404453,
                        53.5629272
                    ],
                    [
                        9.9406857,
                        53.5629429
                    ],
                    [
                        9.9410003,
                        53.562951
                    ],
                    [
                        9.9413113,
                        53.5629409
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "7df8a71a-8b62-414f-a15a-9abbb2f0ce19",
            "railwayEdgeName": "E53",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 101.65425352957773,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9845795,
                        54.0901305
                    ],
                    [
                        9.9845902,
                        54.0901473
                    ],
                    [
                        9.9846737,
                        54.0903034
                    ],
                    [
                        9.9847698,
                        54.0904965
                    ],
                    [
                        9.9848709,
                        54.0906992
                    ],
                    [
                        9.9849044,
                        54.0907672
                    ],
                    [
                        9.9850034,
                        54.0910091
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "4c218b0e-1e8c-435f-9a90-9bcfed66d911",
            "railwayEdgeName": "E57",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 44.20834965641049,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9820648,
                        54.0816375
                    ],
                    [
                        9.9821848,
                        54.0820285
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "fa340628-200a-4ddb-8781-9e9548a63bfb",
            "railwayEdgeName": "E50",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 62.55456634478985,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9842724,
                        54.0893155
                    ],
                    [
                        9.9843933,
                        54.0897065
                    ],
                    [
                        9.9844604,
                        54.0898665
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "4a5dcef1-068e-404e-8993-a1725c9661d6",
            "railwayEdgeName": "E30",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 13876.784273046664,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.4767281,
                        53.7825946
                    ],
                    [
                        9.4839566,
                        53.7835162
                    ],
                    [
                        9.4842691,
                        53.783557
                    ],
                    [
                        9.4844879,
                        53.7835838
                    ],
                    [
                        9.4845351,
                        53.7835898
                    ],
                    [
                        9.4861776,
                        53.7837983
                    ],
                    [
                        9.4886066,
                        53.7841067
                    ],
                    [
                        9.4948337,
                        53.7848974
                    ],
                    [
                        9.5031605,
                        53.7859256
                    ],
                    [
                        9.5071128,
                        53.7864491
                    ],
                    [
                        9.5229186,
                        53.7884323
                    ],
                    [
                        9.5263083,
                        53.7888662
                    ],
                    [
                        9.5276419,
                        53.789005
                    ],
                    [
                        9.5289461,
                        53.7890975
                    ],
                    [
                        9.5298611,
                        53.7891421
                    ],
                    [
                        9.5307884,
                        53.7891483
                    ],
                    [
                        9.53233,
                        53.7891409
                    ],
                    [
                        9.5338809,
                        53.7890809
                    ],
                    [
                        9.5369558,
                        53.788905
                    ],
                    [
                        9.5392025,
                        53.7887975
                    ],
                    [
                        9.5545771,
                        53.7879351
                    ],
                    [
                        9.5606373,
                        53.7875919
                    ],
                    [
                        9.5661261,
                        53.7872935
                    ],
                    [
                        9.571089,
                        53.787016
                    ],
                    [
                        9.5739493,
                        53.7868554
                    ],
                    [
                        9.5753259,
                        53.7867559
                    ],
                    [
                        9.5757342,
                        53.7867126
                    ],
                    [
                        9.5767037,
                        53.7866101
                    ],
                    [
                        9.5783356,
                        53.7863729
                    ],
                    [
                        9.5808334,
                        53.7858817
                    ],
                    [
                        9.5832433,
                        53.7852816
                    ],
                    [
                        9.5854015,
                        53.7845341
                    ],
                    [
                        9.5874707,
                        53.7837158
                    ],
                    [
                        9.5893682,
                        53.7828049
                    ],
                    [
                        9.5911956,
                        53.7818557
                    ],
                    [
                        9.595968,
                        53.7793848
                    ],
                    [
                        9.5982247,
                        53.7782445
                    ],
                    [
                        9.5982698,
                        53.7782252
                    ],
                    [
                        9.5994035,
                        53.7777399
                    ],
                    [
                        9.6007428,
                        53.7772233
                    ],
                    [
                        9.6018154,
                        53.7768589
                    ],
                    [
                        9.6030147,
                        53.7764885
                    ],
                    [
                        9.6064241,
                        53.7754498
                    ],
                    [
                        9.6087404,
                        53.7747839
                    ],
                    [
                        9.6153657,
                        53.7727911
                    ],
                    [
                        9.6240775,
                        53.7702243
                    ],
                    [
                        9.6266744,
                        53.7694621
                    ],
                    [
                        9.6271548,
                        53.7693211
                    ],
                    [
                        9.6377796,
                        53.7661614
                    ],
                    [
                        9.6407509,
                        53.7652793
                    ],
                    [
                        9.6414905,
                        53.7650547
                    ],
                    [
                        9.6415714,
                        53.7650314
                    ],
                    [
                        9.6433194,
                        53.7645125
                    ],
                    [
                        9.6439347,
                        53.7643316
                    ],
                    [
                        9.6447029,
                        53.7641028
                    ],
                    [
                        9.6447185,
                        53.7640977
                    ],
                    [
                        9.6460472,
                        53.7637019
                    ],
                    [
                        9.6461878,
                        53.7636611
                    ],
                    [
                        9.6477615,
                        53.7631825
                    ],
                    [
                        9.6490533,
                        53.7627699
                    ],
                    [
                        9.6496849,
                        53.7625632
                    ],
                    [
                        9.6512742,
                        53.7620498
                    ],
                    [
                        9.6520609,
                        53.7617842
                    ],
                    [
                        9.652485,
                        53.7616271
                    ],
                    [
                        9.6525978,
                        53.7615836
                    ],
                    [
                        9.652938,
                        53.7614408
                    ],
                    [
                        9.6533369,
                        53.7612666
                    ],
                    [
                        9.6537485,
                        53.7610682
                    ],
                    [
                        9.6541396,
                        53.7608657
                    ],
                    [
                        9.6546624,
                        53.7605673
                    ],
                    [
                        9.6552097,
                        53.7602119
                    ],
                    [
                        9.6554115,
                        53.760072
                    ],
                    [
                        9.6560931,
                        53.7595754
                    ],
                    [
                        9.656368,
                        53.7593694
                    ],
                    [
                        9.6566504,
                        53.7591536
                    ],
                    [
                        9.6569193,
                        53.7589348
                    ],
                    [
                        9.6571414,
                        53.7587347
                    ],
                    [
                        9.6573484,
                        53.758528
                    ],
                    [
                        9.6574964,
                        53.7583745
                    ],
                    [
                        9.6576216,
                        53.758235
                    ],
                    [
                        9.6578489,
                        53.7579277
                    ],
                    [
                        9.658039,
                        53.7576197
                    ],
                    [
                        9.6582266,
                        53.7572578
                    ],
                    [
                        9.6584758,
                        53.7565637
                    ],
                    [
                        9.6585992,
                        53.7561347
                    ],
                    [
                        9.6586397,
                        53.7559972
                    ],
                    [
                        9.6586659,
                        53.7559057
                    ],
                    [
                        9.6586861,
                        53.7558354
                    ],
                    [
                        9.6586943,
                        53.7558064
                    ],
                    [
                        9.6588143,
                        53.755384
                    ],
                    [
                        9.6591286,
                        53.7543546
                    ],
                    [
                        9.6591383,
                        53.7543224
                    ],
                    [
                        9.6591716,
                        53.754202
                    ],
                    [
                        9.6591985,
                        53.7541153
                    ],
                    [
                        9.6592899,
                        53.7537988
                    ],
                    [
                        9.6594573,
                        53.7531646
                    ],
                    [
                        9.659673,
                        53.7523969
                    ],
                    [
                        9.659867,
                        53.7517167
                    ],
                    [
                        9.6599546,
                        53.7514527
                    ],
                    [
                        9.6600625,
                        53.7511588
                    ],
                    [
                        9.6603537,
                        53.7504358
                    ],
                    [
                        9.6604286,
                        53.7502353
                    ],
                    [
                        9.6605136,
                        53.74997
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "003c2b96-62a8-4a95-9c41-a5716547293f",
            "railwayEdgeName": "E15",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 1260.9827152856471,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8982304,
                        53.599695
                    ],
                    [
                        9.8988076,
                        53.5993914
                    ],
                    [
                        9.89904,
                        53.5992821
                    ],
                    [
                        9.8990652,
                        53.5992712
                    ],
                    [
                        9.8993281,
                        53.5991579
                    ],
                    [
                        9.8996809,
                        53.5990254
                    ],
                    [
                        9.9000299,
                        53.5989163
                    ],
                    [
                        9.9004921,
                        53.5987906
                    ],
                    [
                        9.9006054,
                        53.5987654
                    ],
                    [
                        9.9009034,
                        53.5986991
                    ],
                    [
                        9.901772,
                        53.5985062
                    ],
                    [
                        9.9024749,
                        53.5983868
                    ],
                    [
                        9.9030123,
                        53.5983251
                    ],
                    [
                        9.9035821,
                        53.5983005
                    ],
                    [
                        9.9041521,
                        53.5983172
                    ],
                    [
                        9.9057197,
                        53.598406
                    ],
                    [
                        9.9063946,
                        53.5984477
                    ],
                    [
                        9.9066606,
                        53.5984622
                    ],
                    [
                        9.9093768,
                        53.5986288
                    ],
                    [
                        9.9095398,
                        53.5986373
                    ],
                    [
                        9.9113454,
                        53.5987599
                    ],
                    [
                        9.9119499,
                        53.5988367
                    ],
                    [
                        9.9125304,
                        53.5989511
                    ],
                    [
                        9.9129592,
                        53.5990585
                    ],
                    [
                        9.9133287,
                        53.5991724
                    ],
                    [
                        9.9136308,
                        53.5992762
                    ],
                    [
                        9.9139898,
                        53.5994258
                    ],
                    [
                        9.9143397,
                        53.5995908
                    ],
                    [
                        9.9149841,
                        53.5999675
                    ],
                    [
                        9.9156398,
                        53.6004511
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "c2c4b531-f75f-4941-8e00-ab8226c57707",
            "railwayEdgeName": "E61",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 3701.383134147333,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.6592675,
                        53.7549595
                    ],
                    [
                        9.6591507,
                        53.7553537
                    ],
                    [
                        9.6590289,
                        53.7557883
                    ],
                    [
                        9.6589576,
                        53.7560291
                    ],
                    [
                        9.6589359,
                        53.7560966
                    ],
                    [
                        9.6588269,
                        53.7564512
                    ],
                    [
                        9.6585749,
                        53.7573095
                    ],
                    [
                        9.6579732,
                        53.7594631
                    ],
                    [
                        9.6578731,
                        53.7597966
                    ],
                    [
                        9.6578393,
                        53.7599177
                    ],
                    [
                        9.6577081,
                        53.7604725
                    ],
                    [
                        9.657351,
                        53.761825
                    ],
                    [
                        9.6571811,
                        53.7624492
                    ],
                    [
                        9.6570722,
                        53.7628179
                    ],
                    [
                        9.6567355,
                        53.7640191
                    ],
                    [
                        9.6567328,
                        53.7640304
                    ],
                    [
                        9.6567177,
                        53.764085
                    ],
                    [
                        9.6565151,
                        53.7647907
                    ],
                    [
                        9.6563978,
                        53.7652697
                    ],
                    [
                        9.6563692,
                        53.7654136
                    ],
                    [
                        9.65635,
                        53.7655608
                    ],
                    [
                        9.6563378,
                        53.7657406
                    ],
                    [
                        9.6563388,
                        53.7659238
                    ],
                    [
                        9.6563542,
                        53.7660648
                    ],
                    [
                        9.6563811,
                        53.7662059
                    ],
                    [
                        9.6564216,
                        53.7663527
                    ],
                    [
                        9.6564698,
                        53.7665003
                    ],
                    [
                        9.656523,
                        53.7666394
                    ],
                    [
                        9.6565875,
                        53.7667765
                    ],
                    [
                        9.6566797,
                        53.7669366
                    ],
                    [
                        9.6567839,
                        53.7670991
                    ],
                    [
                        9.656949,
                        53.7673106
                    ],
                    [
                        9.6571391,
                        53.7675192
                    ],
                    [
                        9.6574479,
                        53.7677953
                    ],
                    [
                        9.6576747,
                        53.7679797
                    ],
                    [
                        9.6579162,
                        53.7681584
                    ],
                    [
                        9.6608948,
                        53.7703507
                    ],
                    [
                        9.6633086,
                        53.7721554
                    ],
                    [
                        9.6640476,
                        53.7727085
                    ],
                    [
                        9.6655835,
                        53.7738358
                    ],
                    [
                        9.6660383,
                        53.7741706
                    ],
                    [
                        9.6668202,
                        53.7747461
                    ],
                    [
                        9.6676825,
                        53.7753837
                    ],
                    [
                        9.6682895,
                        53.775829
                    ],
                    [
                        9.6685531,
                        53.7760077
                    ],
                    [
                        9.6693974,
                        53.7765686
                    ],
                    [
                        9.6703361,
                        53.7771375
                    ],
                    [
                        9.6713418,
                        53.7776994
                    ],
                    [
                        9.6726805,
                        53.778372
                    ],
                    [
                        9.6728735,
                        53.7784612
                    ],
                    [
                        9.6734738,
                        53.778748
                    ],
                    [
                        9.67466,
                        53.7791871
                    ],
                    [
                        9.6756245,
                        53.7794964
                    ],
                    [
                        9.6778744,
                        53.7801597
                    ],
                    [
                        9.6790742,
                        53.7804938
                    ],
                    [
                        9.6804536,
                        53.7808752
                    ],
                    [
                        9.6811283,
                        53.7809824
                    ],
                    [
                        9.6815336,
                        53.7810385
                    ],
                    [
                        9.6820439,
                        53.7810912
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "3dacd4b6-b660-45bc-90a2-b0cd6b440efc",
            "railwayEdgeName": "E4",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 1334.827885437567,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8115009,
                        53.98373
                    ],
                    [
                        9.8127206,
                        53.9843564
                    ],
                    [
                        9.8139902,
                        53.9850125
                    ],
                    [
                        9.8151682,
                        53.9856222
                    ],
                    [
                        9.8152544,
                        53.9856672
                    ],
                    [
                        9.8158701,
                        53.9859829
                    ],
                    [
                        9.8220729,
                        53.9891812
                    ],
                    [
                        9.8222746,
                        53.989288
                    ],
                    [
                        9.8229388,
                        53.9896284
                    ],
                    [
                        9.8230016,
                        53.9896598
                    ],
                    [
                        9.8230724,
                        53.9896981
                    ],
                    [
                        9.8240086,
                        53.9901798
                    ],
                    [
                        9.8252708,
                        53.9908309
                    ],
                    [
                        9.8268189,
                        53.9916314
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "67aca7fc-7b36-4a67-a88f-b7ef07e0d4b8",
            "railwayEdgeName": "E10",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 2492.3712091401626,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.1320484,
                        54.3149215
                    ],
                    [
                        10.1320075,
                        54.3148486
                    ],
                    [
                        10.1316848,
                        54.3142731
                    ],
                    [
                        10.1314452,
                        54.3138537
                    ],
                    [
                        10.1314001,
                        54.313785
                    ],
                    [
                        10.1313552,
                        54.3137065
                    ],
                    [
                        10.1312914,
                        54.3135968
                    ],
                    [
                        10.1310793,
                        54.3132204
                    ],
                    [
                        10.1310749,
                        54.3132123
                    ],
                    [
                        10.1306889,
                        54.312521
                    ],
                    [
                        10.1305185,
                        54.3121961
                    ],
                    [
                        10.1305043,
                        54.312163
                    ],
                    [
                        10.1304263,
                        54.3119671
                    ],
                    [
                        10.1303356,
                        54.3117061
                    ],
                    [
                        10.1303305,
                        54.3116905
                    ],
                    [
                        10.130307,
                        54.3116214
                    ],
                    [
                        10.130143,
                        54.3111279
                    ],
                    [
                        10.1300019,
                        54.3106514
                    ],
                    [
                        10.1299567,
                        54.3104911
                    ],
                    [
                        10.1298789,
                        54.3102066
                    ],
                    [
                        10.129872,
                        54.3101842
                    ],
                    [
                        10.1298,
                        54.3098924
                    ],
                    [
                        10.129758,
                        54.3096641
                    ],
                    [
                        10.1297304,
                        54.3094389
                    ],
                    [
                        10.1297142,
                        54.3091601
                    ],
                    [
                        10.1297147,
                        54.3091084
                    ],
                    [
                        10.1297191,
                        54.3089485
                    ],
                    [
                        10.129727,
                        54.3088259
                    ],
                    [
                        10.1297442,
                        54.3086328
                    ],
                    [
                        10.1297675,
                        54.3084761
                    ],
                    [
                        10.1298002,
                        54.3082789
                    ],
                    [
                        10.129868,
                        54.3079267
                    ],
                    [
                        10.1298905,
                        54.3078279
                    ],
                    [
                        10.1299214,
                        54.3077086
                    ],
                    [
                        10.1299622,
                        54.3075652
                    ],
                    [
                        10.1300172,
                        54.3074002
                    ],
                    [
                        10.1300631,
                        54.3072819
                    ],
                    [
                        10.1301071,
                        54.307177
                    ],
                    [
                        10.1301693,
                        54.3070391
                    ],
                    [
                        10.1302763,
                        54.3068354
                    ],
                    [
                        10.1303881,
                        54.3066481
                    ],
                    [
                        10.1305221,
                        54.3064453
                    ],
                    [
                        10.1306698,
                        54.3062471
                    ],
                    [
                        10.1307172,
                        54.3061876
                    ],
                    [
                        10.1308387,
                        54.3060417
                    ],
                    [
                        10.1309969,
                        54.3058632
                    ],
                    [
                        10.131461,
                        54.3053597
                    ],
                    [
                        10.1317087,
                        54.3050943
                    ],
                    [
                        10.1321714,
                        54.3046006
                    ],
                    [
                        10.1324831,
                        54.304283
                    ],
                    [
                        10.1324974,
                        54.3042693
                    ],
                    [
                        10.1327175,
                        54.3040516
                    ],
                    [
                        10.1337675,
                        54.303035
                    ],
                    [
                        10.1341304,
                        54.3026831
                    ],
                    [
                        10.1342264,
                        54.3025869
                    ],
                    [
                        10.1343512,
                        54.302462
                    ],
                    [
                        10.1345287,
                        54.3022805
                    ],
                    [
                        10.1346776,
                        54.3021227
                    ],
                    [
                        10.1348345,
                        54.3019501
                    ],
                    [
                        10.1349667,
                        54.3018011
                    ],
                    [
                        10.1350833,
                        54.3016648
                    ],
                    [
                        10.1351979,
                        54.3015261
                    ],
                    [
                        10.135544,
                        54.301087
                    ],
                    [
                        10.1359813,
                        54.3005216
                    ],
                    [
                        10.1361497,
                        54.3003044
                    ],
                    [
                        10.1364144,
                        54.2999618
                    ],
                    [
                        10.1366673,
                        54.2996355
                    ],
                    [
                        10.1367564,
                        54.2995229
                    ],
                    [
                        10.1368484,
                        54.2994121
                    ],
                    [
                        10.13694,
                        54.2993021
                    ],
                    [
                        10.1370355,
                        54.2991968
                    ],
                    [
                        10.1371371,
                        54.2990879
                    ],
                    [
                        10.1372368,
                        54.2989865
                    ],
                    [
                        10.1373476,
                        54.2988807
                    ],
                    [
                        10.1374646,
                        54.2987735
                    ],
                    [
                        10.1375895,
                        54.2986665
                    ],
                    [
                        10.1377161,
                        54.2985631
                    ],
                    [
                        10.1377723,
                        54.2985174
                    ],
                    [
                        10.1379102,
                        54.2984117
                    ],
                    [
                        10.1380932,
                        54.2982815
                    ],
                    [
                        10.1382812,
                        54.2981535
                    ],
                    [
                        10.1384705,
                        54.2980309
                    ],
                    [
                        10.1386647,
                        54.2979124
                    ],
                    [
                        10.1389617,
                        54.2977417
                    ],
                    [
                        10.1392765,
                        54.2975744
                    ],
                    [
                        10.1395012,
                        54.2974643
                    ],
                    [
                        10.139775,
                        54.2973356
                    ],
                    [
                        10.1399601,
                        54.2972543
                    ],
                    [
                        10.1401482,
                        54.2971755
                    ],
                    [
                        10.1403748,
                        54.2970841
                    ],
                    [
                        10.1406014,
                        54.2969988
                    ],
                    [
                        10.140866,
                        54.2969032
                    ],
                    [
                        10.1411606,
                        54.2968028
                    ],
                    [
                        10.1414162,
                        54.2967203
                    ],
                    [
                        10.1414527,
                        54.2967086
                    ],
                    [
                        10.1423893,
                        54.2964201
                    ],
                    [
                        10.1426582,
                        54.2963383
                    ],
                    [
                        10.1433889,
                        54.2961129
                    ],
                    [
                        10.144244,
                        54.2958514
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "12b5c4e3-4ae9-4e8d-bb9b-b946a8242a9a",
            "railwayEdgeName": "E18",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 3637.3356053732255,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8569123,
                        53.6211458
                    ],
                    [
                        9.8574953,
                        53.6208228
                    ],
                    [
                        9.8582179,
                        53.6204587
                    ],
                    [
                        9.8584844,
                        53.6203336
                    ],
                    [
                        9.858738,
                        53.6202116
                    ],
                    [
                        9.8590843,
                        53.6200387
                    ],
                    [
                        9.8599566,
                        53.6196081
                    ],
                    [
                        9.8615272,
                        53.6188128
                    ],
                    [
                        9.863247,
                        53.617915
                    ],
                    [
                        9.8637267,
                        53.6176659
                    ],
                    [
                        9.8641387,
                        53.6174234
                    ],
                    [
                        9.8646164,
                        53.617122
                    ],
                    [
                        9.8657486,
                        53.6163975
                    ],
                    [
                        9.8662642,
                        53.6160675
                    ],
                    [
                        9.8665113,
                        53.6159149
                    ],
                    [
                        9.8669173,
                        53.6156561
                    ],
                    [
                        9.8692234,
                        53.6141775
                    ],
                    [
                        9.8699547,
                        53.6137407
                    ],
                    [
                        9.870289,
                        53.613541
                    ],
                    [
                        9.8712573,
                        53.6130447
                    ],
                    [
                        9.8733664,
                        53.6119623
                    ],
                    [
                        9.8755765,
                        53.6108542
                    ],
                    [
                        9.8768117,
                        53.6103826
                    ],
                    [
                        9.8771689,
                        53.6102463
                    ],
                    [
                        9.8779638,
                        53.6099487
                    ],
                    [
                        9.8793251,
                        53.6094208
                    ],
                    [
                        9.8800694,
                        53.609007
                    ],
                    [
                        9.8806205,
                        53.6087829
                    ],
                    [
                        9.8809726,
                        53.6086368
                    ],
                    [
                        9.8812927,
                        53.6085073
                    ],
                    [
                        9.8816141,
                        53.6083532
                    ],
                    [
                        9.8823942,
                        53.607954
                    ],
                    [
                        9.8833352,
                        53.6074743
                    ],
                    [
                        9.884759,
                        53.6067391
                    ],
                    [
                        9.8860272,
                        53.6060937
                    ],
                    [
                        9.8872822,
                        53.6054414
                    ],
                    [
                        9.8889814,
                        53.6045778
                    ],
                    [
                        9.8902355,
                        53.6039375
                    ],
                    [
                        9.8906187,
                        53.6037408
                    ],
                    [
                        9.8909772,
                        53.603579
                    ],
                    [
                        9.8918089,
                        53.6032295
                    ],
                    [
                        9.8918261,
                        53.6032224
                    ],
                    [
                        9.8920777,
                        53.6030956
                    ],
                    [
                        9.8922333,
                        53.6030208
                    ],
                    [
                        9.8930084,
                        53.6026207
                    ],
                    [
                        9.8931062,
                        53.6025729
                    ],
                    [
                        9.8931119,
                        53.6025701
                    ],
                    [
                        9.8936984,
                        53.6022687
                    ],
                    [
                        9.894035,
                        53.6020943
                    ],
                    [
                        9.8946437,
                        53.6017788
                    ],
                    [
                        9.8946465,
                        53.6017774
                    ],
                    [
                        9.8947922,
                        53.6016965
                    ],
                    [
                        9.8952755,
                        53.6013834
                    ],
                    [
                        9.8956181,
                        53.601149
                    ],
                    [
                        9.8960551,
                        53.6008605
                    ],
                    [
                        9.8965014,
                        53.6006055
                    ],
                    [
                        9.897072,
                        53.6003014
                    ],
                    [
                        9.8974113,
                        53.600126
                    ],
                    [
                        9.8982304,
                        53.599695
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "7df76260-086b-4702-9dbd-bb7ebaf792ef",
            "railwayEdgeName": "E51",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 844.7411731553983,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9821678,
                        54.0824004
                    ],
                    [
                        9.982206,
                        54.0827652
                    ],
                    [
                        9.9822693,
                        54.0830237
                    ],
                    [
                        9.9823878,
                        54.0833744
                    ],
                    [
                        9.9826124,
                        54.0841139
                    ],
                    [
                        9.9840271,
                        54.0887455
                    ],
                    [
                        9.9840844,
                        54.0889255
                    ],
                    [
                        9.984209,
                        54.0893215
                    ],
                    [
                        9.9842368,
                        54.0894008
                    ],
                    [
                        9.9842714,
                        54.0894912
                    ],
                    [
                        9.9844604,
                        54.0898665
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "c09aa8d1-750c-4846-8b65-bd15765ca1c9",
            "railwayEdgeName": "E6",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 7952.959593175958,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9346724,
                        53.5525555
                    ],
                    [
                        9.934707,
                        53.5530888
                    ],
                    [
                        9.9347112,
                        53.5531792
                    ],
                    [
                        9.9347263,
                        53.5535075
                    ],
                    [
                        9.9347426,
                        53.5537687
                    ],
                    [
                        9.934808,
                        53.5550274
                    ],
                    [
                        9.9348265,
                        53.555425
                    ],
                    [
                        9.934846,
                        53.5558228
                    ],
                    [
                        9.9348516,
                        53.5559601
                    ],
                    [
                        9.9348566,
                        53.556022
                    ],
                    [
                        9.9348658,
                        53.5562261
                    ],
                    [
                        9.9348708,
                        53.5563285
                    ],
                    [
                        9.9348756,
                        53.5564372
                    ],
                    [
                        9.9348748,
                        53.5564907
                    ],
                    [
                        9.9348649,
                        53.5565666
                    ],
                    [
                        9.9348347,
                        53.5567982
                    ],
                    [
                        9.934798,
                        53.5569429
                    ],
                    [
                        9.9347266,
                        53.5571015
                    ],
                    [
                        9.9345889,
                        53.5573299
                    ],
                    [
                        9.9344862,
                        53.5574624
                    ],
                    [
                        9.9343547,
                        53.5576053
                    ],
                    [
                        9.934181,
                        53.5577606
                    ],
                    [
                        9.9339314,
                        53.557963
                    ],
                    [
                        9.9335795,
                        53.5582574
                    ],
                    [
                        9.9333518,
                        53.5584492
                    ],
                    [
                        9.9331863,
                        53.5586089
                    ],
                    [
                        9.9330295,
                        53.5587831
                    ],
                    [
                        9.9328788,
                        53.5589858
                    ],
                    [
                        9.932768,
                        53.5591576
                    ],
                    [
                        9.9326453,
                        53.5594318
                    ],
                    [
                        9.9325679,
                        53.5596699
                    ],
                    [
                        9.9325667,
                        53.5596775
                    ],
                    [
                        9.9325352,
                        53.5598804
                    ],
                    [
                        9.9325363,
                        53.5601581
                    ],
                    [
                        9.9325775,
                        53.560385
                    ],
                    [
                        9.9325974,
                        53.5604488
                    ],
                    [
                        9.9326232,
                        53.5605312
                    ],
                    [
                        9.93266,
                        53.5606491
                    ],
                    [
                        9.9327998,
                        53.560926
                    ],
                    [
                        9.9332143,
                        53.5615873
                    ],
                    [
                        9.9334561,
                        53.5619234
                    ],
                    [
                        9.9336615,
                        53.5622245
                    ],
                    [
                        9.9337653,
                        53.562424
                    ],
                    [
                        9.9338429,
                        53.5626143
                    ],
                    [
                        9.933867,
                        53.5626879
                    ],
                    [
                        9.9338715,
                        53.5627017
                    ],
                    [
                        9.9339032,
                        53.5627988
                    ],
                    [
                        9.9339275,
                        53.5629511
                    ],
                    [
                        9.9339385,
                        53.5631371
                    ],
                    [
                        9.9339254,
                        53.5634204
                    ],
                    [
                        9.933905,
                        53.5636121
                    ],
                    [
                        9.9338764,
                        53.5637845
                    ],
                    [
                        9.9337709,
                        53.5646467
                    ],
                    [
                        9.9337634,
                        53.5646981
                    ],
                    [
                        9.9337589,
                        53.564728
                    ],
                    [
                        9.9336828,
                        53.5653318
                    ],
                    [
                        9.9335749,
                        53.5662107
                    ],
                    [
                        9.9335302,
                        53.5665014
                    ],
                    [
                        9.9335183,
                        53.5666333
                    ],
                    [
                        9.9334921,
                        53.5668817
                    ],
                    [
                        9.9334197,
                        53.567436
                    ],
                    [
                        9.9333375,
                        53.5680674
                    ],
                    [
                        9.9332644,
                        53.5687218
                    ],
                    [
                        9.9332539,
                        53.5688178
                    ],
                    [
                        9.9331874,
                        53.569602
                    ],
                    [
                        9.9331718,
                        53.5698309
                    ],
                    [
                        9.9331638,
                        53.5699566
                    ],
                    [
                        9.9330511,
                        53.5707413
                    ],
                    [
                        9.9329697,
                        53.5712254
                    ],
                    [
                        9.9327815,
                        53.572149
                    ],
                    [
                        9.9327771,
                        53.5721766
                    ],
                    [
                        9.932682,
                        53.5724397
                    ],
                    [
                        9.9325215,
                        53.5727638
                    ],
                    [
                        9.9323511,
                        53.5730227
                    ],
                    [
                        9.9320654,
                        53.5733626
                    ],
                    [
                        9.9317543,
                        53.5737104
                    ],
                    [
                        9.9316723,
                        53.5738021
                    ],
                    [
                        9.9312124,
                        53.5742381
                    ],
                    [
                        9.9305419,
                        53.5748479
                    ],
                    [
                        9.9298872,
                        53.5754465
                    ],
                    [
                        9.9290191,
                        53.5762498
                    ],
                    [
                        9.9284636,
                        53.5768
                    ],
                    [
                        9.9281273,
                        53.5771548
                    ],
                    [
                        9.9276149,
                        53.5777321
                    ],
                    [
                        9.9274329,
                        53.577956
                    ],
                    [
                        9.9270943,
                        53.5783728
                    ],
                    [
                        9.9266148,
                        53.5789956
                    ],
                    [
                        9.9261154,
                        53.5796435
                    ],
                    [
                        9.925148,
                        53.5809013
                    ],
                    [
                        9.9245618,
                        53.5816748
                    ],
                    [
                        9.9233641,
                        53.5832352
                    ],
                    [
                        9.922506,
                        53.5843522
                    ],
                    [
                        9.9215824,
                        53.58557
                    ],
                    [
                        9.9214777,
                        53.5857005
                    ],
                    [
                        9.9202458,
                        53.5872961
                    ],
                    [
                        9.9198796,
                        53.5877259
                    ],
                    [
                        9.9194634,
                        53.5881827
                    ],
                    [
                        9.9193894,
                        53.5882567
                    ],
                    [
                        9.9190355,
                        53.5886107
                    ],
                    [
                        9.918991,
                        53.5886525
                    ],
                    [
                        9.918533,
                        53.5890819
                    ],
                    [
                        9.9185304,
                        53.5890843
                    ],
                    [
                        9.917613,
                        53.5899306
                    ],
                    [
                        9.9172579,
                        53.5902287
                    ],
                    [
                        9.9167279,
                        53.5906252
                    ],
                    [
                        9.9161819,
                        53.5909736
                    ],
                    [
                        9.9152132,
                        53.5915137
                    ],
                    [
                        9.9141775,
                        53.5920551
                    ],
                    [
                        9.9133029,
                        53.5925123
                    ],
                    [
                        9.9115601,
                        53.5934129
                    ],
                    [
                        9.910722,
                        53.593835
                    ],
                    [
                        9.9098464,
                        53.5942714
                    ],
                    [
                        9.909578,
                        53.5944082
                    ],
                    [
                        9.9090849,
                        53.5946662
                    ],
                    [
                        9.9081556,
                        53.5951433
                    ],
                    [
                        9.9068194,
                        53.595848
                    ],
                    [
                        9.9059371,
                        53.5962829
                    ],
                    [
                        9.9055699,
                        53.5964577
                    ],
                    [
                        9.904281,
                        53.5970848
                    ],
                    [
                        9.9034088,
                        53.5975217
                    ],
                    [
                        9.9025105,
                        53.5979756
                    ],
                    [
                        9.9016021,
                        53.5984262
                    ],
                    [
                        9.900944,
                        53.598752
                    ],
                    [
                        9.897186,
                        53.6006433
                    ],
                    [
                        9.895787,
                        53.6013253
                    ],
                    [
                        9.8944202,
                        53.6020222
                    ],
                    [
                        9.8932951,
                        53.6026046
                    ],
                    [
                        9.8923596,
                        53.603078
                    ],
                    [
                        9.8921955,
                        53.6031576
                    ],
                    [
                        9.8891539,
                        53.6047236
                    ],
                    [
                        9.8874749,
                        53.605586
                    ],
                    [
                        9.884958,
                        53.6068707
                    ],
                    [
                        9.8835379,
                        53.6076515
                    ],
                    [
                        9.8819511,
                        53.6084664
                    ],
                    [
                        9.8819254,
                        53.6084796
                    ],
                    [
                        9.8805098,
                        53.6092061
                    ],
                    [
                        9.8793982,
                        53.6097834
                    ],
                    [
                        9.8778771,
                        53.610541
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "38f5ff9e-2907-4174-a163-bf3d1f35dad9",
            "railwayEdgeName": "E43",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 39.94583064596342,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0966836,
                        54.2803117
                    ],
                    [
                        10.0963146,
                        54.2800292
                    ],
                    [
                        10.0963115,
                        54.2800263
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "6482cdb0-afad-47ba-b028-c0292d6c1bef",
            "railwayEdgeName": "E46",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 13180.654998442109,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.6587612,
                        53.7562223
                    ],
                    [
                        9.6586774,
                        53.7564778
                    ],
                    [
                        9.6586259,
                        53.7566182
                    ],
                    [
                        9.6584832,
                        53.7569444
                    ],
                    [
                        9.6582478,
                        53.7574045
                    ],
                    [
                        9.6582071,
                        53.7574785
                    ],
                    [
                        9.6579206,
                        53.7579498
                    ],
                    [
                        9.6577065,
                        53.7582417
                    ],
                    [
                        9.6575748,
                        53.7583982
                    ],
                    [
                        9.6574339,
                        53.7585523
                    ],
                    [
                        9.6572236,
                        53.7587592
                    ],
                    [
                        9.6570055,
                        53.7589637
                    ],
                    [
                        9.656476,
                        53.75936
                    ],
                    [
                        9.6554155,
                        53.7601329
                    ],
                    [
                        9.6552572,
                        53.7602392
                    ],
                    [
                        9.6547114,
                        53.7605951
                    ],
                    [
                        9.6541864,
                        53.7608913
                    ],
                    [
                        9.6537956,
                        53.7610984
                    ],
                    [
                        9.6533814,
                        53.7612955
                    ],
                    [
                        9.6529717,
                        53.7614742
                    ],
                    [
                        9.6525346,
                        53.7616553
                    ],
                    [
                        9.6520949,
                        53.7618165
                    ],
                    [
                        9.6513053,
                        53.7620823
                    ],
                    [
                        9.6497129,
                        53.762597
                    ],
                    [
                        9.6490894,
                        53.7627999
                    ],
                    [
                        9.6477852,
                        53.763217
                    ],
                    [
                        9.6474428,
                        53.763324
                    ],
                    [
                        9.6462178,
                        53.7636906
                    ],
                    [
                        9.6461192,
                        53.7637197
                    ],
                    [
                        9.645915,
                        53.7637813
                    ],
                    [
                        9.6458943,
                        53.763787
                    ],
                    [
                        9.6442058,
                        53.7642913
                    ],
                    [
                        9.6438962,
                        53.7643823
                    ],
                    [
                        9.6415599,
                        53.7650758
                    ],
                    [
                        9.6414768,
                        53.7650988
                    ],
                    [
                        9.6407749,
                        53.7653123
                    ],
                    [
                        9.6378073,
                        53.7661932
                    ],
                    [
                        9.6272096,
                        53.7693432
                    ],
                    [
                        9.626698,
                        53.7694947
                    ],
                    [
                        9.6241305,
                        53.7702553
                    ],
                    [
                        9.6154187,
                        53.7728221
                    ],
                    [
                        9.6087981,
                        53.7748152
                    ],
                    [
                        9.6065129,
                        53.7754819
                    ],
                    [
                        9.6030471,
                        53.7765186
                    ],
                    [
                        9.6018279,
                        53.7768923
                    ],
                    [
                        9.6007609,
                        53.7772536
                    ],
                    [
                        9.5994359,
                        53.7777628
                    ],
                    [
                        9.59833,
                        53.7782493
                    ],
                    [
                        9.5982857,
                        53.7782688
                    ],
                    [
                        9.596021,
                        53.7794158
                    ],
                    [
                        9.59237,
                        53.7813058
                    ],
                    [
                        9.5912595,
                        53.7818806
                    ],
                    [
                        9.5894222,
                        53.7828175
                    ],
                    [
                        9.5875237,
                        53.7837468
                    ],
                    [
                        9.5854474,
                        53.7845692
                    ],
                    [
                        9.5832963,
                        53.7853126
                    ],
                    [
                        9.5808617,
                        53.785908
                    ],
                    [
                        9.5797143,
                        53.7861381
                    ],
                    [
                        9.5783886,
                        53.7864039
                    ],
                    [
                        9.5766606,
                        53.7866514
                    ],
                    [
                        9.5753239,
                        53.7867876
                    ],
                    [
                        9.5739513,
                        53.7868946
                    ],
                    [
                        9.5711903,
                        53.7870562
                    ],
                    [
                        9.5661851,
                        53.7873309
                    ],
                    [
                        9.5545354,
                        53.7879773
                    ],
                    [
                        9.5392454,
                        53.7888178
                    ],
                    [
                        9.5369598,
                        53.7889302
                    ],
                    [
                        9.5338676,
                        53.7891105
                    ],
                    [
                        9.5323112,
                        53.7891583
                    ],
                    [
                        9.5307666,
                        53.7891744
                    ],
                    [
                        9.5298343,
                        53.7891654
                    ],
                    [
                        9.5289104,
                        53.7891192
                    ],
                    [
                        9.5275949,
                        53.7890247
                    ],
                    [
                        9.5262622,
                        53.7888843
                    ],
                    [
                        9.5229187,
                        53.7884637
                    ],
                    [
                        9.5070692,
                        53.7864784
                    ],
                    [
                        9.5031378,
                        53.7859667
                    ],
                    [
                        9.4949369,
                        53.7849347
                    ],
                    [
                        9.4948867,
                        53.7849284
                    ],
                    [
                        9.4846212,
                        53.7836383
                    ],
                    [
                        9.4842589,
                        53.7835938
                    ],
                    [
                        9.4839475,
                        53.7835539
                    ],
                    [
                        9.483732,
                        53.783527
                    ],
                    [
                        9.4823023,
                        53.783344
                    ],
                    [
                        9.4800808,
                        53.7830597
                    ],
                    [
                        9.4766914,
                        53.782626
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "496b6270-3554-4e14-b878-c4f4f80abd8a",
            "railwayEdgeName": "E70",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 2180.853798291251,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9853095,
                        54.0920134
                    ],
                    [
                        9.9854514,
                        54.0924764
                    ],
                    [
                        9.9855587,
                        54.0928421
                    ],
                    [
                        9.9856242,
                        54.0930818
                    ],
                    [
                        9.9856579,
                        54.0932532
                    ],
                    [
                        9.9856878,
                        54.0934388
                    ],
                    [
                        9.9857112,
                        54.0937093
                    ],
                    [
                        9.9857148,
                        54.0938741
                    ],
                    [
                        9.9857062,
                        54.0940552
                    ],
                    [
                        9.985694,
                        54.0941847
                    ],
                    [
                        9.9856731,
                        54.0943234
                    ],
                    [
                        9.9856329,
                        54.0944943
                    ],
                    [
                        9.985584,
                        54.0946683
                    ],
                    [
                        9.9855068,
                        54.0948927
                    ],
                    [
                        9.9854569,
                        54.0950092
                    ],
                    [
                        9.9853428,
                        54.0952379
                    ],
                    [
                        9.9852094,
                        54.0954657
                    ],
                    [
                        9.984931,
                        54.0958487
                    ],
                    [
                        9.9848537,
                        54.0959456
                    ],
                    [
                        9.9845676,
                        54.0962413
                    ],
                    [
                        9.9843798,
                        54.0964127
                    ],
                    [
                        9.9840955,
                        54.0966444
                    ],
                    [
                        9.9839005,
                        54.0967854
                    ],
                    [
                        9.9836899,
                        54.0969274
                    ],
                    [
                        9.9834272,
                        54.0970884
                    ],
                    [
                        9.9831601,
                        54.0972396
                    ],
                    [
                        9.9829804,
                        54.097333
                    ],
                    [
                        9.9827238,
                        54.0974515
                    ],
                    [
                        9.9824689,
                        54.097565
                    ],
                    [
                        9.9821518,
                        54.0976909
                    ],
                    [
                        9.9818661,
                        54.0977881
                    ],
                    [
                        9.9817606,
                        54.0978236
                    ],
                    [
                        9.9814829,
                        54.0979098
                    ],
                    [
                        9.981185,
                        54.0979934
                    ],
                    [
                        9.9809066,
                        54.098068
                    ],
                    [
                        9.9806463,
                        54.0981328
                    ],
                    [
                        9.9804265,
                        54.0981769
                    ],
                    [
                        9.9801978,
                        54.098217
                    ],
                    [
                        9.9799954,
                        54.0982516
                    ],
                    [
                        9.9797726,
                        54.0982851
                    ],
                    [
                        9.9795441,
                        54.0983139
                    ],
                    [
                        9.9793211,
                        54.0983366
                    ],
                    [
                        9.9788078,
                        54.0983768
                    ],
                    [
                        9.9783103,
                        54.0983955
                    ],
                    [
                        9.9777226,
                        54.0984044
                    ],
                    [
                        9.9736484,
                        54.0983804
                    ],
                    [
                        9.971119,
                        54.0983642
                    ],
                    [
                        9.968724,
                        54.0983533
                    ],
                    [
                        9.9684225,
                        54.0983589
                    ],
                    [
                        9.9681228,
                        54.0983664
                    ],
                    [
                        9.9679537,
                        54.098374
                    ],
                    [
                        9.9677879,
                        54.0983845
                    ],
                    [
                        9.967374,
                        54.0984202
                    ],
                    [
                        9.9669684,
                        54.0984617
                    ],
                    [
                        9.9667068,
                        54.0984993
                    ],
                    [
                        9.9664468,
                        54.0985417
                    ],
                    [
                        9.9662013,
                        54.0985876
                    ],
                    [
                        9.9659575,
                        54.0986365
                    ],
                    [
                        9.9656973,
                        54.0986966
                    ],
                    [
                        9.9654354,
                        54.0987625
                    ],
                    [
                        9.9651964,
                        54.0988303
                    ],
                    [
                        9.9649607,
                        54.0989046
                    ],
                    [
                        9.9645806,
                        54.0990353
                    ],
                    [
                        9.9642219,
                        54.0991758
                    ],
                    [
                        9.9637828,
                        54.0993728
                    ],
                    [
                        9.9634708,
                        54.099532
                    ],
                    [
                        9.9631832,
                        54.0996881
                    ],
                    [
                        9.9627501,
                        54.0999286
                    ],
                    [
                        9.9626878,
                        54.0999734
                    ],
                    [
                        9.9620383,
                        54.1003937
                    ],
                    [
                        9.9613786,
                        54.1008059
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "1c4b3255-869d-4b9a-974b-c56c754d98c8",
            "railwayEdgeName": "E25",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 6363.959475470779,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.1012242,
                        54.3074955
                    ],
                    [
                        10.1016729,
                        54.3071738
                    ],
                    [
                        10.1017912,
                        54.307097
                    ],
                    [
                        10.1019195,
                        54.307023
                    ],
                    [
                        10.1021764,
                        54.3068914
                    ],
                    [
                        10.1023054,
                        54.306831
                    ],
                    [
                        10.1024362,
                        54.3067716
                    ],
                    [
                        10.1025804,
                        54.306709
                    ],
                    [
                        10.1027288,
                        54.3066484
                    ],
                    [
                        10.1030347,
                        54.3065315
                    ],
                    [
                        10.1031488,
                        54.3064911
                    ],
                    [
                        10.103363,
                        54.3064201
                    ],
                    [
                        10.1035806,
                        54.3063515
                    ],
                    [
                        10.1038625,
                        54.3062714
                    ],
                    [
                        10.104146,
                        54.3061992
                    ],
                    [
                        10.1044633,
                        54.3061264
                    ],
                    [
                        10.1047586,
                        54.3060674
                    ],
                    [
                        10.1049654,
                        54.3060312
                    ],
                    [
                        10.1051764,
                        54.3059982
                    ],
                    [
                        10.105364,
                        54.3059705
                    ],
                    [
                        10.1055564,
                        54.3059456
                    ],
                    [
                        10.1057145,
                        54.3059281
                    ],
                    [
                        10.105875,
                        54.3059121
                    ],
                    [
                        10.1061982,
                        54.3058848
                    ],
                    [
                        10.1064367,
                        54.3058705
                    ],
                    [
                        10.1067074,
                        54.3058594
                    ],
                    [
                        10.1069319,
                        54.3058536
                    ],
                    [
                        10.1071851,
                        54.305853
                    ],
                    [
                        10.107499,
                        54.3058591
                    ],
                    [
                        10.1076978,
                        54.3058653
                    ],
                    [
                        10.1078084,
                        54.3058703
                    ],
                    [
                        10.1082573,
                        54.3059031
                    ],
                    [
                        10.1084855,
                        54.3059256
                    ],
                    [
                        10.108722,
                        54.3059516
                    ],
                    [
                        10.1091367,
                        54.3060111
                    ],
                    [
                        10.1095087,
                        54.3060723
                    ],
                    [
                        10.110458,
                        54.306243
                    ],
                    [
                        10.1109368,
                        54.3063306
                    ],
                    [
                        10.1114156,
                        54.306412
                    ],
                    [
                        10.1117525,
                        54.3064643
                    ],
                    [
                        10.1119648,
                        54.3064945
                    ],
                    [
                        10.1121784,
                        54.3065227
                    ],
                    [
                        10.1123955,
                        54.3065487
                    ],
                    [
                        10.1126004,
                        54.3065703
                    ],
                    [
                        10.112797,
                        54.3065903
                    ],
                    [
                        10.1129912,
                        54.3066075
                    ],
                    [
                        10.113182,
                        54.3066231
                    ],
                    [
                        10.1135893,
                        54.3066516
                    ],
                    [
                        10.1149708,
                        54.3067447
                    ],
                    [
                        10.117493,
                        54.3069145
                    ],
                    [
                        10.1191256,
                        54.3070242
                    ],
                    [
                        10.1196424,
                        54.3070576
                    ],
                    [
                        10.1199031,
                        54.3070734
                    ],
                    [
                        10.1201638,
                        54.3070873
                    ],
                    [
                        10.1204736,
                        54.3070997
                    ],
                    [
                        10.1207881,
                        54.3071066
                    ],
                    [
                        10.1210017,
                        54.3071086
                    ],
                    [
                        10.1212153,
                        54.3071079
                    ],
                    [
                        10.1214274,
                        54.307104
                    ],
                    [
                        10.1216394,
                        54.3070965
                    ],
                    [
                        10.121983,
                        54.3070813
                    ],
                    [
                        10.122325,
                        54.307058
                    ],
                    [
                        10.1230222,
                        54.3069994
                    ],
                    [
                        10.1234156,
                        54.3069647
                    ],
                    [
                        10.1236707,
                        54.3069391
                    ],
                    [
                        10.1238924,
                        54.3069157
                    ],
                    [
                        10.1241727,
                        54.3068846
                    ],
                    [
                        10.1244489,
                        54.3068511
                    ],
                    [
                        10.1247237,
                        54.3068212
                    ],
                    [
                        10.1250054,
                        54.3067953
                    ],
                    [
                        10.1253995,
                        54.3067604
                    ],
                    [
                        10.1257609,
                        54.3067276
                    ],
                    [
                        10.1261236,
                        54.3066891
                    ],
                    [
                        10.1264425,
                        54.3066462
                    ],
                    [
                        10.1267544,
                        54.3065953
                    ],
                    [
                        10.1270394,
                        54.3065382
                    ],
                    [
                        10.127323,
                        54.3064739
                    ],
                    [
                        10.127794,
                        54.3063512
                    ],
                    [
                        10.1287429,
                        54.3060965
                    ],
                    [
                        10.1292233,
                        54.3059671
                    ],
                    [
                        10.1294658,
                        54.3059004
                    ],
                    [
                        10.1297022,
                        54.3058337
                    ],
                    [
                        10.1298708,
                        54.3057827
                    ],
                    [
                        10.1300407,
                        54.3057276
                    ],
                    [
                        10.1302537,
                        54.3056503
                    ],
                    [
                        10.1304724,
                        54.3055618
                    ],
                    [
                        10.1307577,
                        54.3054275
                    ],
                    [
                        10.1309855,
                        54.3053026
                    ],
                    [
                        10.131168,
                        54.3051934
                    ],
                    [
                        10.1312938,
                        54.3051096
                    ],
                    [
                        10.1314114,
                        54.3050233
                    ],
                    [
                        10.1315452,
                        54.3049161
                    ],
                    [
                        10.1316645,
                        54.3048094
                    ],
                    [
                        10.1317303,
                        54.3047485
                    ],
                    [
                        10.1320409,
                        54.3044254
                    ],
                    [
                        10.1332345,
                        54.3031419
                    ],
                    [
                        10.1338528,
                        54.3024765
                    ],
                    [
                        10.1340482,
                        54.302263
                    ],
                    [
                        10.1342372,
                        54.3020495
                    ],
                    [
                        10.1344214,
                        54.3018332
                    ],
                    [
                        10.134597,
                        54.3016126
                    ],
                    [
                        10.1346853,
                        54.3014994
                    ],
                    [
                        10.1347699,
                        54.3013852
                    ],
                    [
                        10.1349257,
                        54.3011589
                    ],
                    [
                        10.1350751,
                        54.3009254
                    ],
                    [
                        10.1352112,
                        54.3006885
                    ],
                    [
                        10.1352898,
                        54.3005434
                    ],
                    [
                        10.1353646,
                        54.3003983
                    ],
                    [
                        10.1354429,
                        54.3002313
                    ],
                    [
                        10.135499,
                        54.3001059
                    ],
                    [
                        10.1355724,
                        54.2999227
                    ],
                    [
                        10.1356402,
                        54.2997374
                    ],
                    [
                        10.1357011,
                        54.2995519
                    ],
                    [
                        10.1357563,
                        54.2993664
                    ],
                    [
                        10.1358135,
                        54.2991372
                    ],
                    [
                        10.1358615,
                        54.298908
                    ],
                    [
                        10.1358842,
                        54.2987658
                    ],
                    [
                        10.1359038,
                        54.2986227
                    ],
                    [
                        10.1359237,
                        54.2984329
                    ],
                    [
                        10.1359375,
                        54.2982495
                    ],
                    [
                        10.1359428,
                        54.2980651
                    ],
                    [
                        10.1359435,
                        54.2978808
                    ],
                    [
                        10.1359396,
                        54.2977339
                    ],
                    [
                        10.1359295,
                        54.297587
                    ],
                    [
                        10.1359015,
                        54.2972947
                    ],
                    [
                        10.1358795,
                        54.2971296
                    ],
                    [
                        10.1358543,
                        54.2969655
                    ],
                    [
                        10.135785,
                        54.2966064
                    ],
                    [
                        10.1357476,
                        54.2964425
                    ],
                    [
                        10.135707,
                        54.2962776
                    ],
                    [
                        10.1356319,
                        54.2960065
                    ],
                    [
                        10.135546,
                        54.2957389
                    ],
                    [
                        10.1353974,
                        54.29533
                    ],
                    [
                        10.1352233,
                        54.2949274
                    ],
                    [
                        10.1351054,
                        54.2946749
                    ],
                    [
                        10.1349665,
                        54.2944173
                    ],
                    [
                        10.1348167,
                        54.2941669
                    ],
                    [
                        10.1346179,
                        54.2938762
                    ],
                    [
                        10.1344052,
                        54.2935954
                    ],
                    [
                        10.1341177,
                        54.2932335
                    ],
                    [
                        10.1338193,
                        54.2928762
                    ],
                    [
                        10.1336059,
                        54.2926454
                    ],
                    [
                        10.1333775,
                        54.2924184
                    ],
                    [
                        10.1329179,
                        54.2919661
                    ],
                    [
                        10.1322088,
                        54.2913264
                    ],
                    [
                        10.1312335,
                        54.2904613
                    ],
                    [
                        10.1309851,
                        54.29024
                    ],
                    [
                        10.1307883,
                        54.2900767
                    ],
                    [
                        10.1306442,
                        54.2899675
                    ],
                    [
                        10.1304244,
                        54.2898051
                    ],
                    [
                        10.1301024,
                        54.2895859
                    ],
                    [
                        10.129839,
                        54.289416
                    ],
                    [
                        10.1293466,
                        54.2891167
                    ],
                    [
                        10.1289477,
                        54.2888917
                    ],
                    [
                        10.1285905,
                        54.2887003
                    ],
                    [
                        10.1281912,
                        54.288498
                    ],
                    [
                        10.127794,
                        54.2883127
                    ],
                    [
                        10.1272975,
                        54.2881012
                    ],
                    [
                        10.1267844,
                        54.2879013
                    ],
                    [
                        10.1264702,
                        54.2877868
                    ],
                    [
                        10.1261006,
                        54.2876575
                    ],
                    [
                        10.1254215,
                        54.2874405
                    ],
                    [
                        10.1249147,
                        54.287284
                    ],
                    [
                        10.1245772,
                        54.2871894
                    ],
                    [
                        10.1241817,
                        54.2870848
                    ],
                    [
                        10.1238684,
                        54.2870068
                    ],
                    [
                        10.1233933,
                        54.2868999
                    ],
                    [
                        10.1230763,
                        54.2868342
                    ],
                    [
                        10.1227505,
                        54.2867725
                    ],
                    [
                        10.1223607,
                        54.2867051
                    ],
                    [
                        10.1218549,
                        54.2866289
                    ],
                    [
                        10.1212998,
                        54.2865585
                    ],
                    [
                        10.1206658,
                        54.2864957
                    ],
                    [
                        10.1202831,
                        54.2864656
                    ],
                    [
                        10.1199444,
                        54.2864446
                    ],
                    [
                        10.1188497,
                        54.2863858
                    ],
                    [
                        10.1172643,
                        54.2863023
                    ],
                    [
                        10.1161079,
                        54.2862401
                    ],
                    [
                        10.1157447,
                        54.2862152
                    ],
                    [
                        10.1154968,
                        54.2861929
                    ],
                    [
                        10.1137254,
                        54.285985
                    ],
                    [
                        10.1110839,
                        54.2856728
                    ],
                    [
                        10.1094694,
                        54.2854831
                    ],
                    [
                        10.1091851,
                        54.2854444
                    ],
                    [
                        10.1090021,
                        54.2854163
                    ],
                    [
                        10.1088126,
                        54.2853824
                    ],
                    [
                        10.1086322,
                        54.2853458
                    ],
                    [
                        10.1084528,
                        54.2853066
                    ],
                    [
                        10.1080805,
                        54.2852126
                    ],
                    [
                        10.1077128,
                        54.285115
                    ],
                    [
                        10.107322,
                        54.2850119
                    ],
                    [
                        10.1068495,
                        54.284884
                    ],
                    [
                        10.1064759,
                        54.2847891
                    ],
                    [
                        10.1059374,
                        54.2846463
                    ],
                    [
                        10.1058241,
                        54.2846164
                    ],
                    [
                        10.1043111,
                        54.2842142
                    ],
                    [
                        10.1035106,
                        54.2840004
                    ],
                    [
                        10.1031485,
                        54.2838969
                    ],
                    [
                        10.1027881,
                        54.2837852
                    ],
                    [
                        10.1025055,
                        54.283691
                    ],
                    [
                        10.1019834,
                        54.2835113
                    ],
                    [
                        10.1010854,
                        54.2831861
                    ],
                    [
                        10.1004878,
                        54.2829662
                    ],
                    [
                        10.1001967,
                        54.2828519
                    ],
                    [
                        10.0999931,
                        54.2827668
                    ],
                    [
                        10.0998055,
                        54.2826819
                    ],
                    [
                        10.0994029,
                        54.2824712
                    ],
                    [
                        10.0992093,
                        54.28235
                    ],
                    [
                        10.0989649,
                        54.2821842
                    ],
                    [
                        10.0987432,
                        54.2820203
                    ],
                    [
                        10.098601,
                        54.2819087
                    ],
                    [
                        10.0979664,
                        54.2813331
                    ],
                    [
                        10.0978187,
                        54.2812061
                    ],
                    [
                        10.0976081,
                        54.2810473
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "79ebc9e3-5392-4be1-8519-c64528908743",
            "railwayEdgeName": "E55",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 86.44356781143277,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9818757,
                        54.0808692
                    ],
                    [
                        9.9819255,
                        54.0810475
                    ],
                    [
                        9.9819483,
                        54.0811542
                    ],
                    [
                        9.9819671,
                        54.0812933
                    ],
                    [
                        9.9819963,
                        54.0814285
                    ],
                    [
                        9.9820248,
                        54.0815161
                    ],
                    [
                        9.9820648,
                        54.0816375
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "da27c160-8d39-41be-91d7-cbc5b61c3108",
            "railwayEdgeName": "E33",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 15958.756222287115,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.6885854,
                        53.8618558
                    ],
                    [
                        9.6886556,
                        53.8619385
                    ],
                    [
                        9.6887004,
                        53.8619951
                    ],
                    [
                        9.6888064,
                        53.8621316
                    ],
                    [
                        9.6892695,
                        53.8626706
                    ],
                    [
                        9.6909317,
                        53.8646441
                    ],
                    [
                        9.6923172,
                        53.8662923
                    ],
                    [
                        9.6954672,
                        53.8700398
                    ],
                    [
                        9.6976958,
                        53.8726826
                    ],
                    [
                        9.6986553,
                        53.873829
                    ],
                    [
                        9.7020344,
                        53.8778405
                    ],
                    [
                        9.703373,
                        53.8794264
                    ],
                    [
                        9.7034278,
                        53.8794922
                    ],
                    [
                        9.7059455,
                        53.8824833
                    ],
                    [
                        9.7090491,
                        53.8861702
                    ],
                    [
                        9.7099045,
                        53.8871785
                    ],
                    [
                        9.7119249,
                        53.8895752
                    ],
                    [
                        9.7129233,
                        53.8907621
                    ],
                    [
                        9.7129639,
                        53.8908097
                    ],
                    [
                        9.7131143,
                        53.8909862
                    ],
                    [
                        9.7152532,
                        53.8935267
                    ],
                    [
                        9.7166759,
                        53.8952147
                    ],
                    [
                        9.7171515,
                        53.8957765
                    ],
                    [
                        9.718124,
                        53.8969314
                    ],
                    [
                        9.7213037,
                        53.9007095
                    ],
                    [
                        9.7243398,
                        53.9042992
                    ],
                    [
                        9.7253898,
                        53.9055446
                    ],
                    [
                        9.7277979,
                        53.9083938
                    ],
                    [
                        9.7294291,
                        53.9103295
                    ],
                    [
                        9.7313611,
                        53.9126181
                    ],
                    [
                        9.7349496,
                        53.9168633
                    ],
                    [
                        9.7370693,
                        53.9193778
                    ],
                    [
                        9.7384121,
                        53.9209631
                    ],
                    [
                        9.74191,
                        53.9251132
                    ],
                    [
                        9.7428831,
                        53.9262662
                    ],
                    [
                        9.7438949,
                        53.927462
                    ],
                    [
                        9.7450131,
                        53.9287837
                    ],
                    [
                        9.7453788,
                        53.9292126
                    ],
                    [
                        9.7455977,
                        53.9294687
                    ],
                    [
                        9.745888,
                        53.9298291
                    ],
                    [
                        9.7459813,
                        53.9299389
                    ],
                    [
                        9.7461596,
                        53.9301532
                    ],
                    [
                        9.7461817,
                        53.9301798
                    ],
                    [
                        9.746403,
                        53.9304269
                    ],
                    [
                        9.7471037,
                        53.9311864
                    ],
                    [
                        9.7471644,
                        53.931251
                    ],
                    [
                        9.7476181,
                        53.9317149
                    ],
                    [
                        9.7478189,
                        53.9319253
                    ],
                    [
                        9.74811,
                        53.9322338
                    ],
                    [
                        9.7485379,
                        53.9327208
                    ],
                    [
                        9.7489555,
                        53.9332192
                    ],
                    [
                        9.7504905,
                        53.9350729
                    ],
                    [
                        9.7511426,
                        53.935871
                    ],
                    [
                        9.7515332,
                        53.9363557
                    ],
                    [
                        9.7536995,
                        53.9390361
                    ],
                    [
                        9.7541715,
                        53.9396163
                    ],
                    [
                        9.7548824,
                        53.9404606
                    ],
                    [
                        9.755269,
                        53.9409179
                    ],
                    [
                        9.7555725,
                        53.9412799
                    ],
                    [
                        9.7555919,
                        53.9413046
                    ],
                    [
                        9.7564466,
                        53.942316
                    ],
                    [
                        9.7569462,
                        53.942899
                    ],
                    [
                        9.7571358,
                        53.943129
                    ],
                    [
                        9.7572368,
                        53.9432512
                    ],
                    [
                        9.7604477,
                        53.9470397
                    ],
                    [
                        9.7605003,
                        53.9470998
                    ],
                    [
                        9.7639108,
                        53.9511389
                    ],
                    [
                        9.7652582,
                        53.952733
                    ],
                    [
                        9.7677187,
                        53.9556389
                    ],
                    [
                        9.7685435,
                        53.9566121
                    ],
                    [
                        9.7722853,
                        53.9610349
                    ],
                    [
                        9.7733174,
                        53.9622507
                    ],
                    [
                        9.7738526,
                        53.9628583
                    ],
                    [
                        9.774636,
                        53.9636663
                    ],
                    [
                        9.7751134,
                        53.9641136
                    ],
                    [
                        9.7757515,
                        53.9646637
                    ],
                    [
                        9.7763071,
                        53.965106
                    ],
                    [
                        9.7764798,
                        53.9652391
                    ],
                    [
                        9.7767104,
                        53.9654137
                    ],
                    [
                        9.7770724,
                        53.9656738
                    ],
                    [
                        9.7780371,
                        53.9663199
                    ],
                    [
                        9.7781161,
                        53.9663701
                    ],
                    [
                        9.778503,
                        53.966611
                    ],
                    [
                        9.7787703,
                        53.9667705
                    ],
                    [
                        9.7795892,
                        53.9672361
                    ],
                    [
                        9.7814675,
                        53.9682178
                    ],
                    [
                        9.7835044,
                        53.9692665
                    ],
                    [
                        9.7882882,
                        53.9717381
                    ],
                    [
                        9.7916884,
                        53.9734922
                    ],
                    [
                        9.7959673,
                        53.9757077
                    ],
                    [
                        9.8077402,
                        53.9817963
                    ],
                    [
                        9.8084733,
                        53.9821433
                    ],
                    [
                        9.8102901,
                        53.9831062
                    ],
                    [
                        9.8115009,
                        53.98373
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "afc28dbb-d7b8-4086-be1f-cc696f7128cd",
            "railwayEdgeName": "E65",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 843.4288980419733,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8226131,
                        53.9895183
                    ],
                    [
                        9.821332,
                        53.9888555
                    ],
                    [
                        9.81582,
                        53.9860114
                    ],
                    [
                        9.8152515,
                        53.9857189
                    ],
                    [
                        9.8151669,
                        53.985675
                    ],
                    [
                        9.8139411,
                        53.9850405
                    ],
                    [
                        9.8129352,
                        53.9845251
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "96bcb5e0-50d4-4562-97e2-cee9acbaa229",
            "railwayEdgeName": "E5",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 9744.955123572352,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9356189,
                        53.5527162
                    ],
                    [
                        9.9356204,
                        53.5527782
                    ],
                    [
                        9.9356388,
                        53.5532195
                    ],
                    [
                        9.9356506,
                        53.5534972
                    ],
                    [
                        9.9356632,
                        53.5537543
                    ],
                    [
                        9.9357119,
                        53.554845
                    ],
                    [
                        9.9357318,
                        53.555291
                    ],
                    [
                        9.935735,
                        53.5553864
                    ],
                    [
                        9.9357537,
                        53.5559504
                    ],
                    [
                        9.9357516,
                        53.555967
                    ],
                    [
                        9.9357232,
                        53.5561835
                    ],
                    [
                        9.9357209,
                        53.5562077
                    ],
                    [
                        9.9357283,
                        53.5565805
                    ],
                    [
                        9.9357331,
                        53.5568241
                    ],
                    [
                        9.9357341,
                        53.5568721
                    ],
                    [
                        9.9357431,
                        53.5571964
                    ],
                    [
                        9.9357638,
                        53.5579953
                    ],
                    [
                        9.9357623,
                        53.5580696
                    ],
                    [
                        9.9357434,
                        53.5582908
                    ],
                    [
                        9.9356895,
                        53.5587555
                    ],
                    [
                        9.9356632,
                        53.559041
                    ],
                    [
                        9.9356577,
                        53.5591871
                    ],
                    [
                        9.9356634,
                        53.5596616
                    ],
                    [
                        9.9356659,
                        53.5598335
                    ],
                    [
                        9.9356937,
                        53.560863
                    ],
                    [
                        9.9356896,
                        53.5612917
                    ],
                    [
                        9.9356882,
                        53.5614421
                    ],
                    [
                        9.9356517,
                        53.5616667
                    ],
                    [
                        9.9355943,
                        53.5619057
                    ],
                    [
                        9.9355589,
                        53.5620052
                    ],
                    [
                        9.9355342,
                        53.5620746
                    ],
                    [
                        9.935387,
                        53.5623712
                    ],
                    [
                        9.9352858,
                        53.5625446
                    ],
                    [
                        9.9348807,
                        53.5630424
                    ],
                    [
                        9.9347193,
                        53.5632221
                    ],
                    [
                        9.9346013,
                        53.5633527
                    ],
                    [
                        9.9344794,
                        53.5634906
                    ],
                    [
                        9.934359,
                        53.5636381
                    ],
                    [
                        9.9342504,
                        53.5637934
                    ],
                    [
                        9.9341314,
                        53.5639984
                    ],
                    [
                        9.934045,
                        53.5641952
                    ],
                    [
                        9.9339815,
                        53.5644514
                    ],
                    [
                        9.9339503,
                        53.5646453
                    ],
                    [
                        9.9339258,
                        53.5648273
                    ],
                    [
                        9.9338209,
                        53.5657687
                    ],
                    [
                        9.9336974,
                        53.5666447
                    ],
                    [
                        9.9336845,
                        53.5668911
                    ],
                    [
                        9.933597,
                        53.5675198
                    ],
                    [
                        9.9335929,
                        53.5675547
                    ],
                    [
                        9.9335237,
                        53.5680877
                    ],
                    [
                        9.9335156,
                        53.5686453
                    ],
                    [
                        9.9335855,
                        53.5695175
                    ],
                    [
                        9.9335871,
                        53.569703
                    ],
                    [
                        9.9335793,
                        53.5699352
                    ],
                    [
                        9.9335369,
                        53.5703032
                    ],
                    [
                        9.9334876,
                        53.5705312
                    ],
                    [
                        9.9333807,
                        53.5708431
                    ],
                    [
                        9.9333113,
                        53.5709917
                    ],
                    [
                        9.9331528,
                        53.5712878
                    ],
                    [
                        9.9328404,
                        53.5717423
                    ],
                    [
                        9.932728,
                        53.571864
                    ],
                    [
                        9.9324449,
                        53.5721704
                    ],
                    [
                        9.9318337,
                        53.5727874
                    ],
                    [
                        9.9313344,
                        53.5732737
                    ],
                    [
                        9.9310173,
                        53.5735976
                    ],
                    [
                        9.9307158,
                        53.5739001
                    ],
                    [
                        9.9302882,
                        53.5743447
                    ],
                    [
                        9.9301966,
                        53.5744392
                    ],
                    [
                        9.9298803,
                        53.574771
                    ],
                    [
                        9.9295979,
                        53.5750596
                    ],
                    [
                        9.9294315,
                        53.5752351
                    ],
                    [
                        9.9290787,
                        53.5756106
                    ],
                    [
                        9.9287969,
                        53.5759134
                    ],
                    [
                        9.9283303,
                        53.5764651
                    ],
                    [
                        9.9278775,
                        53.5770265
                    ],
                    [
                        9.9273896,
                        53.5776689
                    ],
                    [
                        9.9268905,
                        53.5783138
                    ],
                    [
                        9.9265145,
                        53.5788027
                    ],
                    [
                        9.9264386,
                        53.5789049
                    ],
                    [
                        9.9249522,
                        53.5808404
                    ],
                    [
                        9.924662,
                        53.5812225
                    ],
                    [
                        9.9243688,
                        53.5816084
                    ],
                    [
                        9.9231648,
                        53.5831808
                    ],
                    [
                        9.9221409,
                        53.5845149
                    ],
                    [
                        9.9213733,
                        53.5855096
                    ],
                    [
                        9.9211443,
                        53.5858096
                    ],
                    [
                        9.9200633,
                        53.5872153
                    ],
                    [
                        9.9200455,
                        53.5872385
                    ],
                    [
                        9.9196793,
                        53.5876687
                    ],
                    [
                        9.9192778,
                        53.5881043
                    ],
                    [
                        9.9191894,
                        53.588193
                    ],
                    [
                        9.9188356,
                        53.5885479
                    ],
                    [
                        9.918341,
                        53.5890151
                    ],
                    [
                        9.917413,
                        53.5898717
                    ],
                    [
                        9.9171054,
                        53.5901239
                    ],
                    [
                        9.916575,
                        53.5905254
                    ],
                    [
                        9.9164404,
                        53.5906127
                    ],
                    [
                        9.9160385,
                        53.5908733
                    ],
                    [
                        9.915465,
                        53.5912059
                    ],
                    [
                        9.915061,
                        53.5914215
                    ],
                    [
                        9.9131197,
                        53.5924321
                    ],
                    [
                        9.9119979,
                        53.593008
                    ],
                    [
                        9.9114347,
                        53.5932978
                    ],
                    [
                        9.9105823,
                        53.5937377
                    ],
                    [
                        9.9097089,
                        53.5941819
                    ],
                    [
                        9.9094454,
                        53.5943189
                    ],
                    [
                        9.9089473,
                        53.5945767
                    ],
                    [
                        9.9081912,
                        53.5949641
                    ],
                    [
                        9.9081732,
                        53.5949736
                    ],
                    [
                        9.9066738,
                        53.5957437
                    ],
                    [
                        9.9057982,
                        53.5961838
                    ],
                    [
                        9.9054805,
                        53.5963434
                    ],
                    [
                        9.9045885,
                        53.5967762
                    ],
                    [
                        9.9041441,
                        53.5969789
                    ],
                    [
                        9.9032852,
                        53.5973453
                    ],
                    [
                        9.9030255,
                        53.5974503
                    ],
                    [
                        9.9024914,
                        53.5976662
                    ],
                    [
                        9.9009114,
                        53.5982597
                    ],
                    [
                        9.9003488,
                        53.5984722
                    ],
                    [
                        9.8990414,
                        53.5989557
                    ],
                    [
                        9.8956078,
                        53.6002595
                    ],
                    [
                        9.8941349,
                        53.6008206
                    ],
                    [
                        9.893529,
                        53.6010507
                    ],
                    [
                        9.8926455,
                        53.6013806
                    ],
                    [
                        9.8919367,
                        53.6016496
                    ],
                    [
                        9.8905696,
                        53.6021643
                    ],
                    [
                        9.8904142,
                        53.6022251
                    ],
                    [
                        9.8892388,
                        53.6026752
                    ],
                    [
                        9.8876122,
                        53.6032929
                    ],
                    [
                        9.886293,
                        53.6038207
                    ],
                    [
                        9.884717,
                        53.6044732
                    ],
                    [
                        9.8838395,
                        53.6048483
                    ],
                    [
                        9.8829538,
                        53.6052377
                    ],
                    [
                        9.8818821,
                        53.6057343
                    ],
                    [
                        9.8806569,
                        53.6063349
                    ],
                    [
                        9.8796195,
                        53.6068678
                    ],
                    [
                        9.878703,
                        53.6073705
                    ],
                    [
                        9.8775282,
                        53.60806
                    ],
                    [
                        9.8761685,
                        53.6088996
                    ],
                    [
                        9.8752326,
                        53.609496
                    ],
                    [
                        9.8735782,
                        53.6105579
                    ],
                    [
                        9.873042,
                        53.610907
                    ],
                    [
                        9.8719299,
                        53.6116188
                    ],
                    [
                        9.8707748,
                        53.6123676
                    ],
                    [
                        9.8671,
                        53.6147097
                    ],
                    [
                        9.8658836,
                        53.6154793
                    ],
                    [
                        9.8657109,
                        53.6155885
                    ],
                    [
                        9.8627066,
                        53.6174955
                    ],
                    [
                        9.8598233,
                        53.6193468
                    ],
                    [
                        9.858582,
                        53.6201395
                    ],
                    [
                        9.858374,
                        53.6202619
                    ],
                    [
                        9.8577902,
                        53.6206039
                    ],
                    [
                        9.8569123,
                        53.6211458
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "9bd6a648-632e-4c62-b448-d0043eb13eb9",
            "railwayEdgeName": "E21",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 3700.2541653764583,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0976081,
                        54.2810473
                    ],
                    [
                        10.0980318,
                        54.2813388
                    ],
                    [
                        10.0982127,
                        54.281476
                    ],
                    [
                        10.0983057,
                        54.2815505
                    ],
                    [
                        10.0987616,
                        54.2819499
                    ],
                    [
                        10.0990005,
                        54.28214
                    ],
                    [
                        10.0992618,
                        54.282322
                    ],
                    [
                        10.0994533,
                        54.2824429
                    ],
                    [
                        10.0996136,
                        54.2825335
                    ],
                    [
                        10.0998517,
                        54.2826536
                    ],
                    [
                        10.1000593,
                        54.2827453
                    ],
                    [
                        10.1002351,
                        54.282818
                    ],
                    [
                        10.1005896,
                        54.2829562
                    ],
                    [
                        10.1012327,
                        54.2831917
                    ],
                    [
                        10.1016866,
                        54.2833567
                    ],
                    [
                        10.1020256,
                        54.2834769
                    ],
                    [
                        10.102836,
                        54.2837523
                    ],
                    [
                        10.1031879,
                        54.2838624
                    ],
                    [
                        10.1035434,
                        54.2839658
                    ],
                    [
                        10.1043358,
                        54.2841775
                    ],
                    [
                        10.1056997,
                        54.2845392
                    ],
                    [
                        10.1064154,
                        54.284727
                    ],
                    [
                        10.1066762,
                        54.2847962
                    ],
                    [
                        10.1069153,
                        54.2848597
                    ],
                    [
                        10.1070782,
                        54.2849029
                    ],
                    [
                        10.1075853,
                        54.2850367
                    ],
                    [
                        10.1077528,
                        54.2850755
                    ],
                    [
                        10.1079166,
                        54.2851089
                    ],
                    [
                        10.1085018,
                        54.2852172
                    ],
                    [
                        10.1088752,
                        54.2852867
                    ],
                    [
                        10.1092591,
                        54.2853516
                    ],
                    [
                        10.1095049,
                        54.2853867
                    ],
                    [
                        10.1111215,
                        54.285579
                    ],
                    [
                        10.1137516,
                        54.2858882
                    ],
                    [
                        10.1155229,
                        54.2860963
                    ],
                    [
                        10.1157615,
                        54.2861183
                    ],
                    [
                        10.1161226,
                        54.2861433
                    ],
                    [
                        10.1172862,
                        54.2862068
                    ],
                    [
                        10.1188666,
                        54.2862903
                    ],
                    [
                        10.1199599,
                        54.2863485
                    ],
                    [
                        10.1202935,
                        54.2863692
                    ],
                    [
                        10.12071,
                        54.2864032
                    ],
                    [
                        10.1213216,
                        54.2864665
                    ],
                    [
                        10.1215893,
                        54.286498
                    ],
                    [
                        10.1218858,
                        54.2865391
                    ],
                    [
                        10.1223736,
                        54.2866155
                    ],
                    [
                        10.1227814,
                        54.2866847
                    ],
                    [
                        10.1231395,
                        54.2867555
                    ],
                    [
                        10.1234436,
                        54.2868191
                    ],
                    [
                        10.1239325,
                        54.2869301
                    ],
                    [
                        10.1242353,
                        54.2870061
                    ],
                    [
                        10.1246351,
                        54.2871149
                    ],
                    [
                        10.124978,
                        54.2872128
                    ],
                    [
                        10.1254824,
                        54.2873681
                    ],
                    [
                        10.1261584,
                        54.2875835
                    ],
                    [
                        10.1265452,
                        54.2877166
                    ],
                    [
                        10.1268578,
                        54.2878311
                    ],
                    [
                        10.1273757,
                        54.2880339
                    ],
                    [
                        10.1278858,
                        54.2882495
                    ],
                    [
                        10.1282909,
                        54.2884373
                    ],
                    [
                        10.1286847,
                        54.2886343
                    ],
                    [
                        10.1290706,
                        54.2888411
                    ],
                    [
                        10.1294454,
                        54.2890544
                    ],
                    [
                        10.1299359,
                        54.2893574
                    ],
                    [
                        10.1302069,
                        54.2895342
                    ],
                    [
                        10.1305309,
                        54.289755
                    ],
                    [
                        10.1307602,
                        54.2899161
                    ],
                    [
                        10.1308761,
                        54.2900014
                    ],
                    [
                        10.1310828,
                        54.290161
                    ],
                    [
                        10.1313555,
                        54.2904024
                    ],
                    [
                        10.1318213,
                        54.2908324
                    ],
                    [
                        10.131965,
                        54.2909548
                    ],
                    [
                        10.1321256,
                        54.2910765
                    ],
                    [
                        10.132241,
                        54.2911563
                    ],
                    [
                        10.1323612,
                        54.2912338
                    ],
                    [
                        10.1325226,
                        54.291329
                    ],
                    [
                        10.1326924,
                        54.2914193
                    ],
                    [
                        10.1328699,
                        54.2915054
                    ],
                    [
                        10.1332781,
                        54.2916875
                    ],
                    [
                        10.1334222,
                        54.2917551
                    ],
                    [
                        10.1335721,
                        54.2918318
                    ],
                    [
                        10.1336957,
                        54.2919005
                    ],
                    [
                        10.1338145,
                        54.2919742
                    ],
                    [
                        10.1339543,
                        54.2920641
                    ],
                    [
                        10.1340917,
                        54.2921597
                    ],
                    [
                        10.1342503,
                        54.2922838
                    ],
                    [
                        10.1343834,
                        54.2924037
                    ],
                    [
                        10.1344798,
                        54.2924981
                    ],
                    [
                        10.1347421,
                        54.2927516
                    ],
                    [
                        10.1348475,
                        54.2928637
                    ],
                    [
                        10.1350432,
                        54.2930783
                    ],
                    [
                        10.1351731,
                        54.2932241
                    ],
                    [
                        10.1352952,
                        54.2933719
                    ],
                    [
                        10.1354297,
                        54.2935385
                    ],
                    [
                        10.1354992,
                        54.2936276
                    ],
                    [
                        10.135574,
                        54.2937318
                    ],
                    [
                        10.1356659,
                        54.2938586
                    ],
                    [
                        10.1357798,
                        54.2940283
                    ],
                    [
                        10.1360041,
                        54.2943585
                    ],
                    [
                        10.1361335,
                        54.294529
                    ],
                    [
                        10.1362564,
                        54.2946728
                    ],
                    [
                        10.1364342,
                        54.2948531
                    ],
                    [
                        10.1366011,
                        54.2950005
                    ],
                    [
                        10.1367797,
                        54.2951429
                    ],
                    [
                        10.1370088,
                        54.2953026
                    ],
                    [
                        10.1371357,
                        54.2953833
                    ],
                    [
                        10.1372708,
                        54.295462
                    ],
                    [
                        10.1374411,
                        54.2955563
                    ],
                    [
                        10.1376325,
                        54.2956534
                    ],
                    [
                        10.1377702,
                        54.2957181
                    ],
                    [
                        10.1378949,
                        54.2957721
                    ],
                    [
                        10.138088,
                        54.2958494
                    ],
                    [
                        10.1382672,
                        54.2959145
                    ],
                    [
                        10.1384751,
                        54.2959858
                    ],
                    [
                        10.1387456,
                        54.2960681
                    ],
                    [
                        10.1390291,
                        54.2961402
                    ],
                    [
                        10.1393484,
                        54.2962104
                    ],
                    [
                        10.1396806,
                        54.2962709
                    ],
                    [
                        10.1398512,
                        54.2962953
                    ],
                    [
                        10.1400237,
                        54.2963175
                    ],
                    [
                        10.1401939,
                        54.2963352
                    ],
                    [
                        10.1403679,
                        54.2963519
                    ],
                    [
                        10.1406015,
                        54.2963669
                    ],
                    [
                        10.1408513,
                        54.2963771
                    ],
                    [
                        10.1411463,
                        54.2963831
                    ],
                    [
                        10.1414656,
                        54.2963757
                    ],
                    [
                        10.1415992,
                        54.296369
                    ],
                    [
                        10.1417361,
                        54.2963596
                    ],
                    [
                        10.1419518,
                        54.2963395
                    ],
                    [
                        10.1421631,
                        54.2963161
                    ],
                    [
                        10.142367,
                        54.2962858
                    ],
                    [
                        10.1425653,
                        54.2962529
                    ],
                    [
                        10.1427841,
                        54.2962095
                    ],
                    [
                        10.1429478,
                        54.2961744
                    ],
                    [
                        10.1431642,
                        54.2961262
                    ],
                    [
                        10.1433783,
                        54.2960773
                    ],
                    [
                        10.1436334,
                        54.2960192
                    ],
                    [
                        10.1438017,
                        54.2959765
                    ],
                    [
                        10.1439658,
                        54.2959308
                    ],
                    [
                        10.144244,
                        54.2958514
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "b13b3e40-813a-4073-8568-d1f1504d7436",
            "railwayEdgeName": "E60",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 90.79201429257603,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9033923,
                        53.5977001
                    ],
                    [
                        9.9030822,
                        53.5978561
                    ],
                    [
                        9.9028361,
                        53.5979731
                    ],
                    [
                        9.9025281,
                        53.598113
                    ],
                    [
                        9.9023147,
                        53.5982046
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "8d709c30-7b1d-4d3b-870a-d489c7b9c896",
            "railwayEdgeName": "E45",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 978.9895871545208,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8988675,
                        53.6014657
                    ],
                    [
                        9.8988993,
                        53.6022362
                    ],
                    [
                        9.89889,
                        53.602467
                    ],
                    [
                        9.898841,
                        53.6029381
                    ],
                    [
                        9.8987172,
                        53.6033535
                    ],
                    [
                        9.8985719,
                        53.603841
                    ],
                    [
                        9.8984972,
                        53.6040918
                    ],
                    [
                        9.8981536,
                        53.605061
                    ],
                    [
                        9.8980999,
                        53.6052345
                    ],
                    [
                        9.8980284,
                        53.605451
                    ],
                    [
                        9.8979289,
                        53.6058815
                    ],
                    [
                        9.8979282,
                        53.6061607
                    ],
                    [
                        9.8979579,
                        53.6064405
                    ],
                    [
                        9.8980614,
                        53.6067335
                    ],
                    [
                        9.8981998,
                        53.6069942
                    ],
                    [
                        9.8982424,
                        53.6070569
                    ],
                    [
                        9.8983226,
                        53.6071748
                    ],
                    [
                        9.8984908,
                        53.6073805
                    ],
                    [
                        9.8987502,
                        53.6076304
                    ],
                    [
                        9.8991713,
                        53.6079732
                    ],
                    [
                        9.8995785,
                        53.6083045
                    ],
                    [
                        9.9003931,
                        53.6089797
                    ],
                    [
                        9.9006151,
                        53.6091861
                    ],
                    [
                        9.9006301,
                        53.6092001
                    ],
                    [
                        9.900802,
                        53.6093965
                    ],
                    [
                        9.9009168,
                        53.6095448
                    ],
                    [
                        9.9010166,
                        53.6096968
                    ],
                    [
                        9.9010207,
                        53.6097033
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "e0df3ceb-3ff4-4fa7-8198-de6fdb058d66",
            "railwayEdgeName": "E12",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 1598.7553745665589,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.1314842,
                        54.314978
                    ],
                    [
                        10.1314498,
                        54.314916
                    ],
                    [
                        10.1314369,
                        54.3148927
                    ],
                    [
                        10.1312155,
                        54.3144933
                    ],
                    [
                        10.1309792,
                        54.31407
                    ],
                    [
                        10.1308097,
                        54.3137886
                    ],
                    [
                        10.1305431,
                        54.3133509
                    ],
                    [
                        10.1305309,
                        54.3133307
                    ],
                    [
                        10.1305026,
                        54.3132873
                    ],
                    [
                        10.1304658,
                        54.3132244
                    ],
                    [
                        10.1304256,
                        54.3131426
                    ],
                    [
                        10.1303655,
                        54.3130146
                    ],
                    [
                        10.130283,
                        54.3127908
                    ],
                    [
                        10.130252,
                        54.3126941
                    ],
                    [
                        10.1302207,
                        54.3125675
                    ],
                    [
                        10.1301936,
                        54.3124011
                    ],
                    [
                        10.1301744,
                        54.3123203
                    ],
                    [
                        10.1301253,
                        54.3121434
                    ],
                    [
                        10.1300755,
                        54.3120099
                    ],
                    [
                        10.129892,
                        54.311607
                    ],
                    [
                        10.1295683,
                        54.3110372
                    ],
                    [
                        10.1295426,
                        54.3109864
                    ],
                    [
                        10.1294918,
                        54.3108945
                    ],
                    [
                        10.1293739,
                        54.3106631
                    ],
                    [
                        10.1292457,
                        54.310384
                    ],
                    [
                        10.1291325,
                        54.3100991
                    ],
                    [
                        10.1290374,
                        54.30981
                    ],
                    [
                        10.1289747,
                        54.3095843
                    ],
                    [
                        10.1288935,
                        54.3092587
                    ],
                    [
                        10.1288538,
                        54.3091155
                    ],
                    [
                        10.1288117,
                        54.3089722
                    ],
                    [
                        10.1287696,
                        54.3088571
                    ],
                    [
                        10.1287227,
                        54.3087454
                    ],
                    [
                        10.1286858,
                        54.3086687
                    ],
                    [
                        10.1286405,
                        54.3085899
                    ],
                    [
                        10.1285496,
                        54.3084568
                    ],
                    [
                        10.1284491,
                        54.3083321
                    ],
                    [
                        10.1283143,
                        54.3081916
                    ],
                    [
                        10.1281614,
                        54.3080574
                    ],
                    [
                        10.1279995,
                        54.3079345
                    ],
                    [
                        10.1278315,
                        54.3078241
                    ],
                    [
                        10.1277098,
                        54.307754
                    ],
                    [
                        10.1276048,
                        54.3076934
                    ],
                    [
                        10.1274319,
                        54.3076053
                    ],
                    [
                        10.1272584,
                        54.3075267
                    ],
                    [
                        10.1270029,
                        54.307423
                    ],
                    [
                        10.1267414,
                        54.3073302
                    ],
                    [
                        10.1265581,
                        54.3072739
                    ],
                    [
                        10.1263699,
                        54.3072225
                    ],
                    [
                        10.126174,
                        54.3071736
                    ],
                    [
                        10.125984,
                        54.3071331
                    ],
                    [
                        10.1257527,
                        54.3070914
                    ],
                    [
                        10.1255939,
                        54.3070652
                    ],
                    [
                        10.1254314,
                        54.3070432
                    ],
                    [
                        10.1252673,
                        54.3070258
                    ],
                    [
                        10.1250745,
                        54.307008
                    ],
                    [
                        10.1248569,
                        54.3069939
                    ],
                    [
                        10.1246478,
                        54.3069846
                    ],
                    [
                        10.1244299,
                        54.306979
                    ],
                    [
                        10.1242205,
                        54.3069791
                    ],
                    [
                        10.1240361,
                        54.306982
                    ],
                    [
                        10.1238505,
                        54.3069884
                    ],
                    [
                        10.1236615,
                        54.3069979
                    ],
                    [
                        10.1234814,
                        54.3070093
                    ],
                    [
                        10.1229927,
                        54.3070529
                    ],
                    [
                        10.1226664,
                        54.3070815
                    ],
                    [
                        10.1223425,
                        54.3071074
                    ],
                    [
                        10.1219927,
                        54.3071292
                    ],
                    [
                        10.1216537,
                        54.3071441
                    ],
                    [
                        10.1214361,
                        54.30715
                    ],
                    [
                        10.1212197,
                        54.3071538
                    ],
                    [
                        10.1210051,
                        54.3071541
                    ],
                    [
                        10.1207905,
                        54.307151
                    ],
                    [
                        10.1204759,
                        54.3071425
                    ],
                    [
                        10.1201613,
                        54.3071284
                    ],
                    [
                        10.1191197,
                        54.3070598
                    ],
                    [
                        10.1174827,
                        54.3069517
                    ],
                    [
                        10.1165663,
                        54.3068869
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "e4505616-ff15-4a7d-a8f8-de7bd40e271f",
            "railwayEdgeName": "E20",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 13733.36172101897,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.6605136,
                        53.74997
                    ],
                    [
                        9.6605305,
                        53.7499114
                    ],
                    [
                        9.6607066,
                        53.7492947
                    ],
                    [
                        9.6607155,
                        53.7492631
                    ],
                    [
                        9.6607195,
                        53.7492445
                    ],
                    [
                        9.6608046,
                        53.7489508
                    ],
                    [
                        9.6608141,
                        53.7489146
                    ],
                    [
                        9.6610351,
                        53.7481118
                    ],
                    [
                        9.6616658,
                        53.7459605
                    ],
                    [
                        9.6618491,
                        53.7453437
                    ],
                    [
                        9.6621794,
                        53.7442482
                    ],
                    [
                        9.6624428,
                        53.7435882
                    ],
                    [
                        9.6627739,
                        53.7429112
                    ],
                    [
                        9.6629952,
                        53.7424827
                    ],
                    [
                        9.6630331,
                        53.7424092
                    ],
                    [
                        9.6631794,
                        53.7421408
                    ],
                    [
                        9.6638778,
                        53.7410427
                    ],
                    [
                        9.6644827,
                        53.7402757
                    ],
                    [
                        9.6654632,
                        53.7392246
                    ],
                    [
                        9.6671543,
                        53.7376786
                    ],
                    [
                        9.6674095,
                        53.7374537
                    ],
                    [
                        9.6684789,
                        53.7365572
                    ],
                    [
                        9.6722601,
                        53.7334611
                    ],
                    [
                        9.6744383,
                        53.7316011
                    ],
                    [
                        9.6769853,
                        53.729417
                    ],
                    [
                        9.6791966,
                        53.7275517
                    ],
                    [
                        9.6799465,
                        53.726918
                    ],
                    [
                        9.685797,
                        53.7219774
                    ],
                    [
                        9.6878437,
                        53.7202489
                    ],
                    [
                        9.6939806,
                        53.7150682
                    ],
                    [
                        9.6945275,
                        53.7145704
                    ],
                    [
                        9.6951526,
                        53.7139937
                    ],
                    [
                        9.6985554,
                        53.7111924
                    ],
                    [
                        9.7016028,
                        53.7085082
                    ],
                    [
                        9.7032309,
                        53.7071228
                    ],
                    [
                        9.705598,
                        53.7051084
                    ],
                    [
                        9.7057639,
                        53.7049659
                    ],
                    [
                        9.7094639,
                        53.7017871
                    ],
                    [
                        9.7119752,
                        53.6997039
                    ],
                    [
                        9.713333,
                        53.6985777
                    ],
                    [
                        9.7141119,
                        53.697916
                    ],
                    [
                        9.7141365,
                        53.6978959
                    ],
                    [
                        9.7143585,
                        53.6977225
                    ],
                    [
                        9.7149622,
                        53.6972241
                    ],
                    [
                        9.7159306,
                        53.6964004
                    ],
                    [
                        9.7159883,
                        53.6963507
                    ],
                    [
                        9.7164883,
                        53.6959201
                    ],
                    [
                        9.7166281,
                        53.6957997
                    ],
                    [
                        9.7176296,
                        53.6950202
                    ],
                    [
                        9.7176386,
                        53.6950131
                    ],
                    [
                        9.7177313,
                        53.6949398
                    ],
                    [
                        9.7190219,
                        53.6940009
                    ],
                    [
                        9.7199922,
                        53.6933598
                    ],
                    [
                        9.7210884,
                        53.6927444
                    ],
                    [
                        9.7222479,
                        53.6921437
                    ],
                    [
                        9.7252009,
                        53.6907279
                    ],
                    [
                        9.7256973,
                        53.6904945
                    ],
                    [
                        9.7264045,
                        53.6901697
                    ],
                    [
                        9.727461,
                        53.6896785
                    ],
                    [
                        9.7276078,
                        53.689617
                    ],
                    [
                        9.7276593,
                        53.6895954
                    ],
                    [
                        9.7312445,
                        53.6880702
                    ],
                    [
                        9.7319912,
                        53.6877387
                    ],
                    [
                        9.7362158,
                        53.6858611
                    ],
                    [
                        9.7379665,
                        53.6850866
                    ],
                    [
                        9.740176,
                        53.6841228
                    ],
                    [
                        9.7422054,
                        53.6832428
                    ],
                    [
                        9.7441014,
                        53.6823427
                    ],
                    [
                        9.7446996,
                        53.6820603
                    ],
                    [
                        9.7504864,
                        53.6795479
                    ],
                    [
                        9.7531894,
                        53.6783732
                    ],
                    [
                        9.7540662,
                        53.6779971
                    ],
                    [
                        9.757168,
                        53.6766097
                    ],
                    [
                        9.7602365,
                        53.675254
                    ],
                    [
                        9.7617758,
                        53.6745756
                    ],
                    [
                        9.7642993,
                        53.6734634
                    ],
                    [
                        9.7653739,
                        53.6729959
                    ],
                    [
                        9.7682878,
                        53.6717284
                    ],
                    [
                        9.7747473,
                        53.6688196
                    ],
                    [
                        9.7773222,
                        53.6676714
                    ],
                    [
                        9.7811674,
                        53.6659566
                    ],
                    [
                        9.7833315,
                        53.6648008
                    ],
                    [
                        9.7834632,
                        53.6647305
                    ],
                    [
                        9.7841146,
                        53.6642927
                    ],
                    [
                        9.7860594,
                        53.6629855
                    ],
                    [
                        9.7862769,
                        53.6628363
                    ],
                    [
                        9.7867645,
                        53.6625019
                    ],
                    [
                        9.7874733,
                        53.6620219
                    ],
                    [
                        9.7875795,
                        53.6619528
                    ],
                    [
                        9.7880013,
                        53.6616756
                    ],
                    [
                        9.7888338,
                        53.6611283
                    ],
                    [
                        9.789998,
                        53.6603127
                    ],
                    [
                        9.7902632,
                        53.6601279
                    ],
                    [
                        9.790337,
                        53.6600778
                    ],
                    [
                        9.7913084,
                        53.659405
                    ],
                    [
                        9.7913486,
                        53.6593784
                    ],
                    [
                        9.7913865,
                        53.6593546
                    ],
                    [
                        9.7918539,
                        53.6590424
                    ],
                    [
                        9.7919481,
                        53.6589776
                    ],
                    [
                        9.7923791,
                        53.6586811
                    ],
                    [
                        9.7929298,
                        53.6583026
                    ],
                    [
                        9.7931419,
                        53.6581513
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "905efa5f-22b1-4272-9d28-dfcc62e790d1",
            "railwayEdgeName": "E41",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 2178.0104819588623,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9613386,
                        54.1007924
                    ],
                    [
                        9.9613443,
                        54.1007881
                    ],
                    [
                        9.962008,
                        54.1003725
                    ],
                    [
                        9.9626352,
                        54.0999732
                    ],
                    [
                        9.9627038,
                        54.0999291
                    ],
                    [
                        9.963143,
                        54.0996667
                    ],
                    [
                        9.9634237,
                        54.09951
                    ],
                    [
                        9.963742,
                        54.0993467
                    ],
                    [
                        9.9640204,
                        54.0992187
                    ],
                    [
                        9.9641808,
                        54.0991488
                    ],
                    [
                        9.9645436,
                        54.099007
                    ],
                    [
                        9.9649313,
                        54.0988748
                    ],
                    [
                        9.9651684,
                        54.0987998
                    ],
                    [
                        9.9654137,
                        54.0987297
                    ],
                    [
                        9.9656683,
                        54.0986656
                    ],
                    [
                        9.9659261,
                        54.0986055
                    ],
                    [
                        9.96618,
                        54.0985538
                    ],
                    [
                        9.9664305,
                        54.098507
                    ],
                    [
                        9.966692,
                        54.0984652
                    ],
                    [
                        9.9669552,
                        54.0984264
                    ],
                    [
                        9.9673634,
                        54.0983853
                    ],
                    [
                        9.9677782,
                        54.0983491
                    ],
                    [
                        9.9679493,
                        54.0983396
                    ],
                    [
                        9.9681204,
                        54.098332
                    ],
                    [
                        9.9684217,
                        54.0983231
                    ],
                    [
                        9.9687264,
                        54.0983171
                    ],
                    [
                        9.971121,
                        54.0983282
                    ],
                    [
                        9.973651,
                        54.0983442
                    ],
                    [
                        9.9777248,
                        54.0983689
                    ],
                    [
                        9.9783049,
                        54.0983597
                    ],
                    [
                        9.978797,
                        54.0983419
                    ],
                    [
                        9.9793071,
                        54.0983022
                    ],
                    [
                        9.9795398,
                        54.0982788
                    ],
                    [
                        9.9797658,
                        54.0982515
                    ],
                    [
                        9.9799797,
                        54.0982191
                    ],
                    [
                        9.9801802,
                        54.0981853
                    ],
                    [
                        9.9804096,
                        54.0981447
                    ],
                    [
                        9.9806289,
                        54.0981001
                    ],
                    [
                        9.9808865,
                        54.0980394
                    ],
                    [
                        9.9811664,
                        54.0979661
                    ],
                    [
                        9.981456,
                        54.0978861
                    ],
                    [
                        9.9817411,
                        54.0977996
                    ],
                    [
                        9.9818407,
                        54.097765
                    ],
                    [
                        9.9821234,
                        54.0976643
                    ],
                    [
                        9.9824401,
                        54.0975388
                    ],
                    [
                        9.982689,
                        54.0974266
                    ],
                    [
                        9.9829394,
                        54.097309
                    ],
                    [
                        9.9831228,
                        54.0972147
                    ],
                    [
                        9.9833924,
                        54.0970629
                    ],
                    [
                        9.9836472,
                        54.0969054
                    ],
                    [
                        9.9838627,
                        54.096763
                    ],
                    [
                        9.9839702,
                        54.096683
                    ],
                    [
                        9.9840401,
                        54.096626
                    ],
                    [
                        9.9843301,
                        54.0963933
                    ],
                    [
                        9.9845176,
                        54.0962256
                    ],
                    [
                        9.9847997,
                        54.09593
                    ],
                    [
                        9.9848787,
                        54.0958347
                    ],
                    [
                        9.985151,
                        54.0954559
                    ],
                    [
                        9.9852824,
                        54.0952291
                    ],
                    [
                        9.9853963,
                        54.0950023
                    ],
                    [
                        9.9854442,
                        54.0948859
                    ],
                    [
                        9.9855195,
                        54.0946604
                    ],
                    [
                        9.9855684,
                        54.0944919
                    ],
                    [
                        9.9856068,
                        54.0943194
                    ],
                    [
                        9.9856252,
                        54.0941807
                    ],
                    [
                        9.9856384,
                        54.0940554
                    ],
                    [
                        9.9856475,
                        54.0938713
                    ],
                    [
                        9.9856441,
                        54.0937093
                    ],
                    [
                        9.9856185,
                        54.0934403
                    ],
                    [
                        9.9855798,
                        54.0932095
                    ],
                    [
                        9.9855484,
                        54.0930658
                    ],
                    [
                        9.9854985,
                        54.0927787
                    ],
                    [
                        9.9854442,
                        54.0925344
                    ],
                    [
                        9.9853095,
                        54.0920134
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "b7b12798-2f58-45d7-8805-e217a3fc76b4",
            "railwayEdgeName": "E48",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 85.17358154258473,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9820648,
                        54.0816375
                    ],
                    [
                        9.9820946,
                        54.0817971
                    ],
                    [
                        9.9821168,
                        54.0819523
                    ],
                    [
                        9.9821351,
                        54.0821732
                    ],
                    [
                        9.9821476,
                        54.0822667
                    ],
                    [
                        9.9821678,
                        54.0824004
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "6da0a1d7-8b78-41a7-9a23-e2325bc25fc7",
            "railwayEdgeName": "E13",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 2740.161023007507,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.7195325,
                        53.6936025
                    ],
                    [
                        9.7192358,
                        53.6937863
                    ],
                    [
                        9.7190227,
                        53.6939016
                    ],
                    [
                        9.718874,
                        53.6939843
                    ],
                    [
                        9.7187421,
                        53.6940705
                    ],
                    [
                        9.7180606,
                        53.6945371
                    ],
                    [
                        9.717597,
                        53.6948762
                    ],
                    [
                        9.7167089,
                        53.6955781
                    ],
                    [
                        9.7161415,
                        53.6959813
                    ],
                    [
                        9.715682,
                        53.6962828
                    ],
                    [
                        9.7155763,
                        53.6963625
                    ],
                    [
                        9.7155064,
                        53.6964104
                    ],
                    [
                        9.7154637,
                        53.6964397
                    ],
                    [
                        9.715162,
                        53.6966466
                    ],
                    [
                        9.714839,
                        53.696834
                    ],
                    [
                        9.7144706,
                        53.6970293
                    ],
                    [
                        9.7142001,
                        53.6971141
                    ],
                    [
                        9.7138997,
                        53.6971692
                    ],
                    [
                        9.7137511,
                        53.697182
                    ],
                    [
                        9.7135466,
                        53.6971996
                    ],
                    [
                        9.7131582,
                        53.6972007
                    ],
                    [
                        9.7126007,
                        53.6971683
                    ],
                    [
                        9.7122226,
                        53.6971475
                    ],
                    [
                        9.7118439,
                        53.6970987
                    ],
                    [
                        9.7107384,
                        53.6968539
                    ],
                    [
                        9.7103037,
                        53.6967376
                    ],
                    [
                        9.7099257,
                        53.6966001
                    ],
                    [
                        9.7088916,
                        53.69613
                    ],
                    [
                        9.7077394,
                        53.695627
                    ],
                    [
                        9.706381,
                        53.6950037
                    ],
                    [
                        9.7056217,
                        53.6945827
                    ],
                    [
                        9.7029586,
                        53.693138
                    ],
                    [
                        9.7006412,
                        53.6919031
                    ],
                    [
                        9.6998012,
                        53.6914593
                    ],
                    [
                        9.6990316,
                        53.6910528
                    ],
                    [
                        9.6986927,
                        53.6909006
                    ],
                    [
                        9.6983005,
                        53.69077
                    ],
                    [
                        9.6975276,
                        53.690547
                    ],
                    [
                        9.6964558,
                        53.6902408
                    ],
                    [
                        9.6961697,
                        53.6901653
                    ],
                    [
                        9.6959245,
                        53.6900928
                    ],
                    [
                        9.6952754,
                        53.6898965
                    ],
                    [
                        9.6945146,
                        53.689688
                    ],
                    [
                        9.694431,
                        53.6896651
                    ],
                    [
                        9.6932668,
                        53.6892625
                    ],
                    [
                        9.6905612,
                        53.687687
                    ],
                    [
                        9.6902456,
                        53.6875003
                    ],
                    [
                        9.6892903,
                        53.6869195
                    ],
                    [
                        9.6888423,
                        53.6865931
                    ],
                    [
                        9.6884273,
                        53.6862576
                    ],
                    [
                        9.6879592,
                        53.6858834
                    ],
                    [
                        9.6877453,
                        53.6857345
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "781b6fe5-3bb2-499b-8757-e54116d8a6a2",
            "railwayEdgeName": "E56",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 1146.672770488916,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.9850034,
                        54.0910091
                    ],
                    [
                        9.9849534,
                        54.0908312
                    ],
                    [
                        9.9848471,
                        54.0905049
                    ],
                    [
                        9.9847808,
                        54.0903058
                    ],
                    [
                        9.9846686,
                        54.0899345
                    ],
                    [
                        9.9843083,
                        54.0887551
                    ],
                    [
                        9.9842039,
                        54.088399
                    ],
                    [
                        9.9828856,
                        54.084096
                    ],
                    [
                        9.9825461,
                        54.0829815
                    ],
                    [
                        9.9823473,
                        54.0823364
                    ],
                    [
                        9.9821946,
                        54.0818286
                    ],
                    [
                        9.9820618,
                        54.0814082
                    ],
                    [
                        9.9820462,
                        54.0813612
                    ],
                    [
                        9.9819788,
                        54.0811543
                    ],
                    [
                        9.9818757,
                        54.0808692
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "a8be4a7b-4d68-4fec-82f2-e930eb148b4a",
            "railwayEdgeName": "E66",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 42.829542926295005,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8129352,
                        53.9845251
                    ],
                    [
                        9.8126754,
                        53.984391
                    ],
                    [
                        9.8124437,
                        53.9842716
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "94209ba0-31f9-4183-824a-ecb9aa7d978d",
            "railwayEdgeName": "E2",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 14091.737903831909,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8268189,
                        53.9916314
                    ],
                    [
                        9.8301142,
                        53.9933353
                    ],
                    [
                        9.8320437,
                        53.9943344
                    ],
                    [
                        9.8389125,
                        53.9978626
                    ],
                    [
                        9.8416173,
                        53.9992701
                    ],
                    [
                        9.8449872,
                        54.0010054
                    ],
                    [
                        9.8519248,
                        54.0045754
                    ],
                    [
                        9.858808,
                        54.008116
                    ],
                    [
                        9.8648571,
                        54.0112227
                    ],
                    [
                        9.8694136,
                        54.0135639
                    ],
                    [
                        9.8718627,
                        54.0148223
                    ],
                    [
                        9.878582,
                        54.018274
                    ],
                    [
                        9.8809954,
                        54.0195137
                    ],
                    [
                        9.8817175,
                        54.0198841
                    ],
                    [
                        9.882491,
                        54.0202792
                    ],
                    [
                        9.884479,
                        54.0213004
                    ],
                    [
                        9.8911101,
                        54.0247054
                    ],
                    [
                        9.8921738,
                        54.0252444
                    ],
                    [
                        9.8940367,
                        54.026206
                    ],
                    [
                        9.8994181,
                        54.0289617
                    ],
                    [
                        9.9072146,
                        54.0329644
                    ],
                    [
                        9.914314,
                        54.036585
                    ],
                    [
                        9.9146548,
                        54.0367745
                    ],
                    [
                        9.921689,
                        54.0403676
                    ],
                    [
                        9.9274001,
                        54.0433071
                    ],
                    [
                        9.9278301,
                        54.0435255
                    ],
                    [
                        9.9284539,
                        54.0438456
                    ],
                    [
                        9.9305868,
                        54.0449365
                    ],
                    [
                        9.938277,
                        54.0488751
                    ],
                    [
                        9.9389364,
                        54.0492131
                    ],
                    [
                        9.9396511,
                        54.0495773
                    ],
                    [
                        9.9398983,
                        54.0497054
                    ],
                    [
                        9.9406683,
                        54.0500952
                    ],
                    [
                        9.9443882,
                        54.0520044
                    ],
                    [
                        9.9445481,
                        54.0520876
                    ],
                    [
                        9.9518739,
                        54.0558446
                    ],
                    [
                        9.9525902,
                        54.056212
                    ],
                    [
                        9.9528484,
                        54.0563436
                    ],
                    [
                        9.9586676,
                        54.0593338
                    ],
                    [
                        9.9629168,
                        54.0615153
                    ],
                    [
                        9.9660214,
                        54.0631094
                    ],
                    [
                        9.966692,
                        54.0634569
                    ],
                    [
                        9.966816,
                        54.0635194
                    ],
                    [
                        9.9672986,
                        54.063772
                    ],
                    [
                        9.9675396,
                        54.0638978
                    ],
                    [
                        9.9687114,
                        54.0645439
                    ],
                    [
                        9.9692535,
                        54.0648487
                    ],
                    [
                        9.9695282,
                        54.0650104
                    ],
                    [
                        9.9697436,
                        54.0651408
                    ],
                    [
                        9.9704406,
                        54.0655649
                    ],
                    [
                        9.9711221,
                        54.0660034
                    ],
                    [
                        9.9715139,
                        54.066265
                    ],
                    [
                        9.9723965,
                        54.0668779
                    ],
                    [
                        9.9728321,
                        54.0672029
                    ],
                    [
                        9.9738962,
                        54.0680272
                    ],
                    [
                        9.9740882,
                        54.0681859
                    ],
                    [
                        9.974444,
                        54.0684826
                    ],
                    [
                        9.9749423,
                        54.068915
                    ],
                    [
                        9.9751479,
                        54.0691121
                    ],
                    [
                        9.9753111,
                        54.0692746
                    ],
                    [
                        9.9758638,
                        54.0698387
                    ],
                    [
                        9.9764294,
                        54.0704157
                    ],
                    [
                        9.9765434,
                        54.0705378
                    ],
                    [
                        9.9767787,
                        54.0707961
                    ],
                    [
                        9.9769976,
                        54.0710468
                    ],
                    [
                        9.9771132,
                        54.071185
                    ],
                    [
                        9.9773154,
                        54.0714295
                    ],
                    [
                        9.9773738,
                        54.0715069
                    ],
                    [
                        9.9774206,
                        54.0715623
                    ],
                    [
                        9.9775281,
                        54.0716947
                    ],
                    [
                        9.9775354,
                        54.0717045
                    ],
                    [
                        9.9775513,
                        54.0717233
                    ],
                    [
                        9.9775942,
                        54.0717751
                    ],
                    [
                        9.9779489,
                        54.0721839
                    ],
                    [
                        9.9783541,
                        54.0726515
                    ],
                    [
                        9.9784678,
                        54.0727877
                    ],
                    [
                        9.9786329,
                        54.0729812
                    ],
                    [
                        9.9786849,
                        54.0730399
                    ],
                    [
                        9.9787612,
                        54.0731406
                    ],
                    [
                        9.9788564,
                        54.0732813
                    ],
                    [
                        9.9789518,
                        54.0734219
                    ],
                    [
                        9.9790192,
                        54.0735426
                    ],
                    [
                        9.9790934,
                        54.0736926
                    ],
                    [
                        9.9791392,
                        54.0737835
                    ],
                    [
                        9.9791672,
                        54.073859
                    ],
                    [
                        9.9792404,
                        54.0740519
                    ],
                    [
                        9.9793877,
                        54.0744696
                    ],
                    [
                        9.9794988,
                        54.0748058
                    ],
                    [
                        9.9795599,
                        54.0749853
                    ],
                    [
                        9.9796046,
                        54.0751162
                    ],
                    [
                        9.9796708,
                        54.0752756
                    ],
                    [
                        9.979738,
                        54.0754134
                    ],
                    [
                        9.9798237,
                        54.0755864
                    ],
                    [
                        9.9798886,
                        54.0757217
                    ],
                    [
                        9.9801323,
                        54.0762248
                    ],
                    [
                        9.9802023,
                        54.0763597
                    ],
                    [
                        9.9803178,
                        54.0765534
                    ],
                    [
                        9.9804649,
                        54.0767657
                    ],
                    [
                        9.9805168,
                        54.0768396
                    ],
                    [
                        9.980573,
                        54.0769236
                    ],
                    [
                        9.9806282,
                        54.0770139
                    ],
                    [
                        9.980677,
                        54.0770988
                    ],
                    [
                        9.9807334,
                        54.0772055
                    ],
                    [
                        9.9808019,
                        54.0773703
                    ],
                    [
                        9.9808591,
                        54.0775387
                    ],
                    [
                        9.980898,
                        54.0776494
                    ],
                    [
                        9.9810934,
                        54.0782075
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "9cc46267-dc70-4397-810d-eccf3ea8ea77",
            "railwayEdgeName": "E32",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 84.47674951297283,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0963115,
                        54.2800263
                    ],
                    [
                        10.0962411,
                        54.2799632
                    ],
                    [
                        10.0961462,
                        54.2798796
                    ],
                    [
                        10.0957475,
                        54.2794682
                    ],
                    [
                        10.095651,
                        54.2793732
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "a0e8c1d7-7cf8-4fd7-a6df-f4c9b27973b5",
            "railwayEdgeName": "E44",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 2557.3720076992545,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.929778,
                        53.5747766
                    ],
                    [
                        9.9301917,
                        53.574348
                    ],
                    [
                        9.9304608,
                        53.5740709
                    ],
                    [
                        9.9309056,
                        53.5736139
                    ],
                    [
                        9.931195,
                        53.5733319
                    ],
                    [
                        9.9316849,
                        53.5728506
                    ],
                    [
                        9.9317327,
                        53.572802
                    ],
                    [
                        9.9323697,
                        53.5721549
                    ],
                    [
                        9.932746,
                        53.5717698
                    ],
                    [
                        9.9327906,
                        53.5717242
                    ],
                    [
                        9.933091,
                        53.5712708
                    ],
                    [
                        9.9332411,
                        53.570981
                    ],
                    [
                        9.9333013,
                        53.5708397
                    ],
                    [
                        9.933405,
                        53.570526
                    ],
                    [
                        9.9334509,
                        53.5702914
                    ],
                    [
                        9.9334836,
                        53.5700861
                    ],
                    [
                        9.933499,
                        53.5699515
                    ],
                    [
                        9.9335152,
                        53.569602
                    ],
                    [
                        9.9335029,
                        53.5693331
                    ],
                    [
                        9.9334659,
                        53.5686481
                    ],
                    [
                        9.9334658,
                        53.5685228
                    ],
                    [
                        9.9334644,
                        53.5680832
                    ],
                    [
                        9.9335514,
                        53.5673803
                    ],
                    [
                        9.933558,
                        53.5673309
                    ],
                    [
                        9.9336134,
                        53.5668876
                    ],
                    [
                        9.9336359,
                        53.5667079
                    ],
                    [
                        9.9336433,
                        53.5666412
                    ],
                    [
                        9.9336556,
                        53.5665923
                    ],
                    [
                        9.9337419,
                        53.5659554
                    ],
                    [
                        9.9337661,
                        53.5657765
                    ],
                    [
                        9.9338652,
                        53.5648222
                    ],
                    [
                        9.9338868,
                        53.5646479
                    ],
                    [
                        9.9339229,
                        53.5644477
                    ],
                    [
                        9.9339957,
                        53.5641884
                    ],
                    [
                        9.9340698,
                        53.5639897
                    ],
                    [
                        9.9341805,
                        53.5637911
                    ],
                    [
                        9.9342827,
                        53.5636348
                    ],
                    [
                        9.9344219,
                        53.5634571
                    ],
                    [
                        9.9345506,
                        53.5633215
                    ],
                    [
                        9.9348659,
                        53.5629565
                    ],
                    [
                        9.9351639,
                        53.5626258
                    ],
                    [
                        9.935286,
                        53.5624233
                    ],
                    [
                        9.9354291,
                        53.5621484
                    ],
                    [
                        9.9354801,
                        53.5619965
                    ],
                    [
                        9.9355235,
                        53.5618674
                    ],
                    [
                        9.9355692,
                        53.5616819
                    ],
                    [
                        9.9356047,
                        53.5614525
                    ],
                    [
                        9.9356131,
                        53.5612283
                    ],
                    [
                        9.9356031,
                        53.5610918
                    ],
                    [
                        9.9355734,
                        53.5608946
                    ],
                    [
                        9.9355292,
                        53.5606864
                    ],
                    [
                        9.9354443,
                        53.5603044
                    ],
                    [
                        9.9354089,
                        53.5599097
                    ],
                    [
                        9.9354259,
                        53.5594368
                    ],
                    [
                        9.9355274,
                        53.5586521
                    ],
                    [
                        9.9355413,
                        53.5585476
                    ],
                    [
                        9.9355828,
                        53.5582365
                    ],
                    [
                        9.9355982,
                        53.5580615
                    ],
                    [
                        9.9355895,
                        53.5576386
                    ],
                    [
                        9.9355721,
                        53.5573593
                    ],
                    [
                        9.9355466,
                        53.5568364
                    ],
                    [
                        9.935537,
                        53.5565646
                    ],
                    [
                        9.9355336,
                        53.5564668
                    ],
                    [
                        9.9355413,
                        53.5563619
                    ],
                    [
                        9.9355296,
                        53.5560192
                    ],
                    [
                        9.9355304,
                        53.5558529
                    ],
                    [
                        9.935529,
                        53.5558214
                    ],
                    [
                        9.9355207,
                        53.5556271
                    ],
                    [
                        9.9354824,
                        53.5547306
                    ],
                    [
                        9.935465,
                        53.5543245
                    ],
                    [
                        9.9354382,
                        53.5537587
                    ],
                    [
                        9.935426,
                        53.5534995
                    ],
                    [
                        9.9354125,
                        53.5531712
                    ],
                    [
                        9.9354096,
                        53.5530712
                    ],
                    [
                        9.9353852,
                        53.5525671
                    ],
                    [
                        9.935385,
                        53.5525616
                    ],
                    [
                        9.9353848,
                        53.5525558
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "96f01ef1-3f8d-4dfc-a340-f7c49e1d46cc",
            "railwayEdgeName": "E81",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 101.65965588258153,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.0966836,
                        54.2803117
                    ],
                    [
                        10.096932,
                        54.2805051
                    ],
                    [
                        10.0972754,
                        54.280799
                    ],
                    [
                        10.0974193,
                        54.2809102
                    ],
                    [
                        10.09749,
                        54.280966
                    ],
                    [
                        10.0976081,
                        54.2810473
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "842a8fb0-d4d8-4ce4-b6eb-fbd9a88bf9b1",
            "railwayEdgeName": "E31",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 5674.415528127056,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        10.095651,
                        54.2793732
                    ],
                    [
                        10.0958955,
                        54.2795937
                    ],
                    [
                        10.0960938,
                        54.2797618
                    ],
                    [
                        10.0962841,
                        54.2799122
                    ],
                    [
                        10.0963675,
                        54.279986
                    ],
                    [
                        10.0967308,
                        54.2802649
                    ],
                    [
                        10.0970551,
                        54.2805112
                    ],
                    [
                        10.0974634,
                        54.28081
                    ],
                    [
                        10.0979819,
                        54.2811759
                    ],
                    [
                        10.0985977,
                        54.2815909
                    ],
                    [
                        10.0989246,
                        54.2817984
                    ],
                    [
                        10.0992642,
                        54.2820036
                    ],
                    [
                        10.0994969,
                        54.2821371
                    ],
                    [
                        10.0996952,
                        54.2822465
                    ],
                    [
                        10.0999309,
                        54.2823724
                    ],
                    [
                        10.1002738,
                        54.2825427
                    ],
                    [
                        10.1006394,
                        54.2827148
                    ],
                    [
                        10.1010159,
                        54.2828812
                    ],
                    [
                        10.1013747,
                        54.2830313
                    ],
                    [
                        10.1017295,
                        54.2831686
                    ],
                    [
                        10.1021679,
                        54.283329
                    ],
                    [
                        10.1025652,
                        54.2834642
                    ],
                    [
                        10.1029789,
                        54.283593
                    ],
                    [
                        10.1032703,
                        54.2836801
                    ],
                    [
                        10.1035676,
                        54.2837628
                    ],
                    [
                        10.1038146,
                        54.2838281
                    ],
                    [
                        10.1041255,
                        54.2839069
                    ],
                    [
                        10.1044001,
                        54.2839712
                    ],
                    [
                        10.1046805,
                        54.2840349
                    ],
                    [
                        10.1050626,
                        54.2841125
                    ],
                    [
                        10.1055461,
                        54.2842029
                    ],
                    [
                        10.1060101,
                        54.2842851
                    ],
                    [
                        10.106394,
                        54.2843474
                    ],
                    [
                        10.1067507,
                        54.2844017
                    ],
                    [
                        10.1071073,
                        54.2844524
                    ],
                    [
                        10.107479,
                        54.2845018
                    ],
                    [
                        10.1078342,
                        54.284546
                    ],
                    [
                        10.1084417,
                        54.2846146
                    ],
                    [
                        10.1089706,
                        54.2846674
                    ],
                    [
                        10.1094999,
                        54.284715
                    ],
                    [
                        10.1101669,
                        54.2847698
                    ],
                    [
                        10.1123868,
                        54.2849369
                    ],
                    [
                        10.1161387,
                        54.285214
                    ],
                    [
                        10.117588,
                        54.2853403
                    ],
                    [
                        10.1179365,
                        54.2853773
                    ],
                    [
                        10.1182827,
                        54.2854181
                    ],
                    [
                        10.1186236,
                        54.2854593
                    ],
                    [
                        10.1189689,
                        54.2855043
                    ],
                    [
                        10.1193002,
                        54.2855508
                    ],
                    [
                        10.1196294,
                        54.2856012
                    ],
                    [
                        10.1199918,
                        54.2856586
                    ],
                    [
                        10.1202725,
                        54.2857048
                    ],
                    [
                        10.120551,
                        54.2857535
                    ],
                    [
                        10.1210069,
                        54.2858387
                    ],
                    [
                        10.1214585,
                        54.2859276
                    ],
                    [
                        10.1219158,
                        54.2860247
                    ],
                    [
                        10.12236,
                        54.2861231
                    ],
                    [
                        10.1226841,
                        54.2861984
                    ],
                    [
                        10.1230039,
                        54.2862776
                    ],
                    [
                        10.1233374,
                        54.2863621
                    ],
                    [
                        10.1236665,
                        54.2864504
                    ],
                    [
                        10.1241348,
                        54.2865805
                    ],
                    [
                        10.1245987,
                        54.2867156
                    ],
                    [
                        10.1251488,
                        54.2868853
                    ],
                    [
                        10.1257113,
                        54.2870709
                    ],
                    [
                        10.1262537,
                        54.287262
                    ],
                    [
                        10.1267851,
                        54.2874594
                    ],
                    [
                        10.1272491,
                        54.2876431
                    ],
                    [
                        10.1275785,
                        54.2877836
                    ],
                    [
                        10.1279058,
                        54.2879266
                    ],
                    [
                        10.1282791,
                        54.2881007
                    ],
                    [
                        10.1286501,
                        54.2882838
                    ],
                    [
                        10.128958,
                        54.288443
                    ],
                    [
                        10.1292572,
                        54.2886048
                    ],
                    [
                        10.1295304,
                        54.28876
                    ],
                    [
                        10.1297637,
                        54.2888963
                    ],
                    [
                        10.1299992,
                        54.2890402
                    ],
                    [
                        10.1303057,
                        54.2892364
                    ],
                    [
                        10.1306078,
                        54.2894389
                    ],
                    [
                        10.1308473,
                        54.2896066
                    ],
                    [
                        10.1310847,
                        54.2897806
                    ],
                    [
                        10.1313921,
                        54.2900188
                    ],
                    [
                        10.1316358,
                        54.2902167
                    ],
                    [
                        10.1318175,
                        54.2903731
                    ],
                    [
                        10.1319431,
                        54.2904818
                    ],
                    [
                        10.1322175,
                        54.290733
                    ],
                    [
                        10.1324671,
                        54.2909746
                    ],
                    [
                        10.132855,
                        54.2913681
                    ],
                    [
                        10.13332,
                        54.2918645
                    ],
                    [
                        10.1341786,
                        54.2927964
                    ],
                    [
                        10.1344242,
                        54.2930782
                    ],
                    [
                        10.1346151,
                        54.2933067
                    ],
                    [
                        10.1348096,
                        54.2935587
                    ],
                    [
                        10.1349961,
                        54.2938245
                    ],
                    [
                        10.1351683,
                        54.2940902
                    ],
                    [
                        10.1353317,
                        54.2943735
                    ],
                    [
                        10.1354774,
                        54.2946548
                    ],
                    [
                        10.1357007,
                        54.2951575
                    ],
                    [
                        10.1358152,
                        54.2954426
                    ],
                    [
                        10.1359148,
                        54.2957309
                    ],
                    [
                        10.1360585,
                        54.2962446
                    ],
                    [
                        10.136135,
                        54.2965966
                    ],
                    [
                        10.1361953,
                        54.2969372
                    ],
                    [
                        10.1362359,
                        54.2972066
                    ],
                    [
                        10.1362579,
                        54.297476
                    ],
                    [
                        10.1362711,
                        54.2977179
                    ],
                    [
                        10.1362771,
                        54.297958
                    ],
                    [
                        10.1362736,
                        54.2981498
                    ],
                    [
                        10.1362608,
                        54.2983583
                    ],
                    [
                        10.1362396,
                        54.2985771
                    ],
                    [
                        10.1362181,
                        54.2987346
                    ],
                    [
                        10.136187,
                        54.2989216
                    ],
                    [
                        10.1361487,
                        54.2991095
                    ],
                    [
                        10.1360917,
                        54.2993439
                    ],
                    [
                        10.1360233,
                        54.299575
                    ],
                    [
                        10.1359313,
                        54.2998424
                    ],
                    [
                        10.1358603,
                        54.3000262
                    ],
                    [
                        10.1357965,
                        54.300173
                    ],
                    [
                        10.1356616,
                        54.3004606
                    ],
                    [
                        10.1355051,
                        54.3007552
                    ],
                    [
                        10.135346,
                        54.3010235
                    ],
                    [
                        10.1351885,
                        54.3012634
                    ],
                    [
                        10.1350252,
                        54.3014895
                    ],
                    [
                        10.1348202,
                        54.3017604
                    ],
                    [
                        10.1345942,
                        54.3020271
                    ],
                    [
                        10.1343835,
                        54.302262
                    ],
                    [
                        10.1340934,
                        54.302565
                    ],
                    [
                        10.1330973,
                        54.3035725
                    ],
                    [
                        10.1325801,
                        54.3040961
                    ],
                    [
                        10.1322123,
                        54.3044727
                    ],
                    [
                        10.1313981,
                        54.3053419
                    ],
                    [
                        10.1308181,
                        54.3059726
                    ],
                    [
                        10.1306544,
                        54.3061656
                    ],
                    [
                        10.1306014,
                        54.3062296
                    ],
                    [
                        10.1304926,
                        54.3063708
                    ],
                    [
                        10.1303866,
                        54.3065178
                    ],
                    [
                        10.1302888,
                        54.3066692
                    ],
                    [
                        10.1301981,
                        54.3068231
                    ],
                    [
                        10.130093,
                        54.3070254
                    ],
                    [
                        10.1300281,
                        54.3071656
                    ],
                    [
                        10.1299,
                        54.3074943
                    ],
                    [
                        10.1298502,
                        54.3076627
                    ],
                    [
                        10.1298076,
                        54.3078304
                    ],
                    [
                        10.1296808,
                        54.3084988
                    ],
                    [
                        10.1296647,
                        54.3086245
                    ],
                    [
                        10.1296404,
                        54.3088799
                    ],
                    [
                        10.1296354,
                        54.3089425
                    ],
                    [
                        10.1296339,
                        54.3091604
                    ],
                    [
                        10.1296428,
                        54.3093671
                    ],
                    [
                        10.1296619,
                        54.3095701
                    ],
                    [
                        10.1296901,
                        54.3097311
                    ],
                    [
                        10.1297166,
                        54.3098485
                    ],
                    [
                        10.1297723,
                        54.3100773
                    ],
                    [
                        10.1298688,
                        54.3104165
                    ],
                    [
                        10.1299079,
                        54.3105417
                    ],
                    [
                        10.1299541,
                        54.3107323
                    ],
                    [
                        10.1299888,
                        54.310848
                    ],
                    [
                        10.1300385,
                        54.3110106
                    ],
                    [
                        10.1302094,
                        54.3115398
                    ],
                    [
                        10.1302526,
                        54.31167
                    ],
                    [
                        10.1304377,
                        54.3122061
                    ],
                    [
                        10.1304699,
                        54.3122873
                    ],
                    [
                        10.1305739,
                        54.3125046
                    ],
                    [
                        10.1306062,
                        54.3125672
                    ],
                    [
                        10.1310234,
                        54.3133083
                    ],
                    [
                        10.1319005,
                        54.3148683
                    ],
                    [
                        10.1319412,
                        54.3149417
                    ]
                ]
            }
        },
        {
            "railwayEdgeId": "30cb4516-2722-4894-bd6a-fdcf6ea43604",
            "railwayEdgeName": "E17",
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "length": 7639.361386061242,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        9.8778771,
                        53.610541
                    ],
                    [
                        9.8777206,
                        53.6106182
                    ],
                    [
                        9.8754148,
                        53.611772
                    ],
                    [
                        9.8723316,
                        53.6133461
                    ],
                    [
                        9.8706102,
                        53.6142112
                    ],
                    [
                        9.8697655,
                        53.6146357
                    ],
                    [
                        9.8667883,
                        53.6161828
                    ],
                    [
                        9.8665532,
                        53.6163041
                    ],
                    [
                        9.8650627,
                        53.6170711
                    ],
                    [
                        9.8617668,
                        53.6187461
                    ],
                    [
                        9.8600882,
                        53.6196281
                    ],
                    [
                        9.8592064,
                        53.6201021
                    ],
                    [
                        9.8588801,
                        53.6202775
                    ],
                    [
                        9.8586268,
                        53.620417
                    ],
                    [
                        9.8571852,
                        53.6211619
                    ],
                    [
                        9.8556423,
                        53.6219455
                    ],
                    [
                        9.8553023,
                        53.6221203
                    ],
                    [
                        9.8548034,
                        53.6223773
                    ],
                    [
                        9.8521973,
                        53.6237123
                    ],
                    [
                        9.8519946,
                        53.6238148
                    ],
                    [
                        9.8519872,
                        53.6238186
                    ],
                    [
                        9.8469105,
                        53.626402
                    ],
                    [
                        9.84394,
                        53.6278702
                    ],
                    [
                        9.8406337,
                        53.6295163
                    ],
                    [
                        9.8403558,
                        53.6296496
                    ],
                    [
                        9.8390685,
                        53.6302875
                    ],
                    [
                        9.8376209,
                        53.6310539
                    ],
                    [
                        9.837202,
                        53.6312969
                    ],
                    [
                        9.8354409,
                        53.632288
                    ],
                    [
                        9.8343017,
                        53.6328801
                    ],
                    [
                        9.8332162,
                        53.6334283
                    ],
                    [
                        9.8322449,
                        53.6339279
                    ],
                    [
                        9.8319931,
                        53.6340549
                    ],
                    [
                        9.8297862,
                        53.6351867
                    ],
                    [
                        9.8228492,
                        53.6387373
                    ],
                    [
                        9.8215295,
                        53.6394164
                    ],
                    [
                        9.8198278,
                        53.6403051
                    ],
                    [
                        9.8188719,
                        53.6408533
                    ],
                    [
                        9.8174446,
                        53.6417967
                    ],
                    [
                        9.8165248,
                        53.6424145
                    ],
                    [
                        9.815193,
                        53.6433089
                    ],
                    [
                        9.8137503,
                        53.6442779
                    ],
                    [
                        9.8097141,
                        53.646985
                    ],
                    [
                        9.8050983,
                        53.6500807
                    ],
                    [
                        9.8036915,
                        53.6510046
                    ],
                    [
                        9.8028161,
                        53.6516086
                    ],
                    [
                        9.802752,
                        53.6516528
                    ],
                    [
                        9.8022071,
                        53.6520179
                    ],
                    [
                        9.8013387,
                        53.6526063
                    ],
                    [
                        9.8009978,
                        53.6528475
                    ],
                    [
                        9.8007276,
                        53.6530342
                    ],
                    [
                        9.8005113,
                        53.6531716
                    ],
                    [
                        9.8000634,
                        53.6534747
                    ],
                    [
                        9.7995966,
                        53.6537875
                    ],
                    [
                        9.7992087,
                        53.6540475
                    ],
                    [
                        9.7987737,
                        53.6543476
                    ],
                    [
                        9.7986452,
                        53.6544352
                    ],
                    [
                        9.7982693,
                        53.6546977
                    ],
                    [
                        9.7977251,
                        53.6550607
                    ],
                    [
                        9.79732,
                        53.6553369
                    ],
                    [
                        9.7970515,
                        53.6555199
                    ],
                    [
                        9.7963346,
                        53.6560086
                    ],
                    [
                        9.7960271,
                        53.6562142
                    ],
                    [
                        9.7955907,
                        53.6565101
                    ],
                    [
                        9.7954794,
                        53.6565863
                    ],
                    [
                        9.7951673,
                        53.6568002
                    ],
                    [
                        9.7942823,
                        53.6574111
                    ],
                    [
                        9.7940466,
                        53.6575762
                    ]
                ]
            }
        }
    ],
    "network": [
        {
            "networkId": "c878cb04-5f21-4d4e-895f-1f7d6c1b24af",
            "organisationsId": "d2c20cea-e6eb-43f3-9abb-db4f58ae4b81",
            "networkName": "1220 - Hamburg-Kiel",
            "networkIcon": null,
            "location": "",
            "mainCity": "",
            "country": "",
            "centerGeoPoint": {
                "type": "Point",
                "coordinates": [
                    10.06347656,
                    53.92213355
                ]
            },
            "active": 1,
            "defaultStartEdge": "65d0a8d5-925c-4264-9d14-04db1be3cc07",
            "lineMeterOnDefaultStartEdge": 0,
            "defaultEndEdge": "65d0a8d5-925c-4264-9d14-04db1be3cc07",
            "lineMeterOnDefaultEndEdge": 0,
            "timeStamp": "0001-01-01T00:00:00",
            "editorStepProcessed": 0,
            "edgeDataExist": false,
            "trackCount": 0
        }
    ]
}

export default hamburgNetwork